var jt = Object.defineProperty;
var Gt = (u, e, t) => e in u ? jt(u,
e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
}) : u[e] = t;
var mt = (u, e, t) => (Gt(u, typeof e !=
        "symbol" ? e + "" : e, t),
    t);
import {
    g as we,
    s as Wt,
    e as ze,
    a as ce,
    c as ge,
    b as Ie,
    d as je,
    f as nt,
    n as ot,
    h as Pe,
    m as W,
    i as Ut,
    j as wt,
    k as Re,
    l as xt,
    o as Je,
    p as Ft,
    q as Ne,
    r as ct,
    S as It,
    t as Qt,
    u as _e
} from "./g-atc-form.5be2ff54.chunk.js";

function Kt(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    t({
        virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate:
                !0,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let o;
    const h = we();
    e.virtual = {
        cache: {},
        from: void 0,
        to: void 0,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const w = h.createElement("div");

    function p(r, s) {
        const d = e.params.virtual;
        if (d.cache && e.virtual.cache[
                s]) return e.virtual
            .cache[s];
        let m;
        return d.renderSlide ? (m = d
                .renderSlide.call(e, r,
                    s), typeof m ==
                "string" && (ce(w, m),
                    m = w.children[0])
                ) : e.isElement ? m =
            ge("swiper-slide") : m = ge(
                "div", e.params
                .slideClass), m
            .setAttribute(
                "data-swiper-slide-index",
                s), d.renderSlide || ce(
                m, r), d.cache && (e
                .virtual.cache[s] = m),
            m
    }

    function f(r, s, d) {
        const {
            slidesPerView: m,
            slidesPerGroup: l,
            centeredSlides: c,
            loop: b,
            initialSlide: A
        } = e.params;
        if (s && !b && A > 0) return;
        const {
            addSlidesBefore: $,
            addSlidesAfter: I
        } = e.params.virtual, {
            from: q,
            to: E,
            slides: D,
            slidesGrid: O,
            offset: _
        } = e.virtual;
        e.params.cssMode || e
            .updateActiveIndex();
        const C = typeof d > "u" ? e
            .activeIndex || 0 : d;
        let T;
        e.rtlTranslate ? T = "right" :
            T = e.isHorizontal() ?
            "left" : "top";
        let z, R;
        c ? (z = Math.floor(m / 2) + l +
            I, R = Math.floor(m /
            2) + l + $) : (z = m + (
            l - 1) + I, R = (b ?
            m : l) + $);
        let S = C - R,
            x = C + z;
        b || (S = Math.max(S, 0), x =
            Math.min(x, D.length -
                1));
        let H = (e.slidesGrid[S] || 0) -
            (e.slidesGrid[0] || 0);
        b && C >= R ? (S -= R, c || (
                H += e.slidesGrid[0]
                )) : b && C < R && (
                S = -R, c && (H += e
                    .slidesGrid[0])),
            Object.assign(e.virtual, {
                from: S,
                to: x,
                offset: H,
                slidesGrid: e
                    .slidesGrid,
                slidesBefore: R,
                slidesAfter: z
            });

        function Y() {
            e.updateSlides(), e
                .updateProgress(), e
                .updateSlidesClasses(),
                a("virtualUpdate")
        }
        if (q === S && E === x && !r) {
            e.slidesGrid !== O && H !==
                _ && e.slides.forEach(
                    L => {
                        L.style[T] =
                            `${H-Math.abs(e.cssOverflowAdjustment())}px`
                    }), e
                .updateProgress(), a(
                    "virtualUpdate");
            return
        }
        if (e.params.virtual
            .renderExternal) {
            e.params.virtual
                .renderExternal.call(
                e, {
                    offset: H,
                    from: S,
                    to: x,
                    slides: function() {
                        const
                            k = [];
                        for (let G =
                                S; G <=
                            x; G +=
                            1) k
                            .push(
                                D[
                                    G]
                                );
                        return k
                    }()
                }), e.params.virtual
                .renderExternalUpdate ?
                Y() : a(
                "virtualUpdate");
            return
        }
        const K = [],
            Z = [],
            ne = L => {
                let k = L;
                return L < 0 ? k = D
                    .length + L : k >= D
                    .length && (k = k -
                        D.length), k
            };
        if (r) e.slides.filter(L => L
            .matches(
                `.${e.params.slideClass}, swiper-slide`
                )).forEach(L => {
            L.remove()
        });
        else
            for (let L = q; L <= E; L +=
                1)
                if (L < S || L > x) {
                    const k = ne(L);
                    e.slides.filter(G =>
                            G.matches(
                                `.${e.params.slideClass}[data-swiper-slide-index="${k}"], swiper-slide[data-swiper-slide-index="${k}"]`
                                ))
                        .forEach(G => {
                            G.remove()
                        })
                } const de = b ? -D
            .length : 0,
            P = b ? D.length * 2 : D
            .length;
        for (let L = de; L < P; L += 1)
            if (L >= S && L <= x) {
                const k = ne(L);
                typeof E > "u" || r ? Z
                    .push(k) : (L > E &&
                        Z.push(k), L <
                        q && K.push(k))
            } if (Z.forEach(L => {
                e.slidesEl.append(p(
                        D[L], L
                        ))
            }), b)
            for (let L = K.length -
                1; L >= 0; L -= 1) {
                const k = K[L];
                e.slidesEl.prepend(p(D[
                    k], k))
            } else K.sort((L, k) => k -
                L), K.forEach(L => {
                e.slidesEl
                    .prepend(p(
                        D[
                        L],
                        L))
            });
        ze(e.slidesEl,
            ".swiper-slide, swiper-slide"
            ).forEach(L => {
            L.style[T] =
                `${H-Math.abs(e.cssOverflowAdjustment())}px`
        }), Y()
    }

    function n(r) {
        if (typeof r == "object" &&
            "length" in r)
            for (let s = 0; s < r
                .length; s += 1) r[s] &&
                e.virtual.slides.push(r[
                    s]);
        else e.virtual.slides.push(r);
        f(!0)
    }

    function v(r) {
        const s = e.activeIndex;
        let d = s + 1,
            m = 1;
        if (Array.isArray(r)) {
            for (let l = 0; l < r
                .length; l += 1) r[l] &&
                e.virtual.slides
                .unshift(r[l]);
            d = s + r.length, m = r
                .length
        } else e.virtual.slides.unshift(
            r);
        if (e.params.virtual.cache) {
            const l = e.virtual.cache,
                c = {};
            Object.keys(l).forEach(
            b => {
                const A = l[b],
                    $ = A
                    .getAttribute(
                        "data-swiper-slide-index"
                        );
                $ && A
                    .setAttribute(
                        "data-swiper-slide-index",
                        parseInt(
                            $,
                            10
                            ) +
                        m), c[
                        parseInt(
                            b,
                            10
                            ) +
                        m] = A
            }), e.virtual.cache = c
        }
        f(!0), e.slideTo(d, 0)
    }

    function y(r) {
        if (typeof r > "u" || r ===
            null) return;
        let s = e.activeIndex;
        if (Array.isArray(r))
            for (let d = r.length -
                1; d >= 0; d -= 1) e
                .params.virtual.cache &&
                (delete e.virtual.cache[
                        r[d]], Object
                    .keys(e.virtual
                        .cache).forEach(
                        m => {
                            m > r && (e
                                .virtual
                                .cache[
                                    m -
                                    1
                                    ] =
                                e
                                .virtual
                                .cache[
                                    m
                                    ],
                                e
                                .virtual
                                .cache[
                                    m -
                                    1
                                    ]
                                .setAttribute(
                                    "data-swiper-slide-index",
                                    m -
                                    1
                                    ),
                                delete e
                                .virtual
                                .cache[
                                    m
                                    ]
                                )
                        })), e.virtual
                .slides.splice(r[d], 1),
                r[d] < s && (s -= 1),
                s = Math.max(s, 0);
        else e.params.virtual.cache && (
                delete e.virtual.cache[
                    r], Object.keys(e
                    .virtual.cache)
                .forEach(d => {
                    d > r && (e
                        .virtual
                        .cache[
                            d -
                            1] =
                        e
                        .virtual
                        .cache[
                            d],
                        e
                        .virtual
                        .cache[
                            d -
                            1]
                        .setAttribute(
                            "data-swiper-slide-index",
                            d -
                            1),
                        delete e
                        .virtual
                        .cache[
                            d])
                })), e.virtual.slides
            .splice(r, 1), r < s && (
                s -= 1), s = Math.max(s,
                0);
        f(!0), e.slideTo(s, 0)
    }

    function g() {
        e.virtual.slides = [], e.params
            .virtual.cache && (e.virtual
                .cache = {}), f(!0), e
            .slideTo(0, 0)
    }
    i("beforeInit", () => {
        if (!e.params.virtual
            .enabled) return;
        let r;
        if (typeof e
            .passedParams
            .virtual.slides >
            "u") {
            const s = [...e
                .slidesEl
                .children
            ].filter(d => d
                .matches(
                    `.${e.params.slideClass}, swiper-slide`
                    ));
            s && s.length && (e
                .virtual
                .slides = [
                    ...s
                ], r = !0, s
                .forEach((d,
                        m
                        ) => {
                        d.setAttribute(
                                "data-swiper-slide-index",
                                m
                                ),
                            e
                            .virtual
                            .cache[
                                m
                                ] =
                            d,
                            d
                            .remove()
                    }))
        }
        r || (e.virtual.slides =
                e.params.virtual
                .slides), e
            .classNames.push(
                `${e.params.containerModifierClass}virtual`
                ), e.params
            .watchSlidesProgress = !
            0, e.originalParams
            .watchSlidesProgress = !
            0, f(!1, !0)
    }), i("setTranslate", () => {
        e.params.virtual
            .enabled && (e
                .params
                .cssMode && !e
                ._immediateVirtual ?
                (clearTimeout(
                    o), o =
                    setTimeout(
                    () => {
                        f()
                    }, 100)) :
                f())
    }), i("init update resize",
    () => {
            e.params.virtual
                .enabled && e.params
                .cssMode && Wt(e
                    .wrapperEl,
                    "--swiper-virtual-size",
                    `${e.virtualSize}px`
                    )
        }), Object.assign(e
    .virtual, {
        appendSlide: n,
        prependSlide: v,
        removeSlide: y,
        removeAllSlides: g,
        update: f
    })
}

function Jt(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    const o = we(),
        h = Ie();
    e.keyboard = {
        enabled: !1
    }, t({
        keyboard: {
            enabled: !1,
            onlyInViewport: !0,
            pageUpDown: !0
        }
    });

    function w(n) {
        if (!e.enabled) return;
        const {
            rtlTranslate: v
        } = e;
        let y = n;
        y.originalEvent && (y = y
            .originalEvent);
        const g = y.keyCode || y
            .charCode,
            r = e.params.keyboard
            .pageUpDown,
            s = r && g === 33,
            d = r && g === 34,
            m = g === 37,
            l = g === 39,
            c = g === 38,
            b = g === 40;
        if (!e.allowSlideNext && (e
                .isHorizontal() && l ||
                e.isVertical() && b || d
                ) || !e
            .allowSlidePrev && (e
                .isHorizontal() && m ||
                e.isVertical() && c || s
                )) return !1;
        if (!(y.shiftKey || y.altKey ||
                y.ctrlKey || y.metaKey
                ) && !(o
                .activeElement && (o
                    .activeElement
                    .isContentEditable ||
                    o.activeElement
                    .nodeName && (o
                        .activeElement
                        .nodeName
                        .toLowerCase() ===
                        "input" || o
                        .activeElement
                        .nodeName
                        .toLowerCase() ===
                        "textarea")))) {
            if (e.params.keyboard
                .onlyInViewport && (s ||
                    d || m || l || c ||
                    b)) {
                let A = !1;
                if (je(e.el,
                        `.${e.params.slideClass}, swiper-slide`
                        ).length > 0 &&
                    je(e.el,
                        `.${e.params.slideActiveClass}`
                        ).length === 0)
                    return;
                const $ = e.el,
                    I = $.clientWidth,
                    q = $.clientHeight,
                    E = h.innerWidth,
                    D = h.innerHeight,
                    O = nt($);
                v && (O.left -= $
                    .scrollLeft);
                const _ = [
                    [O.left, O.top],
                    [O.left + I, O
                        .top
                    ],
                    [O.left, O.top +
                        q
                    ],
                    [O.left + I, O
                        .top + q
                    ]
                ];
                for (let C = 0; C < _
                    .length; C += 1) {
                    const T = _[C];
                    if (T[0] >= 0 && T[
                            0] <= E &&
                        T[1] >= 0 && T[
                            1] <= D) {
                        if (T[0] ===
                            0 && T[
                            1] === 0)
                            continue;
                        A = !0
                    }
                }
                if (!A) return
            }
            e.isHorizontal() ? ((s ||
                    d || m || l) &&
                (y.preventDefault ?
                    y
                    .preventDefault() :
                    y
                    .returnValue = !
                    1), ((d || l) &&
                    !v || (s ||
                    m) && v) && e
                .slideNext(), ((s ||
                        m) && !v ||
                    (d || l) && v
                    ) && e
                .slidePrev()) : ((
                    s || d || c || b
                    ) && (y
                    .preventDefault ?
                    y
                    .preventDefault() :
                    y
                    .returnValue = !
                    1), (d || b) &&
                e.slideNext(), (s ||
                    c) && e
                .slidePrev()), a(
                "keyPress", g)
        }
    }

    function p() {
        e.keyboard.enabled || (o
            .addEventListener(
                "keydown", w), e
            .keyboard.enabled = !0)
    }

    function f() {
        e.keyboard.enabled && (o
            .removeEventListener(
                "keydown", w), e
            .keyboard.enabled = !1)
    }
    i("init", () => {
        e.params.keyboard
            .enabled && p()
    }), i("destroy", () => {
        e.keyboard.enabled &&
        f()
    }), Object.assign(e.keyboard, {
        enable: p,
        disable: f
    })
}

function Zt(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    const o = Ie();
    t({
        mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    }), e.mousewheel = {
        enabled: !1
    };
    let h, w = Pe(),
        p;
    const f = [];

    function n(c) {
        let I = 0,
            q = 0,
            E = 0,
            D = 0;
        return "detail" in c && (q = c
                .detail),
            "wheelDelta" in c && (q = -c
                .wheelDelta / 120),
            "wheelDeltaY" in c && (q = -
                c.wheelDeltaY / 120),
            "wheelDeltaX" in c && (I = -
                c.wheelDeltaX / 120),
            "axis" in c && c.axis === c
            .HORIZONTAL_AXIS && (I = q,
                q = 0), E = I * 10, D =
            q * 10, "deltaY" in c && (
                D = c.deltaY),
            "deltaX" in c && (E = c
                .deltaX), c.shiftKey &&
            !E && (E = D, D = 0), (E ||
                D) && c.deltaMode && (c
                .deltaMode === 1 ? (E *=
                    40, D *= 40) : (E *=
                    800, D *= 800)),
            E && !I && (I = E < 1 ? -1 :
                1), D && !q && (q = D <
                1 ? -1 : 1), {
                spinX: I,
                spinY: q,
                pixelX: E,
                pixelY: D
            }
    }

    function v() {
        e.enabled && (e.mouseEntered = !
            0)
    }

    function y() {
        e.enabled && (e.mouseEntered = !
            1)
    }

    function g(c) {
        return e.params.mousewheel
            .thresholdDelta && c.delta <
            e.params.mousewheel
            .thresholdDelta || e.params
            .mousewheel.thresholdTime &&
            Pe() - w < e.params
            .mousewheel.thresholdTime ?
            !1 : c.delta >= 6 && Pe() -
            w < 60 ? !0 : (c.direction <
                0 ? (!e.isEnd || e
                    .params.loop) && !e
                .animating && (e
                    .slideNext(), a(
                        "scroll", c.raw)
                    ) : (!e
                    .isBeginning || e
                    .params.loop) && !e
                .animating && (e
                    .slidePrev(), a(
                        "scroll", c.raw)
                    ), w = new o.Date()
                .getTime(), !1)
    }

    function r(c) {
        const b = e.params.mousewheel;
        if (c.direction < 0) {
            if (e.isEnd && !e.params
                .loop && b
                .releaseOnEdges)
            return !0
        } else if (e.isBeginning && !e
            .params.loop && b
            .releaseOnEdges) return !0;
        return !1
    }

    function s(c) {
        let b = c,
            A = !0;
        if (!e.enabled || c.target
            .closest(
                `.${e.params.mousewheel.noMousewheelClass}`
                )) return;
        const $ = e.params.mousewheel;
        e.params.cssMode && b
            .preventDefault();
        let I = e.el;
        e.params.mousewheel
            .eventsTarget !==
            "container" && (I = document
                .querySelector(e.params
                    .mousewheel
                    .eventsTarget));
        const q = I && I.contains(b
            .target);
        if (!e.mouseEntered && !q && !$
            .releaseOnEdges) return !0;
        b.originalEvent && (b = b
            .originalEvent);
        let E = 0;
        const D = e.rtlTranslate ? -1 :
            1,
            O = n(b);
        if ($.forceToAxis)
            if (e.isHorizontal())
                if (Math.abs(O.pixelX) >
                    Math.abs(O.pixelY))
                    E = -O.pixelX * D;
                else return !0;
        else if (Math.abs(O.pixelY) >
            Math.abs(O.pixelX)) E = -O
            .pixelY;
        else return !0;
        else E = Math.abs(O.pixelX) >
            Math.abs(O.pixelY) ? -O
            .pixelX * D : -O.pixelY;
        if (E === 0) return !0;
        $.invert && (E = -E);
        let _ = e.getTranslate() + E * $
            .sensitivity;
        if (_ >= e.minTranslate() && (
                _ = e.minTranslate()),
            _ <= e.maxTranslate() && (
                _ = e.maxTranslate()),
            A = e.params.loop ? !0 : !(
                _ === e
            .minTranslate() || _ === e
                .maxTranslate()), A && e
            .params.nested && b
            .stopPropagation(), !e
            .params.freeMode || !e
            .params.freeMode.enabled) {
            const C = {
                time: Pe(),
                delta: Math.abs(E),
                direction: Math
                    .sign(E),
                raw: c
            };
            f.length >= 2 && f.shift();
            const T = f.length ? f[f
                    .length - 1] :
                void 0;
            if (f.push(C), T ? (C
                    .direction !== T
                    .direction || C
                    .delta > T.delta ||
                    C.time > T.time +
                    150) && g(C) : g(C),
                r(C)) return !0
        } else {
            const C = {
                    time: Pe(),
                    delta: Math.abs(E),
                    direction: Math
                        .sign(E)
                },
                T = p && C.time < p
                .time + 500 && C
                .delta <= p.delta && C
                .direction === p
                .direction;
            if (!T) {
                p = void 0;
                let z = e
                .getTranslate() + E * $
                    .sensitivity;
                const R = e.isBeginning,
                    S = e.isEnd;
                if (z >= e
                    .minTranslate() && (
                        z = e
                        .minTranslate()
                        ), z <= e
                    .maxTranslate() && (
                        z = e
                        .maxTranslate()
                        ), e
                    .setTransition(0), e
                    .setTranslate(z), e
                    .updateProgress(), e
                    .updateActiveIndex(),
                    e
                    .updateSlidesClasses(),
                    (!R && e
                        .isBeginning ||
                        !S && e.isEnd
                        ) && e
                    .updateSlidesClasses(),
                    e.params.loop && e
                    .loopFix({
                        direction: C
                            .direction <
                            0 ?
                            "next" :
                            "prev",
                        byMousewheel:
                            !0
                    }), e.params
                    .freeMode.sticky) {
                    clearTimeout(h), h =
                        void 0, f
                        .length >= 15 &&
                        f.shift();
                    const x = f.length ?
                        f[f.length -
                        1] : void 0,
                        H = f[0];
                    if (f.push(C), x &&
                        (C.delta > x
                            .delta || C
                            .direction !==
                            x.direction)
                        ) f.splice(0);
                    else if (f.length >=
                        15 && C.time - H
                        .time < 500 && H
                        .delta - C
                        .delta >= 1 && C
                        .delta <= 6) {
                        const Y = E >
                            0 ? .8 : .2;
                        p = C, f.splice(
                                0), h =
                            ot(() => {
                                e.destroyed ||
                                    !
                                    e
                                    .params ||
                                    e
                                    .slideToClosest(
                                        e
                                        .params
                                        .speed,
                                        !
                                        0,
                                        void 0,
                                        Y
                                        )
                            }, 0)
                    }
                    h || (h = ot(() => {
                        if (e
                            .destroyed ||
                            !
                            e
                            .params
                            )
                            return;
                        const
                            Y =
                            .5;
                        p = C,
                            f
                            .splice(
                                0
                                ),
                            e
                            .slideToClosest(
                                e
                                .params
                                .speed,
                                !
                                0,
                                void 0,
                                Y
                                )
                    }, 500))
                }
                if (T || a("scroll", b),
                    e.params.autoplay &&
                    e.params.autoplay
                    .disableOnInteraction &&
                    e.autoplay.stop(), $
                    .releaseOnEdges && (
                        z === e
                        .minTranslate() ||
                        z === e
                        .maxTranslate())
                    ) return !0
            }
        }
        return b.preventDefault ? b
            .preventDefault() : b
            .returnValue = !1, !1
    }

    function d(c) {
        let b = e.el;
        e.params.mousewheel
            .eventsTarget !==
            "container" && (b = document
                .querySelector(e.params
                    .mousewheel
                    .eventsTarget)), b[
                c]("mouseenter", v), b[
                c]("mouseleave", y), b[
                c]("wheel", s)
    }

    function m() {
        return e.params.cssMode ? (e
                .wrapperEl
                .removeEventListener(
                    "wheel", s), !0) : e
            .mousewheel.enabled ? !1 : (
                d("addEventListener"), e
                .mousewheel.enabled = !
                0, !0)
    }

    function l() {
        return e.params.cssMode ? (e
                .wrapperEl
                .addEventListener(event,
                    s), !0) : e
            .mousewheel.enabled ? (d(
                    "removeEventListener"
                    ), e.mousewheel
                .enabled = !1, !0) : !1
    }
    i("init", () => {
        !e.params.mousewheel
            .enabled && e.params
            .cssMode && l(), e
            .params.mousewheel
            .enabled && m()
    }), i("destroy", () => {
        e.params.cssMode && m(),
            e.mousewheel
            .enabled && l()
    }), Object.assign(e
    .mousewheel, {
        enable: m,
        disable: l
    })
}

function bt(u, e, t, i) {
    return u.params.createElements &&
        Object.keys(i).forEach(a => {
            if (!t[a] && t.auto ===
                !0) {
                let o = ze(u.el,
                    `.${i[a]}`)[
                    0];
                o || (o = ge("div",
                            i[a]), o
                        .className =
                        i[a], u.el
                        .append(o)),
                    t[a] = o, e[a] =
                    o
            }
        }), t
}

function ei(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    t({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    }), e.navigation = {
        nextEl: null,
        prevEl: null
    };

    function o(r) {
        let s;
        return r && typeof r ==
            "string" && e.isElement && (
                s = e.el.querySelector(
                    r) || e.hostEl
                .querySelector(r), s) ?
            s : (r && (typeof r ==
                    "string" && (s = [
                        ...document
                        .querySelectorAll(
                            r)
                    ]), e.params
                    .uniqueNavElements &&
                    typeof r ==
                    "string" && s && s
                    .length > 1 && e.el
                    .querySelectorAll(r)
                    .length === 1 ? s =
                    e.el.querySelector(
                        r) : s && s
                    .length === 1 && (
                        s = s[0])), r &&
                !s ? r : s)
    }

    function h(r, s) {
        const d = e.params.navigation;
        r = W(r), r.forEach(m => {
            m && (m.classList[
                    s ?
                    "add" :
                    "remove"
                    ](...d
                    .disabledClass
                    .split(
                        " ")
                    ), m
                .tagName ===
                "BUTTON" &&
                (m.disabled =
                    s), e
                .params
                .watchOverflow &&
                e.enabled &&
                m.classList[
                    e
                    .isLocked ?
                    "add" :
                    "remove"
                    ](d
                    .lockClass
                    ))
        })
    }

    function w() {
        const {
            nextEl: r,
            prevEl: s
        } = e.navigation;
        if (e.params.loop) {
            h(s, !1), h(r, !1);
            return
        }
        h(s, e.isBeginning && !e.params
            .rewind), h(r, e
            .isEnd && !e.params
            .rewind)
    }

    function p(r) {
        r.preventDefault(), !(e
            .isBeginning && !e
            .params.loop && !e
            .params.rewind) && (e
            .slidePrev(), a(
                "navigationPrev"))
    }

    function f(r) {
        r.preventDefault(), !(e.isEnd &&
            !e.params.loop && !e
            .params.rewind) && (e
            .slideNext(), a(
                "navigationNext"))
    }

    function n() {
        const r = e.params.navigation;
        if (e.params.navigation = bt(e,
                e.originalParams
                .navigation, e.params
                .navigation, {
                    nextEl: "swiper-button-next",
                    prevEl: "swiper-button-prev"
                }), !(r.nextEl || r
                .prevEl)) return;
        let s = o(r.nextEl),
            d = o(r.prevEl);
        Object.assign(e.navigation, {
            nextEl: s,
            prevEl: d
        }), s = W(s), d = W(d);
        const m = (l, c) => {
            l && l.addEventListener(
                    "click", c ===
                    "next" ? f : p),
                !e.enabled && l && l
                .classList.add(...r
                    .lockClass
                    .split(" "))
        };
        s.forEach(l => m(l, "next")), d
            .forEach(l => m(l, "prev"))
    }

    function v() {
        let {
            nextEl: r,
            prevEl: s
        } = e.navigation;
        r = W(r), s = W(s);
        const d = (m, l) => {
            m.removeEventListener(
                    "click", l ===
                    "next" ? f : p),
                m.classList.remove(
                    ...e.params
                    .navigation
                    .disabledClass
                    .split(" "))
        };
        r.forEach(m => d(m, "next")), s
            .forEach(m => d(m, "prev"))
    }
    i("init", () => {
        e.params.navigation
            .enabled === !1 ?
            g() : (n(), w())
    }), i(
        "toEdge fromEdge lock unlock",
        () => {
            w()
        }), i("destroy", () => {
        v()
    }), i("enable disable", () => {
        let {
            nextEl: r,
            prevEl: s
        } = e.navigation;
        if (r = W(r), s = W(s),
            e.enabled) {
            w();
            return
        } [...r, ...s].filter(
                d => !!d)
            .forEach(d => d
                .classList.add(e
                    .params
                    .navigation
                    .lockClass))
    }), i("click", (r, s) => {
        let {
            nextEl: d,
            prevEl: m
        } = e.navigation;
        d = W(d), m = W(m);
        const l = s.target;
        let c = m.includes(l) ||
            d.includes(l);
        if (e.isElement && !c) {
            const b = s.path ||
                s
                .composedPath &&
                s
            .composedPath();
            b && (c = b.find(
                A => d
                .includes(
                    A
                    ) ||
                m
                .includes(
                    A)))
        }
        if (e.params.navigation
            .hideOnClick && !c
            ) {
            if (e.pagination &&
                e.params
                .pagination && e
                .params
                .pagination
                .clickable && (e
                    .pagination
                    .el === l ||
                    e.pagination
                    .el
                    .contains(l)
                    )) return;
            let b;
            d.length ? b = d[0]
                .classList
                .contains(e
                    .params
                    .navigation
                    .hiddenClass
                    ) : m
                .length && (b =
                    m[0]
                    .classList
                    .contains(e
                        .params
                        .navigation
                        .hiddenClass
                        )), a(
                    b === !0 ?
                    "navigationShow" :
                    "navigationHide"
                    ), [...d,
                    ...m
                ].filter(A => !!
                    A).forEach(
                    A => A
                    .classList
                    .toggle(e
                        .params
                        .navigation
                        .hiddenClass
                        ))
        }
    });
    const y = () => {
            e.el.classList.remove(...e
                    .params.navigation
                    .navigationDisabledClass
                    .split(" ")), n(),
                w()
        },
        g = () => {
            e.el.classList.add(...e
                .params.navigation
                .navigationDisabledClass
                .split(" ")), v()
        };
    Object.assign(e.navigation, {
        enable: y,
        disable: g,
        update: w,
        init: n,
        destroy: v
    })
}

function Ee(u) {
    return u === void 0 && (u = ""),
        `.${u.trim().replace(/([\.:!+\/()[\]])/g,"\\$1").replace(/ /g,".")}`
}

function ti(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    const o = "swiper-pagination";
    t({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite:
                !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: l =>
                l,
            formatFractionTotal: l =>
                l,
            bulletClass: `${o}-bullet`,
            bulletActiveClass: `${o}-bullet-active`,
            modifierClass: `${o}-`,
            currentClass: `${o}-current`,
            totalClass: `${o}-total`,
            hiddenClass: `${o}-hidden`,
            progressbarFillClass: `${o}-progressbar-fill`,
            progressbarOppositeClass: `${o}-progressbar-opposite`,
            clickableClass: `${o}-clickable`,
            lockClass: `${o}-lock`,
            horizontalClass: `${o}-horizontal`,
            verticalClass: `${o}-vertical`,
            paginationDisabledClass: `${o}-disabled`
        }
    }), e.pagination = {
        el: null,
        bullets: []
    };
    let h, w = 0;

    function p() {
        return !e.params.pagination
            .el || !e.pagination.el ||
            Array.isArray(e.pagination
                .el) && e.pagination.el
            .length === 0
    }

    function f(l, c) {
        const {
            bulletActiveClass: b
        } = e.params.pagination;
        l && (l = l[
                `${c==="prev"?"previous":"next"}ElementSibling`],
            l && (l.classList.add(
                    `${b}-${c}`),
                l = l[
                    `${c==="prev"?"previous":"next"}ElementSibling`
                    ], l && l
                .classList.add(
                    `${b}-${c}-${c}`
                    )))
    }

    function n(l, c, b) {
        if (l = l % b, c = c % b, c ===
            l + 1) return "next";
        if (c === l - 1)
        return "previous"
    }

    function v(l) {
        const c = l.target.closest(Ee(e
            .params.pagination
            .bulletClass));
        if (!c) return;
        l.preventDefault();
        const b = wt(c) * e.params
            .slidesPerGroup;
        if (e.params.loop) {
            if (e.realIndex === b)
                return;
            const A = n(e.realIndex, b,
                e.slides.length);
            A === "next" ? e
            .slideNext() : A ===
                "previous" ? e
                .slidePrev() : e
                .slideToLoop(b)
        } else e.slideTo(b)
    }

    function y() {
        const l = e.rtl,
            c = e.params.pagination;
        if (p()) return;
        let b = e.pagination.el;
        b = W(b);
        let A, $;
        const I = e.virtual && e.params
            .virtual.enabled ? e.virtual
            .slides.length : e.slides
            .length,
            q = e.params.loop ? Math
            .ceil(I / e.params
                .slidesPerGroup) : e
            .snapGrid.length;
        if (e.params.loop ? ($ = e
                .previousRealIndex || 0,
                A = e.params
                .slidesPerGroup > 1 ?
                Math.floor(e.realIndex /
                    e.params
                    .slidesPerGroup) : e
                .realIndex) : typeof e
            .snapIndex < "u" ? (A = e
                .snapIndex, $ = e
                .previousSnapIndex) : (
                $ = e.previousIndex ||
                0, A = e.activeIndex ||
                0), c.type ===
            "bullets" && e.pagination
            .bullets && e.pagination
            .bullets.length > 0) {
            const E = e.pagination
                .bullets;
            let D, O, _;
            if (c.dynamicBullets && (h =
                    Ut(E[0], e
                        .isHorizontal() ?
                        "width" :
                        "height", !0), b
                    .forEach(C => {
                        C.style[e
                                .isHorizontal() ?
                                "width" :
                                "height"
                                ] =
                            `${h*(c.dynamicMainBullets+4)}px`
                    }), c
                    .dynamicMainBullets >
                    1 && $ !== void 0 &&
                    (w += A - ($ || 0),
                        w > c
                        .dynamicMainBullets -
                        1 ? w = c
                        .dynamicMainBullets -
                        1 : w < 0 && (
                            w = 0)), D =
                    Math.max(A - w, 0),
                    O = D + (Math.min(E
                        .length, c
                        .dynamicMainBullets
                        ) - 1), _ = (O +
                        D) / 2), E
                .forEach(C => {
                    const T = [...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map(
                        z =>
                        `${c.bulletActiveClass}${z}`
                        )].map(
                        z =>
                        typeof z ==
                        "string" &&
                        z
                        .includes(
                            " "
                            ) ?
                        z.split(
                            " "
                            ) :
                        z)
                    .flat();
                    C.classList
                        .remove(...
                            T)
                }), b.length > 1) E
                .forEach(C => {
                    const T = wt(C);
                    T === A ? C
                        .classList
                        .add(...c
                            .bulletActiveClass
                            .split(
                                " ")
                            ) : e
                        .isElement &&
                        C
                        .setAttribute(
                            "part",
                            "bullet"
                            ), c
                        .dynamicBullets &&
                        (T >= D &&
                            T <=
                            O && C
                            .classList
                            .add(...
                                `${c.bulletActiveClass}-main`
                                .split(
                                    " "
                                    )
                                ),
                            T ===
                            D && f(
                                C,
                                "prev"
                                ),
                            T ===
                            O && f(
                                C,
                                "next"
                                ))
                });
            else {
                const C = E[A];
                if (C && C.classList
                    .add(...c
                        .bulletActiveClass
                        .split(" ")), e
                    .isElement && E
                    .forEach((T, z) => {
                        T.setAttribute(
                            "part",
                            z ===
                            A ?
                            "bullet-active" :
                            "bullet"
                            )
                    }), c.dynamicBullets
                    ) {
                    const T = E[D],
                        z = E[O];
                    for (let R = D; R <=
                        O; R += 1) E[
                        R] && E[R]
                        .classList.add(
                            ...
                            `${c.bulletActiveClass}-main`
                            .split(" ")
                            );
                    f(T, "prev"), f(z,
                        "next")
                }
            }
            if (c.dynamicBullets) {
                const C = Math.min(E
                        .length, c
                        .dynamicMainBullets +
                        4),
                    T = (h * C - h) /
                    2 - _ * h,
                    z = l ? "right" :
                    "left";
                E.forEach(R => {
                    R.style[e
                            .isHorizontal() ?
                            z :
                            "top"
                            ] =
                        `${T}px`
                })
            }
        }
        b.forEach((E, D) => {
            if (c.type ===
                "fraction" && (E
                    .querySelectorAll(
                        Ee(c
                            .currentClass)
                        )
                    .forEach(
                        O => {
                            O.textContent =
                                c
                                .formatFractionCurrent(
                                    A +
                                    1
                                    )
                        }), E
                    .querySelectorAll(
                        Ee(c
                            .totalClass)
                        )
                    .forEach(
                        O => {
                            O.textContent =
                                c
                                .formatFractionTotal(
                                    q
                                    )
                        })), c
                .type ===
                "progressbar") {
                let O;
                c.progressbarOpposite ?
                    O = e
                    .isHorizontal() ?
                    "vertical" :
                    "horizontal" :
                    O = e
                    .isHorizontal() ?
                    "horizontal" :
                    "vertical";
                const _ = (A +
                    1) / q;
                let C = 1,
                    T = 1;
                O ===
                    "horizontal" ?
                    C = _ : T =
                    _, E
                    .querySelectorAll(
                        Ee(c
                            .progressbarFillClass)
                        )
                    .forEach(
                        z => {
                            z.style
                                .transform =
                                `translate3d(0,0,0) scaleX(${C}) scaleY(${T})`,
                                z
                                .style
                                .transitionDuration =
                                `${e.params.speed}ms`
                        })
            }
            c.type ===
                "custom" && c
                .renderCustom ?
                (ce(E, c.renderCustom(
                        e,
                        A +
                        1, q
                        )),
                    D === 0 &&
                    a("paginationRender",
                        E)) : (
                    D === 0 &&
                    a("paginationRender",
                        E), a(
                        "paginationUpdate",
                        E)), e
                .params
                .watchOverflow &&
                e.enabled && E
                .classList[e
                    .isLocked ?
                    "add" :
                    "remove"](c
                    .lockClass)
        })
    }

    function g() {
        const l = e.params.pagination;
        if (p()) return;
        const c = e.virtual && e.params
            .virtual.enabled ? e.virtual
            .slides.length : e.grid && e
            .params.grid.rows > 1 ? e
            .slides.length / Math.ceil(e
                .params.grid.rows) : e
            .slides.length;
        let b = e.pagination.el;
        b = W(b);
        let A = "";
        if (l.type === "bullets") {
            let $ = e.params.loop ? Math
                .ceil(c / e.params
                    .slidesPerGroup) : e
                .snapGrid.length;
            e.params.freeMode && e
                .params.freeMode
                .enabled && $ > c && (
                    $ = c);
            for (let I = 0; I < $; I +=
                1) l.renderBullet ? A +=
                l.renderBullet.call(e,
                    I, l.bulletClass) :
                A +=
                `<${l.bulletElement} ${e.isElement?'part="bullet"':""} class="${l.bulletClass}"></${l.bulletElement}>`
        }
        l.type === "fraction" && (l
                .renderFraction ? A = l
                .renderFraction.call(e,
                    l.currentClass, l
                    .totalClass) : A =
                `<span class="${l.currentClass}"></span> / <span class="${l.totalClass}"></span>`
                ), l.type ===
            "progressbar" && (l
                .renderProgressbar ? A =
                l.renderProgressbar
                .call(e, l
                    .progressbarFillClass
                    ) : A =
                `<span class="${l.progressbarFillClass}"></span>`
                ), e.pagination
            .bullets = [], b.forEach(
                $ => {
                    l.type !==
                        "custom" && ce(
                            $, A || ""),
                        l.type ===
                        "bullets" && e
                        .pagination
                        .bullets.push(
                            ...$
                            .querySelectorAll(
                                Ee(l
                                    .bulletClass)
                                ))
                }), l.type !==
            "custom" && a(
                "paginationRender", b[0]
                )
    }

    function r() {
        e.params.pagination = bt(e, e
            .originalParams
            .pagination, e.params
            .pagination, {
                el: "swiper-pagination"
            });
        const l = e.params.pagination;
        if (!l.el) return;
        let c;
        typeof l.el == "string" && e
            .isElement && (c = e.el
                .querySelector(l.el)), !
            c && typeof l.el ==
            "string" && (c = [...
                document
                .querySelectorAll(l
                    .el)
            ]), c || (c = l.el), !(!c ||
                c.length === 0) && (e
                .params
                .uniqueNavElements &&
                typeof l.el ==
                "string" && Array
                .isArray(c) && c
                .length > 1 && (c = [...
                    e.el
                    .querySelectorAll(
                        l.el)
                ], c.length > 1 && (
                    c = c.find(b =>
                        je(b,
                            ".swiper"
                            )[0] ===
                        e.el))), Array
                .isArray(c) && c
                .length === 1 && (c = c[
                    0]), Object.assign(e
                    .pagination, {
                        el: c
                    }), c = W(c), c
                .forEach(b => {
                    l.type ===
                        "bullets" &&
                        l
                        .clickable &&
                        b.classList
                        .add(...(l
                                .clickableClass ||
                                "")
                            .split(
                                " ")
                            ), b
                        .classList
                        .add(l
                            .modifierClass +
                            l.type),
                        b.classList
                        .add(e
                            .isHorizontal() ?
                            l
                            .horizontalClass :
                            l
                            .verticalClass
                            ), l
                        .type ===
                        "bullets" &&
                        l
                        .dynamicBullets &&
                        (b.classList
                            .add(
                                `${l.modifierClass}${l.type}-dynamic`
                                ),
                            w = 0, l
                            .dynamicMainBullets <
                            1 && (l
                                .dynamicMainBullets =
                                1)),
                        l.type ===
                        "progressbar" &&
                        l
                        .progressbarOpposite &&
                        b.classList
                        .add(l
                            .progressbarOppositeClass
                            ), l
                        .clickable &&
                        b
                        .addEventListener(
                            "click",
                            v), e
                        .enabled ||
                        b.classList
                        .add(l
                            .lockClass
                            )
                }))
    }

    function s() {
        const l = e.params.pagination;
        if (p()) return;
        let c = e.pagination.el;
        c && (c = W(c), c.forEach(b => {
                b.classList
                    .remove(l
                        .hiddenClass
                        ), b
                    .classList
                    .remove(l
                        .modifierClass +
                        l.type),
                    b.classList
                    .remove(e
                        .isHorizontal() ?
                        l
                        .horizontalClass :
                        l
                        .verticalClass
                        ), l
                    .clickable &&
                    (b.classList
                        .remove(
                            ...(l
                                .clickableClass ||
                                ""
                                )
                            .split(
                                " "
                                )
                            ), b
                        .removeEventListener(
                            "click",
                            v))
            })), e.pagination.bullets &&
            e.pagination.bullets
            .forEach(b => b.classList
                .remove(...l
                    .bulletActiveClass
                    .split(" ")))
    }
    i("changeDirection", () => {
        if (!e.pagination || !e
            .pagination.el)
            return;
        const l = e.params
            .pagination;
        let {
            el: c
        } = e.pagination;
        c = W(c), c.forEach(
        b => {
            b.classList
                .remove(
                    l
                    .horizontalClass,
                    l
                    .verticalClass
                    ), b
                .classList
                .add(e
                    .isHorizontal() ?
                    l
                    .horizontalClass :
                    l
                    .verticalClass
                    )
        })
    }), i("init", () => {
        e.params.pagination
            .enabled === !1 ?
            m() : (r(), g(),
            y())
    }), i("activeIndexChange",
() => {
        typeof e.snapIndex >
            "u" && y()
    }), i("snapIndexChange", () => {
        y()
    }), i("snapGridLengthChange",
    () => {
            g(), y()
        }), i("destroy", () => {
        s()
    }), i("enable disable", () => {
        let {
            el: l
        } = e.pagination;
        l && (l = W(l), l
            .forEach(c => c
                .classList[e
                    .enabled ?
                    "remove" :
                    "add"](e
                    .params
                    .pagination
                    .lockClass
                    )))
    }), i("lock unlock", () => {
        y()
    }), i("click", (l, c) => {
        const b = c.target,
            A = W(e.pagination
                .el);
        if (e.params.pagination
            .el && e.params
            .pagination
            .hideOnClick && A &&
            A.length > 0 && !b
            .classList.contains(
                e.params
                .pagination
                .bulletClass)) {
            if (e.navigation &&
                (e.navigation
                    .nextEl &&
                    b === e
                    .navigation
                    .nextEl || e
                    .navigation
                    .prevEl &&
                    b === e
                    .navigation
                    .prevEl))
                return;
            const $ = A[0]
                .classList
                .contains(e
                    .params
                    .pagination
                    .hiddenClass
                    );
            a($ === !0 ?
                    "paginationShow" :
                    "paginationHide"
                    ), A
                .forEach(I => I
                    .classList
                    .toggle(e
                        .params
                        .pagination
                        .hiddenClass
                        ))
        }
    });
    const d = () => {
            e.el.classList.remove(e
                .params.pagination
                .paginationDisabledClass
                );
            let {
                el: l
            } = e.pagination;
            l && (l = W(l), l.forEach(
                    c => c.classList
                    .remove(e.params
                        .pagination
                        .paginationDisabledClass
                        ))), r(), g(),
                y()
        },
        m = () => {
            e.el.classList.add(e.params
                .pagination
                .paginationDisabledClass
                );
            let {
                el: l
            } = e.pagination;
            l && (l = W(l), l.forEach(
                c => c.classList
                .add(e.params
                    .pagination
                    .paginationDisabledClass
                    ))), s()
        };
    Object.assign(e.pagination, {
        enable: d,
        disable: m,
        render: g,
        update: y,
        init: r,
        destroy: s
    })
}

function ii(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    const o = we();
    let h = !1,
        w = null,
        p = null,
        f, n, v, y;
    t({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    }), e.scrollbar = {
        el: null,
        dragEl: null
    };

    function g() {
        if (!e.params.scrollbar.el || !e
            .scrollbar.el) return;
        const {
            scrollbar: _,
            rtlTranslate: C
        } = e, {
            dragEl: T,
            el: z
        } = _, R = e.params.scrollbar,
            S = e.params.loop ? e
            .progressLoop : e.progress;
        let x = n,
            H = (v - n) * S;
        C ? (H = -H, H > 0 ? (x = n - H,
                    H = 0) : -H + n >
                v && (x = v + H)) : H <
            0 ? (x = n + H, H = 0) : H +
            n > v && (x = v - H), e
            .isHorizontal() ? (T.style
                .transform =
                `translate3d(${H}px, 0, 0)`,
                T.style.width = `${x}px`
                ) : (T.style.transform =
                `translate3d(0px, ${H}px, 0)`,
                T.style.height =
                `${x}px`), R.hide && (
                clearTimeout(w), z.style
                .opacity = 1, w =
                setTimeout(() => {
                    z.style
                        .opacity =
                        0, z.style
                        .transitionDuration =
                        "400ms"
                }, 1e3))
    }

    function r(_) {
        !e.params.scrollbar.el || !e
            .scrollbar.el || (e
                .scrollbar.dragEl.style
                .transitionDuration =
                `${_}ms`)
    }

    function s() {
        if (!e.params.scrollbar.el || !e
            .scrollbar.el) return;
        const {
            scrollbar: _
        } = e, {
            dragEl: C,
            el: T
        } = _;
        C.style.width = "", C.style
            .height = "", v = e
            .isHorizontal() ? T
            .offsetWidth : T
            .offsetHeight, y = e.size /
            (e.virtualSize + e.params
                .slidesOffsetBefore - (e
                    .params
                    .centeredSlides ? e
                    .snapGrid[0] : 0)),
            e.params.scrollbar
            .dragSize === "auto" ? n =
            v * y : n = parseInt(e
                .params.scrollbar
                .dragSize, 10), e
            .isHorizontal() ? C.style
            .width = `${n}px` : C.style
            .height = `${n}px`, y >= 1 ?
            T.style.display = "none" : T
            .style.display = "", e
            .params.scrollbar.hide && (T
                .style.opacity = 0), e
            .params.watchOverflow && e
            .enabled && _.el.classList[e
                .isLocked ? "add" :
                "remove"](e.params
                .scrollbar.lockClass)
    }

    function d(_) {
        return e.isHorizontal() ? _
            .clientX : _.clientY
    }

    function m(_) {
        const {
            scrollbar: C,
            rtlTranslate: T
        } = e, {
            el: z
        } = C;
        let R;
        R = (d(_) - nt(z)[e
                .isHorizontal() ?
                "left" : "top"] - (
                f !== null ? f : n /
                2)) / (v - n), R = Math
            .max(Math.min(R, 1), 0),
            T && (R = 1 - R);
        const S = e.minTranslate() + (e
            .maxTranslate() - e
            .minTranslate()) * R;
        e.updateProgress(S), e
            .setTranslate(S), e
            .updateActiveIndex(), e
            .updateSlidesClasses()
    }

    function l(_) {
        const C = e.params.scrollbar,
            {
                scrollbar: T,
                wrapperEl: z
            } = e,
            {
                el: R,
                dragEl: S
            } = T;
        h = !0, f = _.target === S ? d(
                _) - _.target
            .getBoundingClientRect()[e
                .isHorizontal() ?
                "left" : "top"] : null,
            _.preventDefault(), _
            .stopPropagation(), z.style
            .transitionDuration =
            "100ms", S.style
            .transitionDuration =
            "100ms", m(_), clearTimeout(
                p), R.style
            .transitionDuration = "0ms",
            C.hide && (R.style.opacity =
                1), e.params.cssMode &&
            (e.wrapperEl.style[
                    "scroll-snap-type"
                    ] = "none"), a(
                "scrollbarDragStart", _)
    }

    function c(_) {
        const {
            scrollbar: C,
            wrapperEl: T
        } = e, {
            el: z,
            dragEl: R
        } = C;
        h && (_.preventDefault && _
            .cancelable ? _
            .preventDefault() : _
            .returnValue = !1, m(_),
            T.style
            .transitionDuration =
            "0ms", z.style
            .transitionDuration =
            "0ms", R.style
            .transitionDuration =
            "0ms", a(
                "scrollbarDragMove",
                _))
    }

    function b(_) {
        const C = e.params.scrollbar,
            {
                scrollbar: T,
                wrapperEl: z
            } = e,
            {
                el: R
            } = T;
        h && (h = !1, e.params
            .cssMode && (e.wrapperEl
                .style[
                    "scroll-snap-type"
                    ] = "", z.style
                .transitionDuration =
                ""), C.hide && (
                clearTimeout(p), p =
                ot(() => {
                    R.style
                        .opacity =
                        0, R
                        .style
                        .transitionDuration =
                        "400ms"
                }, 1e3)), a(
                "scrollbarDragEnd",
                _), C
            .snapOnRelease && e
            .slideToClosest())
    }

    function A(_) {
        const {
            scrollbar: C,
            params: T
        } = e, z = C.el;
        if (!z) return;
        const R = z,
            S = T.passiveListeners ? {
                passive: !1,
                capture: !1
            } : !1,
            x = T.passiveListeners ? {
                passive: !0,
                capture: !1
            } : !1;
        if (!R) return;
        const H = _ === "on" ?
            "addEventListener" :
            "removeEventListener";
        R[H]("pointerdown", l, S), o[H](
            "pointermove", c, S), o[
            H]("pointerup", b, x)
    }

    function $() {
        !e.params.scrollbar.el || !e
            .scrollbar.el || A("on")
    }

    function I() {
        !e.params.scrollbar.el || !e
            .scrollbar.el || A("off")
    }

    function q() {
        const {
            scrollbar: _,
            el: C
        } = e;
        e.params.scrollbar = bt(e, e
            .originalParams
            .scrollbar, e.params
            .scrollbar, {
                el: "swiper-scrollbar"
            });
        const T = e.params.scrollbar;
        if (!T.el) return;
        let z;
        if (typeof T.el == "string" && e
            .isElement && (z = e.el
                .querySelector(T.el)), !
            z && typeof T.el == "string"
            ) {
            if (z = o.querySelectorAll(T
                    .el), !z.length)
                return
        } else z || (z = T.el);
        e.params.uniqueNavElements &&
            typeof T.el == "string" && z
            .length > 1 && C
            .querySelectorAll(T.el)
            .length === 1 && (z = C
                .querySelector(T.el)), z
            .length > 0 && (z = z[0]), z
            .classList.add(e
                .isHorizontal() ? T
                .horizontalClass : T
                .verticalClass);
        let R;
        z && (R = z.querySelector(Ee(e
                .params
                .scrollbar
                .dragClass)), R || (
                R = ge("div", e
                    .params
                    .scrollbar
                    .dragClass), z
                .append(R))), Object
            .assign(_, {
                el: z,
                dragEl: R
            }), T.draggable && $(), z &&
            z.classList[e.enabled ?
                "remove" : "add"](...Re(
                e.params.scrollbar
                .lockClass))
    }

    function E() {
        const _ = e.params.scrollbar,
            C = e.scrollbar.el;
        C && C.classList.remove(...Re(e
            .isHorizontal() ? _
            .horizontalClass : _
            .verticalClass)), I()
    }
    i("changeDirection", () => {
        if (!e.scrollbar || !e
            .scrollbar.el)
            return;
        const _ = e.params
            .scrollbar;
        let {
            el: C
        } = e.scrollbar;
        C = W(C), C.forEach(
        T => {
            T.classList
                .remove(
                    _
                    .horizontalClass,
                    _
                    .verticalClass
                    ), T
                .classList
                .add(e
                    .isHorizontal() ?
                    _
                    .horizontalClass :
                    _
                    .verticalClass
                    )
        })
    }), i("init", () => {
        e.params.scrollbar
            .enabled === !1 ?
            O() : (q(), s(),
            g())
    }), i(
        "update resize observerUpdate lock unlock changeDirection",
        () => {
            s()
        }), i("setTranslate",
() => {
        g()
    }), i("setTransition", (_,
    C) => {
        r(C)
    }), i("enable disable", () => {
        const {
            el: _
        } = e.scrollbar;
        _ && _.classList[e
            .enabled ?
            "remove" : "add"
            ](...Re(e.params
            .scrollbar
            .lockClass))
    }), i("destroy", () => {
        E()
    });
    const D = () => {
            e.el.classList.remove(...Re(
                    e.params
                    .scrollbar
                    .scrollbarDisabledClass
                    )), e.scrollbar
                .el && e.scrollbar.el
                .classList.remove(...Re(
                    e.params
                    .scrollbar
                    .scrollbarDisabledClass
                    )), q(), s(), g()
        },
        O = () => {
            e.el.classList.add(...Re(e
                    .params
                    .scrollbar
                    .scrollbarDisabledClass
                    )), e.scrollbar
                .el && e.scrollbar.el
                .classList.add(...Re(e
                    .params
                    .scrollbar
                    .scrollbarDisabledClass
                    )), E()
        };
    Object.assign(e.scrollbar, {
        enable: D,
        disable: O,
        updateSize: s,
        setTranslate: g,
        init: q,
        destroy: E
    })
}

function si(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        parallax: {
            enabled: !1
        }
    });
    const a =
        "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
        o = (p, f) => {
            const {
                rtl: n
            } = e, v = n ? -1 : 1, y = p
                .getAttribute(
                    "data-swiper-parallax"
                    ) || "0";
            let g = p.getAttribute(
                    "data-swiper-parallax-x"
                    ),
                r = p.getAttribute(
                    "data-swiper-parallax-y"
                    );
            const s = p.getAttribute(
                    "data-swiper-parallax-scale"
                    ),
                d = p.getAttribute(
                    "data-swiper-parallax-opacity"
                    ),
                m = p.getAttribute(
                    "data-swiper-parallax-rotate"
                    );
            if (g || r ? (g = g || "0",
                    r = r || "0") : e
                .isHorizontal() ? (g =
                    y, r = "0") : (r =
                    y, g = "0"), g
                .indexOf("%") >= 0 ? g =
                `${parseInt(g,10)*f*v}%` :
                g = `${g*f*v}px`, r
                .indexOf("%") >= 0 ? r =
                `${parseInt(r,10)*f}%` :
                r = `${r*f}px`,
                typeof d < "u" && d !==
                null) {
                const c = d - (d - 1) *
                    (1 - Math.abs(f));
                p.style.opacity = c
            }
            let l =
                `translate3d(${g}, ${r}, 0px)`;
            if (typeof s < "u" && s !==
                null) {
                const c = s - (s - 1) *
                    (1 - Math.abs(f));
                l += ` scale(${c})`
            }
            if (m && typeof m < "u" &&
                m !== null) {
                const c = m * f * -1;
                l += ` rotate(${c}deg)`
            }
            p.style.transform = l
        },
        h = () => {
            const {
                el: p,
                slides: f,
                progress: n,
                snapGrid: v,
                isElement: y
            } = e, g = ze(p, a);
            e.isElement && g.push(...ze(
                    e.hostEl, a)), g
                .forEach(r => {
                    o(r, n)
                }), f.forEach((r,
                s) => {
                    let d = r
                        .progress;
                    e.params
                        .slidesPerGroup >
                        1 && e
                        .params
                        .slidesPerView !==
                        "auto" && (
                            d +=
                            Math
                            .ceil(
                                s /
                                2) -
                            n * (v
                                .length -
                                1)),
                        d = Math
                        .min(Math
                            .max(d,
                                -1),
                            1), r
                        .querySelectorAll(
                            `${a}, [data-swiper-parallax-rotate]`
                            )
                        .forEach(
                            m => {
                                o(m, d)
                            })
                })
        },
        w = function(p) {
            p === void 0 && (p = e
                .params.speed);
            const {
                el: f,
                hostEl: n
            } = e, v = [...f
                .querySelectorAll(a)
            ];
            e.isElement && v.push(...n
                .querySelectorAll(a)
                ), v.forEach(y => {
                let g =
                    parseInt(y
                        .getAttribute(
                            "data-swiper-parallax-duration"
                            ),
                        10) ||
                    p;
                p === 0 && (g =
                        0), y
                    .style
                    .transitionDuration =
                    `${g}ms`
            })
        };
    i("beforeInit", () => {
        e.params.parallax
            .enabled && (e
                .params
                .watchSlidesProgress = !
                0, e
                .originalParams
                .watchSlidesProgress = !
                0)
    }), i("init", () => {
        e.params.parallax
            .enabled && h()
    }), i("setTranslate", () => {
        e.params.parallax
            .enabled && h()
    }), i("setTransition", (p,
    f) => {
        e.params.parallax
            .enabled && w(f)
    })
}

function ri(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a
    } = u;
    const o = Ie();
    t({
        zoom: {
            enabled: !1,
            limitToOriginalSize:
                !1,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: !1,
            toggle: !0,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    }), e.zoom = {
        enabled: !1
    };
    let h = 1,
        w = !1,
        p = !1,
        f = {
            x: 0,
            y: 0
        };
    const n = -3;
    let v, y;
    const g = [],
        r = {
            originX: 0,
            originY: 0,
            slideEl: void 0,
            slideWidth: void 0,
            slideHeight: void 0,
            imageEl: void 0,
            imageWrapEl: void 0,
            maxRatio: 3
        },
        s = {
            isTouched: void 0,
            isMoved: void 0,
            currentX: void 0,
            currentY: void 0,
            minX: void 0,
            minY: void 0,
            maxX: void 0,
            maxY: void 0,
            width: void 0,
            height: void 0,
            startX: void 0,
            startY: void 0,
            touchesStart: {},
            touchesCurrent: {}
        },
        d = {
            x: void 0,
            y: void 0,
            prevPositionX: void 0,
            prevPositionY: void 0,
            prevTime: void 0
        };
    let m = 1;
    Object.defineProperty(e.zoom,
        "scale", {
            get() {
                return m
            },
            set(P) {
                if (m !== P) {
                    const L = r
                        .imageEl,
                        k = r
                        .slideEl;
                    a("zoomChange",
                        P,
                        L, k
                        )
                }
                m = P
            }
        });

    function l() {
        if (g.length < 2) return 1;
        const P = g[0].pageX,
            L = g[0].pageY,
            k = g[1].pageX,
            G = g[1].pageY;
        return Math.sqrt((k - P) ** 2 +
            (G - L) ** 2)
    }

    function c() {
        const P = e.params.zoom,
            L = r.imageWrapEl
            .getAttribute(
                "data-swiper-zoom") || P
            .maxRatio;
        if (P.limitToOriginalSize && r
            .imageEl && r.imageEl
            .naturalWidth) {
            const k = r.imageEl
                .naturalWidth / r
                .imageEl.offsetWidth;
            return Math.min(k, L)
        }
        return L
    }

    function b() {
        if (g.length < 2) return {
            x: null,
            y: null
        };
        const P = r.imageEl
            .getBoundingClientRect();
        return [(g[0].pageX + (g[1]
                    .pageX - g[0]
                    .pageX) / 2 - P
                .x - o.scrollX) / h,
            (g[0].pageY + (g[1]
                    .pageY - g[0]
                    .pageY) / 2 - P
                .y - o.scrollY) / h
        ]
    }

    function A() {
        return e.isElement ?
            "swiper-slide" :
            `.${e.params.slideClass}`
    }

    function $(P) {
        const L = A();
        return !!(P.target.matches(L) ||
            e.slides.filter(k => k
                .contains(P.target))
            .length > 0)
    }

    function I(P) {
        const L =
            `.${e.params.zoom.containerClass}`;
        return !!(P.target.matches(L) ||
            [...e.hostEl
                .querySelectorAll(L)
            ].filter(k => k
                .contains(P.target))
            .length > 0)
    }

    function q(P) {
        if (P.pointerType === "mouse" &&
            g.splice(0, g.length), !$(P)
            ) return;
        const L = e.params.zoom;
        if (v = !1, y = !1, g.push(P), !
            (g.length < 2)) {
            if (v = !0, r.scaleStart =
                l(), !r.slideEl) {
                r.slideEl = P.target
                    .closest(
                        `.${e.params.slideClass}, swiper-slide`
                        ), r.slideEl ||
                    (r.slideEl = e
                        .slides[e
                            .activeIndex
                            ]);
                let k = r.slideEl
                    .querySelector(
                        `.${L.containerClass}`
                        );
                if (k && (k = k
                        .querySelectorAll(
                            "picture, img, svg, canvas, .swiper-zoom-target"
                            )[0]), r
                    .imageEl = k, k ? r
                    .imageWrapEl = je(r
                        .imageEl,
                        `.${L.containerClass}`
                        )[0] : r
                    .imageWrapEl =
                    void 0, !r
                    .imageWrapEl) {
                    r.imageEl = void 0;
                    return
                }
                r.maxRatio = c()
            }
            if (r.imageEl) {
                const [k, G] = b();
                r.originX = k, r
                    .originY = G, r
                    .imageEl.style
                    .transitionDuration =
                    "0ms"
            }
            w = !0
        }
    }

    function E(P) {
        if (!$(P)) return;
        const L = e.params.zoom,
            k = e.zoom,
            G = g.findIndex(te => te
                .pointerId === P
                .pointerId);
        G >= 0 && (g[G] = P), !(g
            .length < 2) && (y = !0,
            r.scaleMove = l(), r
            .imageEl && (k.scale = r
                .scaleMove / r
                .scaleStart * h, k
                .scale > r
                .maxRatio && (k
                    .scale = r
                    .maxRatio - 1 +
                    (k.scale - r
                        .maxRatio +
                        1) ** .5), k
                .scale < L
                .minRatio && (k
                    .scale = L
                    .minRatio + 1 -
                    (L.minRatio - k
                        .scale + 1
                        ) ** .5), r
                .imageEl.style
                .transform =
                `translate3d(0,0,0) scale(${k.scale})`
                ))
    }

    function D(P) {
        if (!$(P) || P.pointerType ===
            "mouse" && P.type ===
            "pointerout") return;
        const L = e.params.zoom,
            k = e.zoom,
            G = g.findIndex(te => te
                .pointerId === P
                .pointerId);
        G >= 0 && g.splice(G, 1), !(!
            v || !y) && (v = !1,
            y = !1, r.imageEl && (k
                .scale = Math.max(
                    Math.min(k
                        .scale, r
                        .maxRatio),
                    L.minRatio), r
                .imageEl.style
                .transitionDuration =
                `${e.params.speed}ms`,
                r.imageEl.style
                .transform =
                `translate3d(0,0,0) scale(${k.scale})`,
                h = k.scale, w = !1,
                k.scale > 1 && r
                .slideEl ? r.slideEl
                .classList.add(
                    `${L.zoomedSlideClass}`
                    ) : k.scale <=
                1 && r.slideEl && r
                .slideEl.classList
                .remove(
                    `${L.zoomedSlideClass}`
                    ), k.scale ===
                1 && (r.originX = 0,
                    r.originY = 0, r
                    .slideEl =
                    void 0)))
    }
    let O;

    function _() {
        e.touchEventsData
            .preventTouchMoveFromPointerMove = !
            1
    }

    function C() {
        clearTimeout(O), e
            .touchEventsData
            .preventTouchMoveFromPointerMove = !
            0, O = setTimeout(() => {
                e.destroyed || _()
            })
    }

    function T(P) {
        const L = e.device;
        if (!r.imageEl || s.isTouched)
            return;
        L.android && P.cancelable && P
            .preventDefault(), s
            .isTouched = !0;
        const k = g.length > 0 ? g[0] :
            P;
        s.touchesStart.x = k.pageX, s
            .touchesStart.y = k.pageY
    }

    function z(P) {
        const k = P.pointerType ===
            "mouse" && e.params.zoom
            .panOnMouseMove;
        if (!$(P) || !I(P)) return;
        const G = e.zoom;
        if (!r.imageEl) return;
        if (!s.isTouched || !r
            .slideEl) {
            k && x(P);
            return
        }
        if (k) {
            x(P);
            return
        }
        s.isMoved || (s.width = r
            .imageEl.offsetWidth ||
            r.imageEl.clientWidth, s
            .height = r.imageEl
            .offsetHeight || r
            .imageEl.clientHeight, s
            .startX = xt(r
                .imageWrapEl, "x"
                ) || 0, s.startY =
            xt(r.imageWrapEl,
            "y") || 0, r
            .slideWidth = r.slideEl
            .offsetWidth, r
            .slideHeight = r.slideEl
            .offsetHeight, r
            .imageWrapEl.style
            .transitionDuration =
            "0ms");
        const te = s.width * G.scale,
            pe = s.height * G.scale;
        if (s.minX = Math.min(r
                .slideWidth / 2 - te /
                2, 0), s.maxX = -s.minX,
            s.minY = Math.min(r
                .slideHeight / 2 - pe /
                2, 0), s.maxY = -s.minY,
            s.touchesCurrent.x = g
            .length > 0 ? g[0].pageX : P
            .pageX, s.touchesCurrent.y =
            g.length > 0 ? g[0].pageY :
            P.pageY, Math.max(Math.abs(s
                    .touchesCurrent.x -
                    s.touchesStart.x),
                Math.abs(s
                    .touchesCurrent.y -
                    s.touchesStart.y)) >
            5 && (e.allowClick = !1), !s
            .isMoved && !w) {
            if (e.isHorizontal() && (
                    Math.floor(s
                    .minX) === Math
                    .floor(s.startX) &&
                    s.touchesCurrent.x <
                    s.touchesStart.x ||
                    Math.floor(s
                    .maxX) === Math
                    .floor(s.startX) &&
                    s.touchesCurrent.x >
                    s.touchesStart.x)) {
                s.isTouched = !1, _();
                return
            }
            if (!e.isHorizontal() && (
                    Math.floor(s
                    .minY) === Math
                    .floor(s.startY) &&
                    s.touchesCurrent.y <
                    s.touchesStart.y ||
                    Math.floor(s
                    .maxY) === Math
                    .floor(s.startY) &&
                    s.touchesCurrent.y >
                    s.touchesStart.y)) {
                s.isTouched = !1, _();
                return
            }
        }
        P.cancelable && P
            .preventDefault(), P
            .stopPropagation(), C(), s
            .isMoved = !0;
        const oe = (G.scale - h) / (r
                .maxRatio - e.params
                .zoom.minRatio),
            {
                originX: he,
                originY: ie
            } = r;
        s.currentX = s.touchesCurrent
            .x - s.touchesStart.x + s
            .startX + oe * (s.width -
                he * 2), s.currentY = s
            .touchesCurrent.y - s
            .touchesStart.y + s.startY +
            oe * (s.height - ie * 2), s
            .currentX < s.minX && (s
                .currentX = s.minX + 1 -
                (s.minX - s.currentX +
                    1) ** .8), s
            .currentX > s.maxX && (s
                .currentX = s.maxX - 1 +
                (s.currentX - s.maxX +
                    1) ** .8), s
            .currentY < s.minY && (s
                .currentY = s.minY + 1 -
                (s.minY - s.currentY +
                    1) ** .8), s
            .currentY > s.maxY && (s
                .currentY = s.maxY - 1 +
                (s.currentY - s.maxY +
                    1) ** .8), d
            .prevPositionX || (d
                .prevPositionX = s
                .touchesCurrent.x), d
            .prevPositionY || (d
                .prevPositionY = s
                .touchesCurrent.y), d
            .prevTime || (d.prevTime =
                Date.now()), d.x = (s
                .touchesCurrent.x - d
                .prevPositionX) / (Date
                .now() - d.prevTime) /
            2, d.y = (s.touchesCurrent
                .y - d.prevPositionY) /
            (Date.now() - d.prevTime) /
            2, Math.abs(s.touchesCurrent
                .x - d.prevPositionX) <
            2 && (d.x = 0), Math.abs(s
                .touchesCurrent.y - d
                .prevPositionY) < 2 && (
                d.y = 0), d
            .prevPositionX = s
            .touchesCurrent.x, d
            .prevPositionY = s
            .touchesCurrent.y, d
            .prevTime = Date.now(), r
            .imageWrapEl.style
            .transform =
            `translate3d(${s.currentX}px, ${s.currentY}px,0)`
    }

    function R() {
        const P = e.zoom;
        if (g.length = 0, !r.imageEl)
            return;
        if (!s.isTouched || !s
            .isMoved) {
            s.isTouched = !1, s
                .isMoved = !1;
            return
        }
        s.isTouched = !1, s.isMoved = !
        1;
        let L = 300,
            k = 300;
        const G = d.x * L,
            te = s.currentX + G,
            pe = d.y * k,
            ue = s.currentY + pe;
        d.x !== 0 && (L = Math.abs((te -
                s.currentX) / d
            .x)), d.y !== 0 && (k =
            Math.abs((ue - s
                    .currentY) / d
                .y));
        const oe = Math.max(L, k);
        s.currentX = te, s.currentY =
        ue;
        const he = s.width * P.scale,
            ie = s.height * P.scale;
        s.minX = Math.min(r.slideWidth /
                2 - he / 2, 0), s
            .maxX = -s.minX, s.minY =
            Math.min(r.slideHeight / 2 -
                ie / 2, 0), s.maxY = -s
            .minY, s.currentX = Math
            .max(Math.min(s.currentX, s
                .maxX), s.minX), s
            .currentY = Math.max(Math
                .min(s.currentY, s
                .maxY), s.minY), r
            .imageWrapEl.style
            .transitionDuration =
            `${oe}ms`, r.imageWrapEl
            .style.transform =
            `translate3d(${s.currentX}px, ${s.currentY}px,0)`
    }

    function S() {
        const P = e.zoom;
        r.slideEl && e.activeIndex !== e
            .slides.indexOf(r
            .slideEl) && (r.imageEl && (
                    r.imageEl.style
                    .transform =
                    "translate3d(0,0,0) scale(1)"
                    ), r.imageWrapEl &&
                (r.imageWrapEl.style
                    .transform =
                    "translate3d(0,0,0)"
                    ), r.slideEl
                .classList.remove(
                    `${e.params.zoom.zoomedSlideClass}`
                    ), P.scale = 1, h =
                1, r.slideEl = void 0, r
                .imageEl = void 0, r
                .imageWrapEl = void 0, r
                .originX = 0, r
                .originY = 0)
    }

    function x(P) {
        if (h <= 1 || !r.imageWrapEl ||
            !$(P) || !I(P)) return;
        const L = o.getComputedStyle(r
                .imageWrapEl).transform,
            k = new o.DOMMatrix(L);
        if (!p) {
            p = !0, f.x = P.clientX, f
                .y = P.clientY, s
                .startX = k.e, s
                .startY = k.f, s.width =
                r.imageEl.offsetWidth ||
                r.imageEl.clientWidth, s
                .height = r.imageEl
                .offsetHeight || r
                .imageEl.clientHeight, r
                .slideWidth = r.slideEl
                .offsetWidth, r
                .slideHeight = r.slideEl
                .offsetHeight;
            return
        }
        const G = (P.clientX - f.x) * n,
            te = (P.clientY - f.y) * n,
            pe = s.width * h,
            ue = s.height * h,
            oe = r.slideWidth,
            he = r.slideHeight,
            ie = Math.min(oe / 2 - pe /
                2, 0),
            ae = -ie,
            se = Math.min(he / 2 - ue /
                2, 0),
            De = -se,
            xe = Math.max(Math.min(s
                    .startX + G, ae),
                ie),
            Ce = Math.max(Math.min(s
                    .startY + te, De),
                se);
        r.imageWrapEl.style
            .transitionDuration = "0ms",
            r.imageWrapEl.style
            .transform =
            `translate3d(${xe}px, ${Ce}px, 0)`,
            f.x = P.clientX, f.y = P
            .clientY, s.startX = xe, s
            .startY = Ce, s.currentX =
            xe, s.currentY = Ce
    }

    function H(P) {
        const L = e.zoom,
            k = e.params.zoom;
        if (!r.slideEl) {
            P && P.target && (r
                    .slideEl = P.target
                    .closest(
                        `.${e.params.slideClass}, swiper-slide`
                        )), r.slideEl ||
                (e.params.virtual && e
                    .params.virtual
                    .enabled && e
                    .virtual ? r
                    .slideEl = ze(e
                        .slidesEl,
                        `.${e.params.slideActiveClass}`
                        )[0] : r
                    .slideEl = e.slides[
                        e.activeIndex]);
            let Le = r.slideEl
                .querySelector(
                    `.${k.containerClass}`
                    );
            Le && (Le = Le
                    .querySelectorAll(
                        "picture, img, svg, canvas, .swiper-zoom-target"
                        )[0]), r
                .imageEl = Le, Le ? r
                .imageWrapEl = je(r
                    .imageEl,
                    `.${k.containerClass}`
                    )[0] : r
                .imageWrapEl = void 0
        }
        if (!r.imageEl || !r
            .imageWrapEl) return;
        e.params.cssMode && (e.wrapperEl
                .style.overflow =
                "hidden", e.wrapperEl
                .style.touchAction =
                "none"), r.slideEl
            .classList.add(
                `${k.zoomedSlideClass}`
                );
        let G, te, pe, ue, oe, he, ie,
            ae, se, De, xe, Ce, Xe, Ve,
            Fe, $e, qe, Te;
        typeof s.touchesStart.x > "u" &&
            P ? (G = P.pageX, te = P
                .pageY) : (G = s
                .touchesStart.x, te = s
                .touchesStart.y);
        const Me = h,
            ve = typeof P == "number" ?
            P : null;
        h === 1 && ve && (G = void 0,
            te = void 0, s
            .touchesStart.x =
            void 0, s.touchesStart
            .y = void 0);
        const Oe = c();
        L.scale = ve || Oe, h = ve ||
            Oe, P && !(h === 1 && ve) ?
            (qe = r.slideEl.offsetWidth,
                Te = r.slideEl
                .offsetHeight, pe = nt(r
                    .slideEl).left + o
                .scrollX, ue = nt(r
                    .slideEl).top + o
                .scrollY, oe = pe + qe /
                2 - G, he = ue + Te /
                2 - te, se = r.imageEl
                .offsetWidth || r
                .imageEl.clientWidth,
                De = r.imageEl
                .offsetHeight || r
                .imageEl.clientHeight,
                xe = se * L.scale, Ce =
                De * L.scale, Xe = Math
                .min(qe / 2 - xe / 2,
                0), Ve = Math.min(Te /
                    2 - Ce / 2, 0),
                Fe = -Xe, $e = -Ve, Me >
                0 && ve && typeof s
                .currentX == "number" &&
                typeof s.currentY ==
                "number" ? (ie = s
                    .currentX * L
                    .scale / Me, ae = s
                    .currentY * L
                    .scale / Me) : (ie =
                    oe * L.scale, ae =
                    he * L.scale), ie <
                Xe && (ie = Xe), ie >
                Fe && (ie = Fe), ae <
                Ve && (ae = Ve), ae >
                $e && (ae = $e)) : (ie =
                0, ae = 0), ve && L
            .scale === 1 && (r.originX =
                0, r.originY = 0), s
            .currentX = ie, s.currentY =
            ae, r.imageWrapEl.style
            .transitionDuration =
            "300ms", r.imageWrapEl.style
            .transform =
            `translate3d(${ie}px, ${ae}px,0)`,
            r.imageEl.style
            .transitionDuration =
            "300ms", r.imageEl.style
            .transform =
            `translate3d(0,0,0) scale(${L.scale})`
    }

    function Y() {
        const P = e.zoom,
            L = e.params.zoom;
        if (!r.slideEl) {
            e.params.virtual && e.params
                .virtual.enabled && e
                .virtual ? r.slideEl =
                ze(e.slidesEl,
                    `.${e.params.slideActiveClass}`
                    )[0] : r.slideEl = e
                .slides[e.activeIndex];
            let k = r.slideEl
                .querySelector(
                    `.${L.containerClass}`
                    );
            k && (k = k
                    .querySelectorAll(
                        "picture, img, svg, canvas, .swiper-zoom-target"
                        )[0]), r
                .imageEl = k, k ? r
                .imageWrapEl = je(r
                    .imageEl,
                    `.${L.containerClass}`
                    )[0] : r
                .imageWrapEl = void 0
        }!r.imageEl || !r.imageWrapEl ||
            (e.params.cssMode && (e
                    .wrapperEl.style
                    .overflow = "", e
                    .wrapperEl.style
                    .touchAction = ""),
                P.scale = 1, h = 1, s
                .currentX = void 0, s
                .currentY = void 0, s
                .touchesStart.x =
                void 0, s.touchesStart
                .y = void 0, r
                .imageWrapEl.style
                .transitionDuration =
                "300ms", r.imageWrapEl
                .style.transform =
                "translate3d(0,0,0)", r
                .imageEl.style
                .transitionDuration =
                "300ms", r.imageEl.style
                .transform =
                "translate3d(0,0,0) scale(1)",
                r.slideEl.classList
                .remove(
                    `${L.zoomedSlideClass}`
                    ), r.slideEl =
                void 0, r.originX = 0, r
                .originY = 0, e.params
                .zoom.panOnMouseMove &&
                (f = {
                    x: 0,
                    y: 0
                }, p && (p = !1, s
                    .startX = 0, s
                    .startY = 0)))
    }

    function K(P) {
        const L = e.zoom;
        L.scale && L.scale !== 1 ? Y() :
            H(P)
    }

    function Z() {
        const P = e.params
            .passiveListeners ? {
                passive: !0,
                capture: !1
            } : !1,
            L = e.params
            .passiveListeners ? {
                passive: !1,
                capture: !0
            } : !0;
        return {
            passiveListener: P,
            activeListenerWithCapture: L
        }
    }

    function ne() {
        const P = e.zoom;
        if (P.enabled) return;
        P.enabled = !0;
        const {
            passiveListener: L,
            activeListenerWithCapture: k
        } = Z();
        e.wrapperEl.addEventListener(
                "pointerdown", q, L), e
            .wrapperEl.addEventListener(
                "pointermove", E, k), [
                "pointerup",
                "pointercancel",
                "pointerout"
            ].forEach(G => {
                e.wrapperEl
                    .addEventListener(
                        G, D, L)
            }), e.wrapperEl
            .addEventListener(
                "pointermove", z, k)
    }

    function de() {
        const P = e.zoom;
        if (!P.enabled) return;
        P.enabled = !1;
        const {
            passiveListener: L,
            activeListenerWithCapture: k
        } = Z();
        e.wrapperEl.removeEventListener(
                "pointerdown", q, L), e
            .wrapperEl
            .removeEventListener(
                "pointermove", E, k), [
                "pointerup",
                "pointercancel",
                "pointerout"
            ].forEach(G => {
                e.wrapperEl
                    .removeEventListener(
                        G, D, L)
            }), e.wrapperEl
            .removeEventListener(
                "pointermove", z, k)
    }
    i("init", () => {
        e.params.zoom.enabled &&
            ne()
    }), i("destroy", () => {
        de()
    }), i("touchStart", (P, L) => {
        e.zoom.enabled && T(L)
    }), i("touchEnd", (P, L) => {
        e.zoom.enabled && R()
    }), i("doubleTap", (P, L) => {
        !e.animating && e.params
            .zoom.enabled && e
            .zoom.enabled && e
            .params.zoom
            .toggle && K(L)
    }), i("transitionEnd", () => {
        e.zoom.enabled && e
            .params.zoom
            .enabled && S()
    }), i("slideChange", () => {
        e.zoom.enabled && e
            .params.zoom
            .enabled && e.params
            .cssMode && S()
    }), Object.assign(e.zoom, {
        enable: ne,
        disable: de,
        in: H,
        out: Y,
        toggle: K
    })
}

function ai(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        controller: {
            control: void 0,
            inverse: !1,
            by: "slide"
        }
    }), e.controller = {
        control: void 0
    };

    function a(f, n) {
        const v = function() {
            let s, d, m;
            return (l, c) => {
                for (d = -1, s =
                    l
                    .length; s -
                    d > 1;) m =
                    s + d >> 1,
                    l[m] <= c ?
                    d = m : s =
                    m;
                return s
            }
        }();
        this.x = f, this.y = n, this
            .lastIndex = f.length - 1;
        let y, g;
        return this.interpolate =
            function(s) {
                return s ? (g = v(this
                        .x, s), y =
                    g - 1, (s - this
                        .x[y]) * (
                        this.y[g] -
                        this.y[y]) /
                    (this.x[g] -
                        this.x[y]) +
                    this.y[y]) : 0
            }, this
    }

    function o(f) {
        e.controller.spline = e.params
            .loop ? new a(e.slidesGrid,
                f.slidesGrid) : new a(e
                .snapGrid, f.snapGrid)
    }

    function h(f, n) {
        const v = e.controller.control;
        let y, g;
        const r = e.constructor;

        function s(d) {
            if (d.destroyed) return;
            const m = e.rtlTranslate ? -
                e.translate : e
                .translate;
            e.params.controller.by ===
                "slide" && (o(d), g = -e
                    .controller.spline
                    .interpolate(-m)), (
                    !g || e.params
                    .controller.by ===
                    "container") && (y =
                    (d.maxTranslate() -
                        d.minTranslate()
                        ) / (e
                        .maxTranslate() -
                        e.minTranslate()
                        ), (Number
                        .isNaN(y) || !
                        Number.isFinite(
                            y)) && (y =
                        1), g = (m - e
                        .minTranslate()
                        ) * y + d
                    .minTranslate()), e
                .params.controller
                .inverse && (g = d
                    .maxTranslate() - g
                    ), d.updateProgress(
                    g), d.setTranslate(
                    g, e), d
                .updateActiveIndex(), d
                .updateSlidesClasses()
        }
        if (Array.isArray(v))
            for (let d = 0; d < v
                .length; d += 1) v[
                d] !== n && v[
                d] instanceof r && s(v[
                    d]);
        else v instanceof r && n !==
            v && s(v)
    }

    function w(f, n) {
        const v = e.constructor,
            y = e.controller.control;
        let g;

        function r(s) {
            s.destroyed || (s
                .setTransition(f,
                e), f !== 0 && (s
                    .transitionStart(),
                    s.params
                    .autoHeight &&
                    ot(() => {
                        s.updateAutoHeight()
                    }), Je(s
                        .wrapperEl,
                        () => {
                            y && s
                                .transitionEnd()
                        })))
        }
        if (Array.isArray(y))
            for (g = 0; g < y
                .length; g += 1) y[
                g] !== n && y[
                g] instanceof v && r(y[
                    g]);
        else y instanceof v && n !==
            y && r(y)
    }

    function p() {
        e.controller.control && e
            .controller.spline && (e
                .controller.spline =
                void 0, delete e
                .controller.spline)
    }
    i("beforeInit", () => {
        if (typeof window <
            "u" && (typeof e
                .params
                .controller
                .control ==
                "string" || e
                .params
                .controller
                .control instanceof HTMLElement
                )) {
            (typeof e.params
                .controller
                .control ==
                "string" ? [...
                    document
                    .querySelectorAll(
                        e.params
                        .controller
                        .control
                        )
                ] : [e.params
                    .controller
                    .control
                ]).forEach(
            n => {
                if (e
                    .controller
                    .control ||
                    (e.controller
                        .control = []
                        ),
                    n &&
                    n
                    .swiper
                    ) e
                    .controller
                    .control
                    .push(
                        n
                        .swiper
                        );
                else if (
                    n) {
                    const
                        v =
                        `${e.params.eventsPrefix}init`,
                        y =
                        g => {
                            e.controller
                                .control
                                .push(
                                    g
                                    .detail[
                                        0
                                        ]
                                    ),
                                e
                                .update(),
                                n
                                .removeEventListener(
                                    v,
                                    y
                                    )
                        };
                    n.addEventListener(
                        v,
                        y
                        )
                }
            });
            return
        }
        e.controller.control = e
            .params.controller
            .control
    }), i("update", () => {
        p()
    }), i("resize", () => {
        p()
    }), i("observerUpdate", () => {
        p()
    }), i("setTranslate", (f, n,
        v) => {
            !e.controller.control ||
                e.controller.control
                .destroyed || e
                .controller
                .setTranslate(n, v)
        }), i("setTransition", (f,
        n, v) => {
        !e.controller.control ||
            e.controller.control
            .destroyed || e
            .controller
            .setTransition(n, v)
    }), Object.assign(e
    .controller, {
        setTranslate: h,
        setTransition: w
    })
}

function ni(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: !0
        }
    }), e.a11y = {
        clicked: !1
    };
    let a = null,
        o, h, w = new Date().getTime();

    function p(S) {
        const x = a;
        x.length !== 0 && ce(x, S)
    }

    function f(S) {
        S === void 0 && (S = 16);
        const x = () => Math.round(16 *
            Math.random()).toString(
            16);
        return "x".repeat(S).replace(
            /x/g, x)
    }

    function n(S) {
        S = W(S), S.forEach(x => {
            x.setAttribute(
                "tabIndex",
                "0")
        })
    }

    function v(S) {
        S = W(S), S.forEach(x => {
            x.setAttribute(
                "tabIndex",
                "-1")
        })
    }

    function y(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute(
                "role", x)
        })
    }

    function g(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute(
                "aria-roledescription",
                x)
        })
    }

    function r(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute(
                "aria-controls",
                x)
        })
    }

    function s(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute(
                "aria-label",
                x)
        })
    }

    function d(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute("id",
                x)
        })
    }

    function m(S, x) {
        S = W(S), S.forEach(H => {
            H.setAttribute(
                "aria-live",
                x)
        })
    }

    function l(S) {
        S = W(S), S.forEach(x => {
            x.setAttribute(
                "aria-disabled",
                !0)
        })
    }

    function c(S) {
        S = W(S), S.forEach(x => {
            x.setAttribute(
                "aria-disabled",
                !1)
        })
    }

    function b(S) {
        if (S.keyCode !== 13 && S
            .keyCode !== 32) return;
        const x = e.params.a11y,
            H = S.target;
        if (!(e.pagination && e
                .pagination.el && (H ===
                    e.pagination.el || e
                    .pagination.el
                    .contains(S.target)
                    ) && !S.target
                .matches(Ee(e.params
                    .pagination
                    .bulletClass)))) {
            if (e.navigation && e
                .navigation.prevEl && e
                .navigation.nextEl) {
                const Y = W(e.navigation
                    .prevEl);
                W(e.navigation.nextEl)
                    .includes(H) && (e
                        .isEnd && !e
                        .params.loop ||
                        e.slideNext(), e
                        .isEnd ? p(x
                            .lastSlideMessage
                            ) : p(x
                            .nextSlideMessage
                            )), Y
                    .includes(H) && (e
                        .isBeginning &&
                        !e.params
                        .loop || e
                        .slidePrev(), e
                        .isBeginning ?
                        p(x
                            .firstSlideMessage) :
                        p(x
                            .prevSlideMessage)
                        )
            }
            e.pagination && H.matches(
                    Ee(e.params
                        .pagination
                        .bulletClass)
                    ) && H.click()
        }
    }

    function A() {
        if (e.params.loop || e.params
            .rewind || !e.navigation)
            return;
        const {
            nextEl: S,
            prevEl: x
        } = e.navigation;
        x && (e.isBeginning ? (l(x), v(
                x)) : (c(x), n(x))),
            S && (e.isEnd ? (l(S), v(
                S)) : (c(S), n(S)))
    }

    function $() {
        return e.pagination && e
            .pagination.bullets && e
            .pagination.bullets.length
    }

    function I() {
        return $() && e.params
            .pagination.clickable
    }

    function q() {
        const S = e.params.a11y;
        $() && e.pagination.bullets
            .forEach(x => {
                e.params.pagination
                    .clickable && (
                        n(x), e
                        .params
                        .pagination
                        .renderBullet ||
                        (y(x,
                                "button"),
                            s(x, S
                                .paginationBulletMessage
                                .replace(
                                    /\{\{index\}\}/,
                                    wt(
                                        x) +
                                    1
                                    )
                                ))),
                    x.matches(Ee(e
                        .params
                        .pagination
                        .bulletActiveClass
                        )) ? x
                    .setAttribute(
                        "aria-current",
                        "true") : x
                    .removeAttribute(
                        "aria-current"
                        )
            })
    }
    const E = (S, x, H) => {
            n(S), S.tagName !==
                "BUTTON" && (y(S,
                        "button"), S
                    .addEventListener(
                        "keydown", b)),
                s(S, H), r(S, x)
        },
        D = S => {
            h && h !== S.target && !h
                .contains(S.target) && (
                    o = !0), e.a11y
                .clicked = !0
        },
        O = () => {
            o = !1,
                requestAnimationFrame(
                () => {
                        requestAnimationFrame
                            (() => {
                                e.destroyed ||
                                    (e.a11y
                                        .clicked = !
                                        1
                                        )
                            })
                    })
        },
        _ = S => {
            w = new Date().getTime()
        },
        C = S => {
            if (e.a11y.clicked || !e
                .params.a11y
                .scrollOnFocus ||
                new Date().getTime() -
                w < 100) return;
            const x = S.target.closest(
                `.${e.params.slideClass}, swiper-slide`
                );
            if (!x || !e.slides
                .includes(x)) return;
            h = x;
            const H = e.slides.indexOf(
                    x) === e
                .activeIndex,
                Y = e.params
                .watchSlidesProgress &&
                e.visibleSlides && e
                .visibleSlides.includes(
                    x);
            H || Y || S
                .sourceCapabilities && S
                .sourceCapabilities
                .firesTouchEvents || (e
                    .isHorizontal() ? e
                    .el.scrollLeft = 0 :
                    e.el.scrollTop = 0,
                    requestAnimationFrame(
                        () => {
                            o || (e.params
                                .loop ?
                                e
                                .slideToLoop(
                                    e
                                    .getSlideIndexWhenGrid(
                                        parseInt(
                                            x
                                            .getAttribute(
                                                "data-swiper-slide-index"
                                                )
                                            )
                                        ),
                                    0
                                    ) :
                                e
                                .slideTo(
                                    e
                                    .getSlideIndexWhenGrid(
                                        e
                                        .slides
                                        .indexOf(
                                            x
                                            )
                                        ),
                                    0
                                    ),
                                o = !
                                1)
                        }))
        },
        T = () => {
            const S = e.params.a11y;
            S.itemRoleDescriptionMessage &&
                g(e.slides, S
                    .itemRoleDescriptionMessage
                    ), S.slideRole && y(
                    e.slides, S
                    .slideRole);
            const x = e.slides.length;
            S.slideLabelMessage && e
                .slides.forEach((H,
                    Y) => {
                        const K = e
                            .params
                            .loop ?
                            parseInt(H
                                .getAttribute(
                                    "data-swiper-slide-index"
                                    ),
                                10) : Y,
                            Z = S
                            .slideLabelMessage
                            .replace(
                                /\{\{index\}\}/,
                                K + 1)
                            .replace(
                                /\{\{slidesLength\}\}/,
                                x);
                        s(H, Z)
                    })
        },
        z = () => {
            const S = e.params.a11y;
            e.el.append(a);
            const x = e.el;
            S.containerRoleDescriptionMessage &&
                g(x, S
                    .containerRoleDescriptionMessage
                    ), S
                .containerMessage && s(
                    x, S
                    .containerMessage),
                S.containerRole && y(x,
                    S.containerRole);
            const H = e.wrapperEl,
                Y = S.id || H
                .getAttribute("id") ||
                `swiper-wrapper-${f(16)}`,
                K = e.params.autoplay &&
                e.params.autoplay
                .enabled ? "off" :
                "polite";
            d(H, Y), m(H, K), T();
            let {
                nextEl: Z,
                prevEl: ne
            } = e.navigation ? e
                .navigation : {};
            Z = W(Z), ne = W(ne), Z && Z
                .forEach(P => E(P, Y, S
                    .nextSlideMessage
                    )), ne && ne
                .forEach(P => E(P, Y, S
                    .prevSlideMessage
                    )), I() && W(e
                    .pagination.el)
                .forEach(L => {
                    L.addEventListener(
                        "keydown",
                        b)
                }), we()
                .addEventListener(
                    "visibilitychange",
                    _), e.el
                .addEventListener(
                    "focus", C, !0), e
                .el.addEventListener(
                    "focus", C, !0), e
                .el.addEventListener(
                    "pointerdown", D, !0
                    ), e.el
                .addEventListener(
                    "pointerup", O, !0)
        };

    function R() {
        a && a.remove();
        let {
            nextEl: S,
            prevEl: x
        } = e.navigation ? e
            .navigation : {};
        S = W(S), x = W(x), S && S
            .forEach(Y => Y
                .removeEventListener(
                    "keydown", b)), x &&
            x.forEach(Y => Y
                .removeEventListener(
                    "keydown", b)),
        I() && W(e.pagination.el)
            .forEach(K => {
                K.removeEventListener(
                    "keydown", b
                    )
            }), we()
            .removeEventListener(
                "visibilitychange", _),
            e.el && typeof e.el !=
            "string" && (e.el
                .removeEventListener(
                    "focus", C, !0), e
                .el.removeEventListener(
                    "pointerdown", D, !0
                    ), e.el
                .removeEventListener(
                    "pointerup", O, !0))
    }
    i("beforeInit", () => {
        a = ge("span", e.params
                .a11y
                .notificationClass
                ), a
            .setAttribute(
                "aria-live",
                "assertive"), a
            .setAttribute(
                "aria-atomic",
                "true")
    }), i("afterInit", () => {
        e.params.a11y.enabled &&
            z()
    }), i(
        "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
        () => {
            e.params.a11y.enabled &&
                T()
        }), i(
        "fromEdge toEdge afterInit lock unlock",
        () => {
            e.params.a11y.enabled &&
                A()
        }), i("paginationUpdate",
    () => {
            e.params.a11y.enabled &&
                q()
        }), i("destroy", () => {
        e.params.a11y.enabled &&
            R()
    })
}

function oi(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        history: {
            enabled: !1,
            root: "",
            replaceState: !1,
            key: "slides",
            keepQuery: !1
        }
    });
    let a = !1,
        o = {};
    const h = g => g.toString().replace(
            /\s+/g, "-").replace(
            /[^\w-]+/g, "").replace(
            /--+/g, "-").replace(/^-+/,
            "").replace(/-+$/, ""),
        w = g => {
            const r = Ie();
            let s;
            g ? s = new URL(g) : s = r
                .location;
            const d = s.pathname.slice(
                    1).split("/")
                .filter(b => b !== ""),
                m = d.length,
                l = d[m - 2],
                c = d[m - 1];
            return {
                key: l,
                value: c
            }
        },
        p = (g, r) => {
            const s = Ie();
            if (!a || !e.params.history
                .enabled) return;
            let d;
            e.params.url ? d = new URL(e
                    .params.url) : d = s
                .location;
            const m = e.virtual && e
                .params.virtual
                .enabled ? e.slidesEl
                .querySelector(
                    `[data-swiper-slide-index="${r}"]`
                    ) : e.slides[r];
            let l = h(m.getAttribute(
                "data-history"));
            if (e.params.history.root
                .length > 0) {
                let b = e.params.history
                    .root;
                b[b.length - 1] ===
                    "/" && (b = b.slice(
                            0, b
                            .length - 1
                            )), l =
                    `${b}/${g?`${g}/`:""}${l}`
            } else d.pathname.includes(
                g) || (l =
                `${g?`${g}/`:""}${l}`
                );
            e.params.history
                .keepQuery && (l += d
                    .search);
            const c = s.history.state;
            c && c.value === l || (e
                .params.history
                .replaceState ? s
                .history
                .replaceState({
                    value: l
                }, null, l) : s
                .history.pushState({
                    value: l
                }, null, l))
        },
        f = (g, r, s) => {
            if (r)
                for (let d = 0, m = e
                        .slides
                        .length; d <
                    m; d += 1) {
                    const l = e.slides[
                        d];
                    if (h(l.getAttribute(
                            "data-history"
                            )) === r) {
                        const b = e
                            .getSlideIndex(
                                l);
                        e.slideTo(b, g,
                            s)
                    }
                } else e.slideTo(0, g,
                    s)
        },
        n = () => {
            o = w(e.params.url), f(e
                .params.speed, o
                .value, !1)
        },
        v = () => {
            const g = Ie();
            if (e.params.history) {
                if (!g.history || !g
                    .history.pushState
                    ) {
                    e.params.history
                        .enabled = !1, e
                        .params
                        .hashNavigation
                        .enabled = !0;
                    return
                }
                if (a = !0, o = w(e
                        .params.url), !o
                    .key && !o.value) {
                    e.params.history
                        .replaceState ||
                        g
                        .addEventListener(
                            "popstate",
                            n);
                    return
                }
                f(0, o.value, e.params
                        .runCallbacksOnInit
                        ), e.params
                    .history
                    .replaceState || g
                    .addEventListener(
                        "popstate", n)
            }
        },
        y = () => {
            const g = Ie();
            e.params.history
                .replaceState || g
                .removeEventListener(
                    "popstate", n)
        };
    i("init", () => {
        e.params.history
            .enabled && v()
    }), i("destroy", () => {
        e.params.history
            .enabled && y()
    }), i(
        "transitionEnd _freeModeNoMomentumRelease",
        () => {
            a && p(e.params.history
                .key, e
                .activeIndex)
        }), i("slideChange", () => {
        a && e.params.cssMode &&
            p(e.params.history
                .key, e
                .activeIndex)
    })
}

function li(u) {
    let {
        swiper: e,
        extendParams: t,
        emit: i,
        on: a
    } = u, o = !1;
    const h = we(),
        w = Ie();
    t({
        hashNavigation: {
            enabled: !1,
            replaceState: !1,
            watchState: !1,
            getSlideIndex(y,
            g) {
                if (e.virtual &&
                    e.params
                    .virtual
                    .enabled) {
                    const r = e
                        .slides
                        .find(
                            d =>
                            d
                            .getAttribute(
                                "data-hash"
                                ) ===
                            g);
                    return r ?
                        parseInt(
                            r
                            .getAttribute(
                                "data-swiper-slide-index"
                                ),
                            10
                            ) :
                        0
                }
                return e
                    .getSlideIndex(
                        ze(e.slidesEl,
                            `.${e.params.slideClass}[data-hash="${g}"], swiper-slide[data-hash="${g}"]`
                            )[0]
                        )
            }
        }
    });
    const p = () => {
            i("hashChange");
            const y = h.location.hash
                .replace("#", ""),
                g = e.virtual && e
                .params.virtual
                .enabled ? e.slidesEl
                .querySelector(
                    `[data-swiper-slide-index="${e.activeIndex}"]`
                    ) : e.slides[e
                    .activeIndex],
                r = g ? g.getAttribute(
                    "data-hash") : "";
            if (y !== r) {
                const s = e.params
                    .hashNavigation
                    .getSlideIndex(e,
                    y);
                if (typeof s > "u" ||
                    Number.isNaN(s))
                    return;
                e.slideTo(s)
            }
        },
        f = () => {
            if (!o || !e.params
                .hashNavigation.enabled)
                return;
            const y = e.virtual && e
                .params.virtual
                .enabled ? e.slidesEl
                .querySelector(
                    `[data-swiper-slide-index="${e.activeIndex}"]`
                    ) : e.slides[e
                    .activeIndex],
                g = y ? y.getAttribute(
                    "data-hash") || y
                .getAttribute(
                    "data-history") :
                "";
            e.params.hashNavigation
                .replaceState && w
                .history && w.history
                .replaceState ? (w
                    .history
                    .replaceState(null,
                        null, `#${g}` ||
                        ""), i(
                        "hashSet")) : (h
                    .location.hash =
                    g || "", i(
                        "hashSet"))
        },
        n = () => {
            if (!e.params.hashNavigation
                .enabled || e.params
                .history && e.params
                .history.enabled)
        return;
            o = !0;
            const y = h.location.hash
                .replace("#", "");
            if (y) {
                const r = e.params
                    .hashNavigation
                    .getSlideIndex(e,
                    y);
                e.slideTo(r || 0, 0, e
                    .params
                    .runCallbacksOnInit,
                    !0)
            }
            e.params.hashNavigation
                .watchState && w
                .addEventListener(
                    "hashchange", p)
        },
        v = () => {
            e.params.hashNavigation
                .watchState && w
                .removeEventListener(
                    "hashchange", p)
        };
    a("init", () => {
        e.params.hashNavigation
            .enabled && n()
    }), a("destroy", () => {
        e.params.hashNavigation
            .enabled && v()
    }), a(
        "transitionEnd _freeModeNoMomentumRelease",
        () => {
            o && f()
        }), a("slideChange", () => {
        o && e.params.cssMode &&
            f()
    })
}

function ci(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i,
        emit: a,
        params: o
    } = u;
    e.autoplay = {
        running: !1,
        paused: !1,
        timeLeft: 0
    }, t({
        autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !
                0,
            disableOnInteraction:
                !1,
            stopOnLastSlide: !1,
            reverseDirection: !
                1,
            pauseOnMouseEnter: !
                1
        }
    });
    let h, w, p = o && o.autoplay ? o
        .autoplay.delay : 3e3,
        f = o && o.autoplay ? o.autoplay
        .delay : 3e3,
        n, v = new Date().getTime(),
        y, g, r, s, d, m, l;

    function c(x) {
        !e || e.destroyed || !e
            .wrapperEl || x.target === e
            .wrapperEl && (e.wrapperEl
                .removeEventListener(
                    "transitionend", c),
                !(l || x.detail && x
                    .detail
                    .bySwiperTouchMove
                    ) && D())
    }
    const b = () => {
            if (e.destroyed || !e
                .autoplay.running)
                return;
            e.autoplay.paused ? y = !0 :
                y && (f = n, y = !1);
            const x = e.autoplay
                .paused ? n : v + f -
                new Date().getTime();
            e.autoplay.timeLeft = x, a(
                    "autoplayTimeLeft",
                    x, x / p), w =
                requestAnimationFrame(
                () => {
                        b()
                    })
        },
        A = () => {
            let x;
            return e.virtual && e.params
                .virtual.enabled ? x = e
                .slides.find(Y => Y
                    .classList.contains(
                        "swiper-slide-active"
                        )) : x = e
                .slides[e.activeIndex],
                x ? parseInt(x
                    .getAttribute(
                        "data-swiper-autoplay"
                        ), 10) : void 0
        },
        $ = x => {
            if (e.destroyed || !e
                .autoplay.running)
                return;
            cancelAnimationFrame(w),
        b();
            let H = typeof x > "u" ? e
                .params.autoplay.delay :
                x;
            p = e.params.autoplay.delay,
                f = e.params.autoplay
                .delay;
            const Y = A();
            !Number.isNaN(Y) && Y > 0 &&
                typeof x > "u" && (H =
                    Y, p = Y, f = Y),
                n = H;
            const K = e.params.speed,
                Z = () => {
                    !e || e.destroyed ||
                        (e.params
                            .autoplay
                            .reverseDirection ?
                            !e
                            .isBeginning ||
                            e.params
                            .loop || e
                            .params
                            .rewind ? (e
                                .slidePrev(
                                    K, !
                                    0, !
                                    0),
                                a(
                                    "autoplay")
                                ) : e
                            .params
                            .autoplay
                            .stopOnLastSlide ||
                            (e.slideTo(e
                                    .slides
                                    .length -
                                    1,
                                    K, !
                                    0, !
                                    0),
                                a(
                                    "autoplay")
                                ) : !e
                            .isEnd || e
                            .params
                            .loop || e
                            .params
                            .rewind ? (e
                                .slideNext(
                                    K, !
                                    0, !
                                    0),
                                a(
                                    "autoplay")
                                ) : e
                            .params
                            .autoplay
                            .stopOnLastSlide ||
                            (e.slideTo(
                                    0,
                                    K, !
                                    0, !
                                    0),
                                a(
                                    "autoplay")
                                ), e
                            .params
                            .cssMode &&
                            (v = new Date()
                                .getTime(),
                                requestAnimationFrame(
                                    () => {
                                        $()
                                    })))
                };
            return H > 0 ? (
                    clearTimeout(h), h =
                    setTimeout(() => {
                        Z()
                    }, H)) :
                requestAnimationFrame(
                () => {
                        Z()
                    }), H
        },
        I = () => {
            v = new Date().getTime(), e
                .autoplay.running = !0,
                $(), a("autoplayStart")
        },
        q = () => {
            e.autoplay.running = !1,
                clearTimeout(h),
                cancelAnimationFrame(w),
                a("autoplayStop")
        },
        E = (x, H) => {
            if (e.destroyed || !e
                .autoplay.running)
                return;
            clearTimeout(h), x || (m = !
                0);
            const Y = () => {
                a("autoplayPause"),
                    e.params
                    .autoplay
                    .waitForTransition ?
                    e.wrapperEl
                    .addEventListener(
                        "transitionend",
                        c) : D()
            };
            if (e.autoplay.paused = !0,
                H) {
                d && (n = e.params
                        .autoplay.delay
                        ), d = !1, Y();
                return
            }
            n = (n || e.params.autoplay
                .delay) - (
                new Date()
            .getTime() - v), !(e
                .isEnd && n < 0 && !
                e.params.loop) && (
                n < 0 && (n = 0),
                Y())
        },
        D = () => {
            e.isEnd && n < 0 && !e
                .params.loop || e
                .destroyed || !e
                .autoplay.running || (
                    v = new Date()
                    .getTime(), m ? (
                        m = !1, $(n)) :
                    $(), e.autoplay
                    .paused = !1, a(
                        "autoplayResume"
                        ))
        },
        O = () => {
            if (e.destroyed || !e
                .autoplay.running)
                return;
            const x = we();
            x.visibilityState ===
                "hidden" && (m = !0, E(!
                    0)), x
                .visibilityState ===
                "visible" && D()
        },
        _ = x => {
            x.pointerType === "mouse" &&
                (m = !0, l = !0, !(e
                    .animating || e
                    .autoplay.paused
                    ) && E(!0))
        },
        C = x => {
            x.pointerType === "mouse" &&
                (l = !1, e.autoplay
                    .paused && D())
        },
        T = () => {
            e.params.autoplay
                .pauseOnMouseEnter && (e
                    .el
                    .addEventListener(
                        "pointerenter",
                        _), e.el
                    .addEventListener(
                        "pointerleave",
                        C))
        },
        z = () => {
            e.el && typeof e.el !=
                "string" && (e.el
                    .removeEventListener(
                        "pointerenter",
                        _), e.el
                    .removeEventListener(
                        "pointerleave",
                        C))
        },
        R = () => {
            we().addEventListener(
                "visibilitychange",
                O)
        },
        S = () => {
            we().removeEventListener(
                "visibilitychange",
                O)
        };
    i("init", () => {
        e.params.autoplay
            .enabled && (T(),
            R(), I())
    }), i("destroy", () => {
        z(), S(), e.autoplay
            .running && q()
    }), i("_freeModeStaticRelease",
        () => {
            (r || m) && D()
        }), i(
        "_freeModeNoMomentumRelease",
        () => {
            e.params.autoplay
                .disableOnInteraction ?
                q() : E(!0, !0)
        }), i(
        "beforeTransitionStart", (x,
            H, Y) => {
            e.destroyed || !e
                .autoplay.running ||
                (Y || !e.params
                    .autoplay
                    .disableOnInteraction ?
                    E(!0, !0) : q())
        }), i("sliderFirstMove",
    () => {
            if (!(e.destroyed || !e
                    .autoplay
                    .running)) {
                if (e.params
                    .autoplay
                    .disableOnInteraction
                    ) {
                    q();
                    return
                }
                g = !0, r = !1,
                    m = !1, s =
                    setTimeout(
                () => {
                        m = !0,
                            r = !
                            0,
                            E(!
                                0)
                    }, 200)
            }
        }), i("touchEnd", () => {
        if (!(e.destroyed || !e
                .autoplay
                .running || !g
                )) {
            if (clearTimeout(s),
                clearTimeout(h),
                e.params
                .autoplay
                .disableOnInteraction
                ) {
                r = !1, g = !1;
                return
            }
            r && e.params
                .cssMode && D(),
                r = !1, g = !1
        }
    }), i("slideChange", () => {
        e.destroyed || !e
            .autoplay.running ||
            (d = !0)
    }), Object.assign(e.autoplay, {
        start: I,
        stop: q,
        pause: E,
        resume: D
    })
}

function di(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        thumbs: {
            swiper: null,
            multipleActiveThumbs:
                !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let a = !1,
        o = !1;
    e.thumbs = {
        swiper: null
    };

    function h() {
        const f = e.thumbs.swiper;
        if (!f || f.destroyed) return;
        const n = f.clickedIndex,
            v = f.clickedSlide;
        if (v && v.classList.contains(e
                .params.thumbs
                .slideThumbActiveClass
                ) || typeof n > "u" ||
            n === null) return;
        let y;
        f.params.loop ? y = parseInt(f
                .clickedSlide
                .getAttribute(
                    "data-swiper-slide-index"
                    ), 10) : y = n, e
            .params.loop ? e
            .slideToLoop(y) : e.slideTo(
                y)
    }

    function w() {
        const {
            thumbs: f
        } = e.params;
        if (a) return !1;
        a = !0;
        const n = e.constructor;
        if (f.swiper instanceof n) {
            if (f.swiper.destroyed)
                return a = !1, !1;
            e.thumbs.swiper = f.swiper,
                Object.assign(e.thumbs
                    .swiper
                    .originalParams, {
                        watchSlidesProgress:
                            !0,
                        slideToClickedSlide:
                            !1
                    }), Object.assign(e
                    .thumbs.swiper
                    .params, {
                        watchSlidesProgress:
                            !0,
                        slideToClickedSlide:
                            !1
                    }), e.thumbs.swiper
                .update()
        } else if (Ft(f.swiper)) {
            const v = Object.assign({},
                f.swiper);
            Object.assign(v, {
                    watchSlidesProgress:
                        !0,
                    slideToClickedSlide:
                        !1
                }), e.thumbs.swiper =
                new n(v), o = !0
        }
        return e.thumbs.swiper.el
            .classList.add(e.params
                .thumbs
                .thumbsContainerClass),
            e.thumbs.swiper.on("tap",
            h), !0
    }

    function p(f) {
        const n = e.thumbs.swiper;
        if (!n || n.destroyed) return;
        const v = n.params
            .slidesPerView === "auto" ?
            n.slidesPerViewDynamic() : n
            .params.slidesPerView;
        let y = 1;
        const g = e.params.thumbs
            .slideThumbActiveClass;
        if (e.params.slidesPerView >
            1 && !e.params
            .centeredSlides && (y = e
                .params.slidesPerView),
            e.params.thumbs
            .multipleActiveThumbs || (
                y = 1), y = Math.floor(
                y), n.slides.forEach(
                d => d.classList.remove(
                    g)), n.params
            .loop || n.params.virtual &&
            n.params.virtual.enabled)
            for (let d = 0; d < y; d +=
                1) ze(n.slidesEl,
                `[data-swiper-slide-index="${e.realIndex+d}"]`
                ).forEach(m => {
                m.classList.add(
                    g)
            });
        else
            for (let d = 0; d < y; d +=
                1) n.slides[e
                    .realIndex + d] && n
                .slides[e.realIndex + d]
                .classList.add(g);
        const r = e.params.thumbs
            .autoScrollOffset,
            s = r && !n.params.loop;
        if (e.realIndex !== n
            .realIndex || s) {
            const d = n.activeIndex;
            let m, l;
            if (n.params.loop) {
                const c = n.slides.find(
                    b => b
                    .getAttribute(
                        "data-swiper-slide-index"
                        ) ===
                    `${e.realIndex}`
                    );
                m = n.slides.indexOf(c),
                    l = e.activeIndex >
                    e.previousIndex ?
                    "next" : "prev"
            } else m = e.realIndex, l =
                m > e.previousIndex ?
                "next" : "prev";
            s && (m += l === "next" ?
                    r : -1 * r), n
                .visibleSlidesIndexes &&
                n.visibleSlidesIndexes
                .indexOf(m) < 0 && (n
                    .params
                    .centeredSlides ?
                    m > d ? m = m - Math
                    .floor(v / 2) + 1 :
                    m = m + Math.floor(
                        v / 2) - 1 : m >
                    d && n.params
                    .slidesPerGroup, n
                    .slideTo(m, f ? 0 :
                        void 0))
        }
    }
    i("beforeInit", () => {
        const {
            thumbs: f
        } = e.params;
        if (!(!f || !f.swiper))
            if (typeof f
                .swiper ==
                "string" || f
                .swiper instanceof HTMLElement
                ) {
                const n = we(),
                    v = () => {
                        const
                            g =
                            typeof f
                            .swiper ==
                            "string" ?
                            n
                            .querySelector(
                                f
                                .swiper
                                ) :
                            f
                            .swiper;
                        if (g &&
                            g
                            .swiper
                            ) f
                            .swiper =
                            g
                            .swiper,
                            w(),
                            p(!
                                0);
                        else if (
                            g) {
                            const
                                r =
                                `${e.params.eventsPrefix}init`,
                                s =
                                d => {
                                    f.swiper =
                                        d
                                        .detail[
                                            0
                                            ],
                                        g
                                        .removeEventListener(
                                            r,
                                            s
                                            ),
                                        w(),
                                        p(!
                                            0),
                                        f
                                        .swiper
                                        .update(),
                                        e
                                        .update()
                                };
                            g.addEventListener(
                                r,
                                s
                                )
                        }
                        return g
                    },
                    y = () => {
                        if (e
                            .destroyed
                            )
                            return;
                        v() ||
                            requestAnimationFrame(
                                y
                                )
                    };
                requestAnimationFrame
                    (y)
            } else w(), p(!0)
    }), i(
        "slideChange update resize observerUpdate",
        () => {
            p()
        }), i("setTransition", (f,
        n) => {
        const v = e.thumbs
            .swiper;
        !v || v.destroyed || v
            .setTransition(n)
    }), i("beforeDestroy", () => {
        const f = e.thumbs
            .swiper;
        !f || f.destroyed ||
            o && f.destroy()
    }), Object.assign(e.thumbs, {
        init: w,
        update: p
    })
}

function pi(u) {
    let {
        swiper: e,
        extendParams: t,
        emit: i,
        once: a
    } = u;
    t({
        freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: .02
        }
    });

    function o() {
        if (e.params.cssMode) return;
        const p = e.getTranslate();
        e.setTranslate(p), e
            .setTransition(0), e
            .touchEventsData.velocities
            .length = 0, e.freeMode
            .onTouchEnd({
                currentPos: e.rtl ?
                    e.translate : -e
                    .translate
            })
    }

    function h() {
        if (e.params.cssMode) return;
        const {
            touchEventsData: p,
            touches: f
        } = e;
        p.velocities.length === 0 && p
            .velocities.push({
                position: f[e
                    .isHorizontal() ?
                    "startX" :
                    "startY"],
                time: p
                    .touchStartTime
            }), p.velocities.push({
                position: f[e
                    .isHorizontal() ?
                    "currentX" :
                    "currentY"],
                time: Pe()
            })
    }

    function w(p) {
        let {
            currentPos: f
        } = p;
        if (e.params.cssMode) return;
        const {
            params: n,
            wrapperEl: v,
            rtlTranslate: y,
            snapGrid: g,
            touchEventsData: r
        } = e, d = Pe() - r
            .touchStartTime;
        if (f < -e.minTranslate()) {
            e.slideTo(e.activeIndex);
            return
        }
        if (f > -e.maxTranslate()) {
            e.slides.length < g.length ?
                e.slideTo(g.length -
                1) : e.slideTo(e.slides
                    .length - 1);
            return
        }
        if (n.freeMode.momentum) {
            if (r.velocities.length >
                1) {
                const q = r.velocities
                    .pop(),
                    E = r.velocities
                    .pop(),
                    D = q.position - E
                    .position,
                    O = q.time - E.time;
                e.velocity = D / O, e
                    .velocity /= 2, Math
                    .abs(e.velocity) < n
                    .freeMode
                    .minimumVelocity &&
                    (e.velocity = 0), (
                        O > 150 ||
                    Pe() - q.time > 300
                        ) && (e
                        .velocity = 0)
            } else e.velocity = 0;
            e.velocity *= n.freeMode
                .momentumVelocityRatio,
                r.velocities.length = 0;
            let m = 1e3 * n.freeMode
                .momentumRatio;
            const l = e.velocity * m;
            let c = e.translate + l;
            y && (c = -c);
            let b = !1,
                A;
            const $ = Math.abs(e
                    .velocity) * 20 * n
                .freeMode
                .momentumBounceRatio;
            let I;
            if (c < e.maxTranslate()) n
                .freeMode
                .momentumBounce ? (c + e
                    .maxTranslate() < -
                    $ && (c = e
                        .maxTranslate() -
                        $), A = e
                    .maxTranslate(),
                    b = !0, r
                    .allowMomentumBounce = !
                    0) : c = e
                .maxTranslate(), n
                .loop && n
                .centeredSlides && (
                    I = !0);
            else if (c > e
                .minTranslate()) n
                .freeMode
                .momentumBounce ? (c - e
                    .minTranslate() >
                    $ && (c = e
                        .minTranslate() +
                        $), A = e
                    .minTranslate(),
                    b = !0, r
                    .allowMomentumBounce = !
                    0) : c = e
                .minTranslate(), n
                .loop && n
                .centeredSlides && (
                    I = !0);
            else if (n.freeMode
                .sticky) {
                let q;
                for (let E = 0; E < g
                    .length; E += 1)
                    if (g[E] > -c) {
                        q = E;
                        break
                    } Math.abs(g[q] -
                    c) < Math.abs(g[q -
                        1] - c) || e
                    .swipeDirection ===
                    "next" ? c = g[q] :
                    c = g[q - 1], c = -c
            }
            if (I && a("transitionEnd",
                    () => {
                        e.loopFix()
                    }), e.velocity !==
                0) {
                if (y ? m = Math.abs((-
                            c - e
                            .translate
                            ) / e
                        .velocity) : m =
                    Math.abs((c - e
                            .translate
                            ) / e
                        .velocity), n
                    .freeMode.sticky) {
                    const q = Math.abs((
                                y ? -c :
                                c) - e
                            .translate),
                        E = e
                        .slidesSizesGrid[
                            e
                            .activeIndex
                            ];
                    q < E ? m = n
                        .speed : q < 2 *
                        E ? m = n
                        .speed * 1.5 :
                        m = n.speed *
                        2.5
                }
            } else if (n.freeMode
                .sticky) {
                e.slideToClosest();
                return
            }
            n.freeMode.momentumBounce &&
                b ? (e.updateProgress(
                    A), e.setTransition(
                        m), e
                    .setTranslate(c), e
                    .transitionStart(!0,
                        e.swipeDirection
                        ), e
                    .animating = !0, Je(
                        v, () => {
                            !e || e
                                .destroyed ||
                                !r
                                .allowMomentumBounce ||
                                (i("momentumBounce"),
                                    e
                                    .setTransition(
                                        n
                                        .speed
                                        ),
                                    setTimeout(
                                        () => {
                                            e.setTranslate(
                                                    A
                                                    ),
                                                Je(v,
                                                    () => {
                                                        !
                                                        e || e
                                                            .destroyed ||
                                                            e
                                                            .transitionEnd()
                                                    }
                                                    )
                                        },
                                        0
                                        )
                                    )
                        })) : e
                .velocity ? (i(
                        "_freeModeNoMomentumRelease"
                        ), e
                    .updateProgress(c),
                    e.setTransition(m),
                    e.setTranslate(c), e
                    .transitionStart(!0,
                        e.swipeDirection
                        ), e
                    .animating || (e
                        .animating = !0,
                        Je(v, () => {
                            !e || e
                                .destroyed ||
                                e
                                .transitionEnd()
                        }))) : e
                .updateProgress(c), e
                .updateActiveIndex(), e
                .updateSlidesClasses()
        } else if (n.freeMode.sticky) {
            e.slideToClosest();
            return
        } else n.freeMode && i(
            "_freeModeNoMomentumRelease"
            );
        (!n.freeMode.momentum || d >= n
            .longSwipesMs) && (i(
                "_freeModeStaticRelease"
                ), e.updateProgress(), e
            .updateActiveIndex(), e
            .updateSlidesClasses())
    }
    Object.assign(e, {
        freeMode: {
            onTouchStart: o,
            onTouchMove: h,
            onTouchEnd: w
        }
    })
}

function ui(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let a, o, h, w;
    const p = () => {
            let s = e.params
                .spaceBetween;
            return typeof s ==
                "string" && s.indexOf(
                    "%") >= 0 ? s =
                parseFloat(s.replace(
                    "%", "")) / 100 * e
                .size : typeof s ==
                "string" && (s =
                    parseFloat(s)), s
        },
        f = s => {
            const {
                slidesPerView: d
            } = e.params, {
                    rows: m,
                    fill: l
                } = e.params.grid, c = e
                .virtual && e.params
                .virtual.enabled ? e
                .virtual.slides.length :
                s.length;
            h = Math.floor(c / m), Math
                .floor(c / m) === c /
                m ? a = c : a = Math
                .ceil(c / m) * m, d !==
                "auto" && l === "row" &&
                (a = Math.max(a, d *
                m)), o = a / m
        },
        n = () => {
            e.slides && e.slides
                .forEach(s => {
                    s.swiperSlideGridSet &&
                        (s.style
                            .height =
                            "", s
                            .style[e
                                .getDirectionLabel(
                                    "margin-top"
                                    )
                                ] =
                            "")
                })
        },
        v = (s, d, m) => {
            const {
                slidesPerGroup: l
            } = e.params, c = p(), {
                    rows: b,
                    fill: A
                } = e.params.grid, $ = e
                .virtual && e.params
                .virtual.enabled ? e
                .virtual.slides.length :
                m.length;
            let I, q, E;
            if (A === "row" && l > 1) {
                const D = Math.floor(s /
                        (l * b)),
                    O = s - b * l * D,
                    _ = D === 0 ? l :
                    Math.min(Math.ceil((
                            $ - D *
                            b * l) /
                        b), l);
                E = Math.floor(O / _),
                    q = O - E * _ + D *
                    l, I = q + E * a /
                    b, d.style.order = I
            } else A === "column" ? (q =
                Math.floor(s / b),
                E = s - q * b, (q >
                    h || q === h &&
                    E === b - 1) &&
                (E += 1, E >= b && (
                    E = 0, q +=
                    1))) : (E = Math
                .floor(s / o), q =
                s - E * o);
            d.row = E, d.column = q, d
                .style.height =
                `calc((100% - ${(b-1)*c}px) / ${b})`,
                d.style[e
                    .getDirectionLabel(
                        "margin-top")] =
                E !== 0 ? c &&
                `${c}px` : "", d
                .swiperSlideGridSet = !0
        },
        y = (s, d) => {
            const {
                centeredSlides: m,
                roundLengths: l
            } = e.params, c = p(), {
                rows: b
            } = e.params.grid;
            if (e.virtualSize = (s +
                c) * a, e.virtualSize =
                Math.ceil(e
                    .virtualSize / b) -
                c, e.params.cssMode || (
                    e.wrapperEl.style[e
                        .getDirectionLabel(
                            "width")] =
                    `${e.virtualSize+c}px`
                    ), m) {
                const A = [];
                for (let $ = 0; $ < d
                    .length; $ += 1) {
                    let I = d[$];
                    l && (I = Math
                            .floor(I)),
                        d[$] < e
                        .virtualSize +
                        d[0] && A.push(
                            I)
                }
                d.splice(0, d.length), d
                    .push(...A)
            }
        },
        g = () => {
            w = e.params.grid && e
                .params.grid.rows > 1
        },
        r = () => {
            const {
                params: s,
                el: d
            } = e, m = s.grid && s.grid
                .rows > 1;
            w && !m ? (d.classList
                .remove(
                    `${s.containerModifierClass}grid`,
                    `${s.containerModifierClass}grid-column`
                    ), h = 1, e
                .emitContainerClasses()
                ) : !w && m && (d
                .classList.add(
                    `${s.containerModifierClass}grid`
                    ), s.grid
                .fill ===
                "column" && d
                .classList.add(
                    `${s.containerModifierClass}grid-column`
                    ), e
                .emitContainerClasses()
                ), w = m
        };
    i("init", g), i("update", r), e
        .grid = {
            initSlides: f,
            unsetSlides: n,
            updateSlide: v,
            updateWrapperSize: y
        }
}

function fi(u) {
    const e = this,
        {
            params: t,
            slidesEl: i
        } = e;
    t.loop && e.loopDestroy();
    const a = o => {
        if (typeof o == "string") {
            const h = document
                .createElement(
                    "div");
            ce(h, o), i.append(h
                    .children[0]),
                ce(h, "")
        } else i.append(o)
    };
    if (typeof u == "object" &&
        "length" in u)
        for (let o = 0; o < u
            .length; o += 1) u[o] && a(
            u[o]);
    else a(u);
    e.recalcSlides(), t.loop && e
        .loopCreate(), (!t.observer || e
            .isElement) && e.update()
}

function hi(u) {
    const e = this,
        {
            params: t,
            activeIndex: i,
            slidesEl: a
        } = e;
    t.loop && e.loopDestroy();
    let o = i + 1;
    const h = w => {
        if (typeof w == "string") {
            const p = document
                .createElement(
                    "div");
            ce(p, w), a.prepend(p
                    .children[0]),
                ce(p, "")
        } else a.prepend(w)
    };
    if (typeof u == "object" &&
        "length" in u) {
        for (let w = 0; w < u
            .length; w += 1) u[w] && h(
            u[w]);
        o = i + u.length
    } else h(u);
    e.recalcSlides(), t.loop && e
        .loopCreate(), (!t.observer || e
            .isElement) && e.update(), e
        .slideTo(o, 0, !1)
}

function mi(u, e) {
    const t = this,
        {
            params: i,
            activeIndex: a,
            slidesEl: o
        } = t;
    let h = a;
    i.loop && (h -= t.loopedSlides, t
        .loopDestroy(), t
        .recalcSlides());
    const w = t.slides.length;
    if (u <= 0) {
        t.prependSlide(e);
        return
    }
    if (u >= w) {
        t.appendSlide(e);
        return
    }
    let p = h > u ? h + 1 : h;
    const f = [];
    for (let n = w - 1; n >= u; n -=
        1) {
        const v = t.slides[n];
        v.remove(), f.unshift(v)
    }
    if (typeof e == "object" &&
        "length" in e) {
        for (let n = 0; n < e
            .length; n += 1) e[n] && o
            .append(e[n]);
        p = h > u ? h + e.length : h
    } else o.append(e);
    for (let n = 0; n < f.length; n +=
        1) o.append(f[n]);
    t.recalcSlides(), i.loop && t
        .loopCreate(), (!i.observer || t
            .isElement) && t.update(), i
        .loop ? t.slideTo(p + t
            .loopedSlides, 0, !1) : t
        .slideTo(p, 0, !1)
}

function gi(u) {
    const e = this,
        {
            params: t,
            activeIndex: i
        } = e;
    let a = i;
    t.loop && (a -= e.loopedSlides, e
        .loopDestroy());
    let o = a,
        h;
    if (typeof u == "object" &&
        "length" in u) {
        for (let w = 0; w < u
            .length; w += 1) h = u[w], e
            .slides[h] && e.slides[h]
            .remove(), h < o && (o -=
            1);
        o = Math.max(o, 0)
    } else h = u, e.slides[h] && e
        .slides[h].remove(), h < o && (
            o -= 1), o = Math.max(o, 0);
    e.recalcSlides(), t.loop && e
        .loopCreate(), (!t.observer || e
            .isElement) && e.update(), t
        .loop ? e.slideTo(o + e
            .loopedSlides, 0, !1) : e
        .slideTo(o, 0, !1)
}

function wi() {
    const u = this,
        e = [];
    for (let t = 0; t < u.slides
        .length; t += 1) e.push(t);
    u.removeSlide(e)
}

function vi(u) {
    let {
        swiper: e
    } = u;
    Object.assign(e, {
        appendSlide: fi.bind(e),
        prependSlide: hi.bind(
            e),
        addSlide: mi.bind(e),
        removeSlide: gi.bind(e),
        removeAllSlides: wi
            .bind(e)
    })
}

function Ue(u) {
    const {
        effect: e,
        swiper: t,
        on: i,
        setTranslate: a,
        setTransition: o,
        overwriteParams: h,
        perspective: w,
        recreateShadows: p,
        getEffectParams: f
    } = u;
    i("beforeInit", () => {
        if (t.params.effect !==
            e) return;
        t.classNames.push(
                `${t.params.containerModifierClass}${e}`
                ), w && w() && t
            .classNames.push(
                `${t.params.containerModifierClass}3d`
                );
        const v = h ? h() : {};
        Object.assign(t.params,
                v), Object
            .assign(t
                .originalParams,
                v)
    }), i(
        "setTranslate _virtualUpdated",
        () => {
            t.params.effect === e &&
                a()
        }), i("setTransition", (v,
        y) => {
        t.params.effect === e &&
            o(y)
    }), i("transitionEnd", () => {
        if (t.params.effect ===
            e && p) {
            if (!f || !f()
                .slideShadows)
                return;
            t.slides.forEach(
                v => {
                    v.querySelectorAll(
                            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                            )
                        .forEach(
                            y =>
                            y
                            .remove()
                            )
                }), p()
        }
    });
    let n;
    i("virtualUpdate", () => {
        t.params.effect === e &&
            (t.slides.length ||
                (n = !0),
                requestAnimationFrame(
                    () => {
                        n && t
                            .slides &&
                            t
                            .slides
                            .length &&
                            (a(),
                                n = !
                                1
                                )
                    }))
    })
}

function Ze(u, e) {
    const t = Ne(e);
    return t !== e && (t.style
        .backfaceVisibility =
        "hidden", t.style[
            "-webkit-backface-visibility"
            ] = "hidden"), t
}

function dt(u) {
    let {
        swiper: e,
        duration: t,
        transformElements: i,
        allSlides: a
    } = u;
    const {
        activeIndex: o
    } = e, h = w => w.parentElement ? w
        .parentElement : e.slides.find(
            f => f.shadowRoot && f
            .shadowRoot === w.parentNode
            );
    if (e.params.virtualTranslate &&
        t !== 0) {
        let w = !1,
            p;
        a ? p = i : p = i.filter(f => {
            const n = f
                .classList
                .contains(
                    "swiper-slide-transform"
                    ) ? h(f) :
                f;
            return e
                .getSlideIndex(
                    n) === o
        }), p.forEach(f => {
            Je(f, () => {
                if (w ||
                    !
                    e ||
                    e
                    .destroyed
                    )
                    return;
                w = !0,
                    e
                    .animating = !
                    1;
                const
                    n =
                    new window
                    .CustomEvent(
                        "transitionend", {
                            bubbles:
                                !
                                0,
                            cancelable:
                                !
                                0
                        }
                        );
                e.wrapperEl
                    .dispatchEvent(
                        n
                        )
            })
        })
    }
}

function bi(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        fadeEffect: {
            crossFade: !1
        }
    }), Ue({
        effect: "fade",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                slides: h
            } = e, w = e
                .params
                .fadeEffect;
            for (let p =
                0; p < h
                .length; p +=
                1) {
                const f = e
                    .slides[
                        p];
                let v = -f
                    .swiperSlideOffset;
                e.params
                    .virtualTranslate ||
                    (v -= e
                        .translate
                        );
                let y = 0;
                e.isHorizontal() ||
                    (y = v,
                        v =
                        0);
                const g = e
                    .params
                    .fadeEffect
                    .crossFade ?
                    Math
                    .max(1 -
                        Math
                        .abs(
                            f
                            .progress
                            ),
                        0) :
                    1 + Math
                    .min(
                        Math
                        .max(
                            f
                            .progress,
                            -
                            1
                            ),
                        0),
                    r = Ze(
                        w, f
                        );
                r.style
                    .opacity =
                    g, r
                    .style
                    .transform =
                    `translate3d(${v}px, ${y}px, 0px)`
            }
        },
        setTransition: h => {
            const w = e
                .slides.map(
                    p => Ne(
                        p));
            w.forEach(p => {
                p.style
                    .transitionDuration =
                    `${h}ms`
            }), dt({
                swiper: e,
                duration: h,
                transformElements: w,
                allSlides:
                    !
                    0
            })
        },
        overwriteParams: () =>
    ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress:
                !0,
            spaceBetween: 0,
            virtualTranslate:
                !e
                .params
                .cssMode
        })
    })
}

function yi(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        cubeEffect: {
            slideShadows: !0,
            shadow: !0,
            shadowOffset: 20,
            shadowScale: .94
        }
    });
    const a = (p, f, n) => {
        let v = n ? p.querySelector(
                ".swiper-slide-shadow-left"
                ) : p.querySelector(
                ".swiper-slide-shadow-top"
                ),
            y = n ? p.querySelector(
                ".swiper-slide-shadow-right"
                ) : p.querySelector(
                ".swiper-slide-shadow-bottom"
                );
        v || (v = ge("div",
                    `swiper-slide-shadow-cube swiper-slide-shadow-${n?"left":"top"}`
                    .split(" ")), p
                .append(v)), y || (
                y = ge("div",
                    `swiper-slide-shadow-cube swiper-slide-shadow-${n?"right":"bottom"}`
                    .split(" ")), p
                .append(y)), v && (v
                .style.opacity =
                Math.max(-f, 0)),
            y && (y.style.opacity =
                Math.max(f, 0))
    };
    Ue({
        effect: "cube",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                el: p,
                wrapperEl: f,
                slides: n,
                width: v,
                height: y,
                rtlTranslate: g,
                size: r,
                browser: s
            } = e, d = ct(
                e), m = e
                .params
                .cubeEffect,
                l = e
                .isHorizontal(),
                c = e
                .virtual &&
                e.params
                .virtual
                .enabled;
            let b = 0,
                A;
            m.shadow && (l ?
                (A = e
                    .wrapperEl
                    .querySelector(
                        ".swiper-cube-shadow"
                        ),
                    A ||
                    (A = ge("div",
                            "swiper-cube-shadow"
                            ),
                        e
                        .wrapperEl
                        .append(
                            A
                            )
                        ),
                    A
                    .style
                    .height =
                    `${v}px`
                    ) :
                (A = p
                    .querySelector(
                        ".swiper-cube-shadow"
                        ),
                    A ||
                    (A = ge("div",
                            "swiper-cube-shadow"
                            ),
                        p
                        .append(
                            A
                            )
                        )
                    ));
            for (let I =
                0; I < n
                .length; I +=
                1) {
                const q = n[
                    I];
                let E = I;
                c && (E =
                    parseInt(
                        q
                        .getAttribute(
                            "data-swiper-slide-index"
                            ),
                        10
                        )
                    );
                let D = E *
                    90,
                    O = Math
                    .floor(
                        D /
                        360
                        );
                g && (D = -
                    D,
                    O =
                    Math
                    .floor(
                        -
                        D /
                        360
                        )
                    );
                const _ =
                    Math
                    .max(
                        Math
                        .min(
                            q
                            .progress,
                            1
                            ),
                        -1);
                let C = 0,
                    T = 0,
                    z = 0;
                E % 4 ===
                    0 ? (
                        C = -
                        O *
                        4 *
                        r,
                        z =
                        0) :
                    (E -
                    1) %
                    4 ===
                    0 ? (C =
                        0,
                        z = -
                        O *
                        4 *
                        r) :
                    (E -
                    2) %
                    4 ===
                    0 ? (C =
                        r +
                        O *
                        4 *
                        r,
                        z =
                        r) :
                    (E -
                    3) %
                    4 ===
                    0 && (
                        C = -
                        r,
                        z =
                        3 *
                        r +
                        r *
                        4 *
                        O),
                    g && (
                        C = -
                        C),
                    l || (
                        T =
                        C,
                        C =
                        0);
                const R =
                    `rotateX(${d(l?0:-D)}deg) rotateY(${d(l?D:0)}deg) translate3d(${C}px, ${T}px, ${z}px)`;
                _ <= 1 &&
                    _ > -
                    1 && (
                        b =
                        E *
                        90 +
                        _ *
                        90,
                        g &&
                        (b = -
                            E *
                            90 -
                            _ *
                            90
                            )
                        ), q
                    .style
                    .transform =
                    R, m
                    .slideShadows &&
                    a(q, _,
                        l)
            }
            if (f.style
                .transformOrigin =
                `50% 50% -${r/2}px`,
                f.style[
                    "-webkit-transform-origin"
                    ] =
                `50% 50% -${r/2}px`,
                m.shadow)
                if (l) A
                    .style
                    .transform =
                    `translate3d(0px, ${v/2+m.shadowOffset}px, ${-v/2}px) rotateX(89.99deg) rotateZ(0deg) scale(${m.shadowScale})`;
                else {
                    const
                        I =
                        Math
                        .abs(
                            b
                            ) -
                        Math
                        .floor(
                            Math
                            .abs(
                                b
                                ) /
                            90
                            ) *
                        90,
                        q =
                        1.5 -
                        (Math
                            .sin(
                                I *
                                2 *
                                Math
                                .PI /
                                360
                                ) /
                            2 +
                            Math
                            .cos(
                                I *
                                2 *
                                Math
                                .PI /
                                360
                                ) /
                            2
                            ),
                        E =
                        m
                        .shadowScale,
                        D =
                        m
                        .shadowScale /
                        q,
                        O =
                        m
                        .shadowOffset;
                    A.style
                        .transform =
                        `scale3d(${E}, 1, ${D}) translate3d(0px, ${y/2+O}px, ${-y/2/D}px) rotateX(-89.99deg)`
                } const $ =
                (s.isSafari ||
                    s
                    .isWebView
                    ) && s
                .needPerspectiveFix ?
                -r / 2 : 0;
            f.style
                .transform =
                `translate3d(0px,0,${$}px) rotateX(${d(e.isHorizontal()?0:b)}deg) rotateY(${d(e.isHorizontal()?-b:0)}deg)`,
                f.style
                .setProperty(
                    "--swiper-cube-translate-z",
                    `${$}px`
                    )
        },
        setTransition: p => {
            const {
                el: f,
                slides: n
            } = e;
            if (n.forEach(
                    v => {
                        v.style
                            .transitionDuration =
                            `${p}ms`,
                            v
                            .querySelectorAll(
                                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                )
                            .forEach(
                                y => {
                                    y.style
                                        .transitionDuration =
                                        `${p}ms`
                                }
                                )
                    }), e
                .params
                .cubeEffect
                .shadow && !
                e
                .isHorizontal()
                ) {
                const v = f
                    .querySelector(
                        ".swiper-cube-shadow"
                        );
                v && (v.style
                    .transitionDuration =
                    `${p}ms`
                    )
            }
        },
        recreateShadows: () => {
            const p = e
                .isHorizontal();
            e.slides
                .forEach(
                    f => {
                        const
                            n =
                            Math
                            .max(
                                Math
                                .min(
                                    f
                                    .progress,
                                    1
                                    ),
                                -
                                1
                                );
                        a(f, n,
                            p)
                    })
        },
        getEffectParams: () => e
            .params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () =>
    ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress:
                !0,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides:
                !1,
            virtualTranslate:
                !0
        })
    })
}

function Ge(u, e, t) {
    const i =
        `swiper-slide-shadow${t?`-${t}`:""}${u?` swiper-slide-shadow-${u}`:""}`,
        a = Ne(e);
    let o = a.querySelector(
        `.${i.split(" ").join(".")}`
        );
    return o || (o = ge("div", i.split(
        " ")), a.append(o)), o
}

function Ei(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        flipEffect: {
            slideShadows: !0,
            limitRotation: !0
        }
    });
    const a = (p, f) => {
        let n = e.isHorizontal() ? p
            .querySelector(
                ".swiper-slide-shadow-left"
                ) : p.querySelector(
                ".swiper-slide-shadow-top"
                ),
            v = e.isHorizontal() ? p
            .querySelector(
                ".swiper-slide-shadow-right"
                ) : p.querySelector(
                ".swiper-slide-shadow-bottom"
                );
        n || (n = Ge("flip", p, e
                .isHorizontal() ?
                "left" : "top")),
            v || (v = Ge("flip", p,
                e
            .isHorizontal() ?
                "right" :
                "bottom")), n && (n
                .style.opacity =
                Math.max(-f, 0)),
            v && (v.style.opacity =
                Math.max(f, 0))
    };
    Ue({
        effect: "flip",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                slides: p,
                rtlTranslate: f
            } = e, n = e
                .params
                .flipEffect,
                v = ct(e);
            for (let y =
                0; y < p
                .length; y +=
                1) {
                const g = p[
                    y];
                let r = g
                    .progress;
                e.params
                    .flipEffect
                    .limitRotation &&
                    (r = Math
                        .max(
                            Math
                            .min(
                                g
                                .progress,
                                1
                                ),
                            -
                            1
                            )
                        );
                const s = g
                    .swiperSlideOffset;
                let m = -
                    180 * r,
                    l = 0,
                    c = e
                    .params
                    .cssMode ?
                    -s - e
                    .translate :
                    -s,
                    b = 0;
                e.isHorizontal() ?
                    f && (
                        m = -
                        m) :
                    (b = c,
                        c =
                        0,
                        l = -
                        m,
                        m =
                        0),
                    g.style
                    .zIndex = -
                    Math
                    .abs(
                        Math
                        .round(
                            r
                            )
                        ) +
                    p
                    .length,
                    n
                    .slideShadows &&
                    a(g, r);
                const A =
                    `translate3d(${c}px, ${b}px, 0px) rotateX(${v(l)}deg) rotateY(${v(m)}deg)`,
                    $ = Ze(
                        n, g
                        );
                $.style
                    .transform =
                    A
            }
        },
        setTransition: p => {
            const f = e
                .slides.map(
                    n => Ne(
                        n));
            f.forEach(n => {
                n.style
                    .transitionDuration =
                    `${p}ms`,
                    n
                    .querySelectorAll(
                        ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                        )
                    .forEach(
                        v => {
                            v.style
                                .transitionDuration =
                                `${p}ms`
                        }
                        )
            }), dt({
                swiper: e,
                duration: p,
                transformElements: f
            })
        },
        recreateShadows: () => {
            e.params
                .flipEffect,
                e.slides
                .forEach(
                    p => {
                        let f =
                            p
                            .progress;
                        e.params
                            .flipEffect
                            .limitRotation &&
                            (f = Math
                                .max(
                                    Math
                                    .min(
                                        p
                                        .progress,
                                        1
                                        ),
                                    -
                                    1
                                    )
                                ),
                            a(p,
                                f)
                    })
        },
        getEffectParams: () => e
            .params.flipEffect,
        perspective: () => !0,
        overwriteParams: () =>
    ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress:
                !0,
            spaceBetween: 0,
            virtualTranslate:
                !e
                .params
                .cssMode
        })
    })
}

function Si(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: !0
        }
    }), Ue({
        effect: "coverflow",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                width: h,
                height: w,
                slides: p,
                slidesSizesGrid: f
            } = e, n = e
                .params
                .coverflowEffect,
                v = e
                .isHorizontal(),
                y = e
                .translate,
                g = v ? -y +
                h / 2 : -y +
                w / 2, r =
                v ? n
                .rotate : -n
                .rotate, s =
                n.depth, d =
                ct(e);
            for (let m = 0,
                    l = p
                    .length; m <
                l; m += 1) {
                const c = p[
                        m],
                    b = f[
                    m],
                    A = c
                    .swiperSlideOffset,
                    $ = (g -
                        A -
                        b /
                        2) /
                    b,
                    I =
                    typeof n
                    .modifier ==
                    "function" ?
                    n
                    .modifier(
                        $) :
                    $ * n
                    .modifier;
                let q = v ?
                    r * I :
                    0,
                    E = v ?
                    0 : r *
                    I,
                    D = -s *
                    Math
                    .abs(I),
                    O = n
                    .stretch;
                typeof O ==
                    "string" &&
                    O
                    .indexOf(
                        "%"
                        ) !==
                    -1 && (
                        O =
                        parseFloat(
                            n
                            .stretch
                            ) /
                        100 *
                        b);
                let _ = v ?
                    0 : O *
                    I,
                    C = v ?
                    O * I :
                    0,
                    T = 1 -
                    (1 - n
                        .scale
                        ) *
                    Math
                    .abs(I);
                Math.abs(
                    C) <
                    .001 &&
                    (C = 0),
                    Math
                    .abs(
                    _) <
                    .001 &&
                    (_ = 0),
                    Math
                    .abs(
                    D) <
                    .001 &&
                    (D = 0),
                    Math
                    .abs(
                    q) <
                    .001 &&
                    (q = 0),
                    Math
                    .abs(
                    E) <
                    .001 &&
                    (E = 0),
                    Math
                    .abs(
                    T) <
                    .001 &&
                    (T = 0);
                const z =
                    `translate3d(${C}px,${_}px,${D}px)  rotateX(${d(E)}deg) rotateY(${d(q)}deg) scale(${T})`,
                    R = Ze(
                        n, c
                        );
                if (R.style
                    .transform =
                    z, c
                    .style
                    .zIndex = -
                    Math
                    .abs(
                        Math
                        .round(
                            I
                            )
                        ) +
                    1, n
                    .slideShadows
                    ) {
                    let S =
                        v ?
                        c
                        .querySelector(
                            ".swiper-slide-shadow-left"
                            ) :
                        c
                        .querySelector(
                            ".swiper-slide-shadow-top"
                            ),
                        x =
                        v ?
                        c
                        .querySelector(
                            ".swiper-slide-shadow-right"
                            ) :
                        c
                        .querySelector(
                            ".swiper-slide-shadow-bottom"
                            );
                    S || (S =
                            Ge("coverflow",
                                c,
                                v ?
                                "left" :
                                "top"
                                )
                            ),
                        x ||
                        (x = Ge("coverflow",
                            c,
                            v ?
                            "right" :
                            "bottom"
                            )),
                        S &&
                        (S.style
                            .opacity =
                            I >
                            0 ?
                            I :
                            0
                            ),
                        x &&
                        (x.style
                            .opacity = -
                            I >
                            0 ?
                            -
                            I :
                            0
                            )
                }
            }
        },
        setTransition: h => {
            e.slides.map(
                    p => Ne(
                        p))
                .forEach(
                    p => {
                        p.style
                            .transitionDuration =
                            `${h}ms`,
                            p
                            .querySelectorAll(
                                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                )
                            .forEach(
                                f => {
                                    f.style
                                        .transitionDuration =
                                        `${h}ms`
                                }
                                )
                    })
        },
        perspective: () => !0,
        overwriteParams: () =>
    ({
            watchSlidesProgress:
                !0
        })
    })
}

function xi(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: !
                1,
            progressMultiplier: 1,
            perspective: !0,
            prev: {
                translate: [0,
                    0, 0
                ],
                rotate: [0, 0,
                    0],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [0,
                    0, 0
                ],
                rotate: [0, 0,
                    0],
                opacity: 1,
                scale: 1
            }
        }
    });
    const a = w => typeof w ==
        "string" ? w : `${w}px`;
    Ue({
        effect: "creative",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                slides: w,
                wrapperEl: p,
                slidesSizesGrid: f
            } = e, n = e
                .params
                .creativeEffect, {
                    progressMultiplier: v
                } = n, y = e
                .params
                .centeredSlides,
                g = ct(e);
            if (y) {
                const r = f[
                        0] /
                    2 - e
                    .params
                    .slidesOffsetBefore ||
                    0;
                p.style
                    .transform =
                    `translateX(calc(50% - ${r}px))`
            }
            for (let r =
                0; r < w
                .length; r +=
                1) {
                const s = w[
                        r],
                    d = s
                    .progress,
                    m = Math
                    .min(
                        Math
                        .max(
                            s
                            .progress,
                            -
                            n
                            .limitProgress
                            ),
                        n
                        .limitProgress
                        );
                let l = m;
                y || (l =
                    Math
                    .min(
                        Math
                        .max(
                            s
                            .originalProgress,
                            -
                            n
                            .limitProgress
                            ),
                        n
                        .limitProgress
                        )
                    );
                const c = s
                    .swiperSlideOffset,
                    b = [e
                        .params
                        .cssMode ?
                        -c -
                        e
                        .translate :
                        -c,
                        0, 0
                    ],
                    A = [0,
                        0, 0
                    ];
                let $ = !1;
                e.isHorizontal() ||
                    (b[1] =
                        b[
                        0],
                        b[
                        0] =
                        0);
                let I = {
                    translate: [
                        0,
                        0,
                        0
                    ],
                    rotate: [
                        0,
                        0,
                        0
                    ],
                    scale: 1,
                    opacity: 1
                };
                m < 0 ? (I =
                        n
                        .next,
                        $ = !
                        0) :
                    m > 0 &&
                    (I = n
                        .prev,
                        $ = !
                        0),
                    b
                    .forEach(
                        (T,
                            z) => {
                            b[z] =
                                `calc(${T}px + (${a(I.translate[z])} * ${Math.abs(m*v)}))`
                        }),
                    A
                    .forEach(
                        (T,
                            z) => {
                            let R =
                                I
                                .rotate[
                                    z
                                    ] *
                                Math
                                .abs(
                                    m *
                                    v
                                    );
                            A[z] =
                                R
                        }),
                    s.style
                    .zIndex = -
                    Math
                    .abs(
                        Math
                        .round(
                            d
                            )
                        ) +
                    w
                    .length;
                const q = b
                    .join(
                        ", "
                        ),
                    E =
                    `rotateX(${g(A[0])}deg) rotateY(${g(A[1])}deg) rotateZ(${g(A[2])}deg)`,
                    D = l <
                    0 ?
                    `scale(${1+(1-I.scale)*l*v})` :
                    `scale(${1-(1-I.scale)*l*v})`,
                    O = l <
                    0 ? 1 +
                    (1 - I
                        .opacity
                        ) *
                    l * v :
                    1 - (1 -
                        I
                        .opacity
                        ) *
                    l * v,
                    _ =
                    `translate3d(${q}) ${E} ${D}`;
                if ($ && I
                    .shadow ||
                    !$) {
                    let T =
                        s
                        .querySelector(
                            ".swiper-slide-shadow"
                            );
                    if (!
                        T &&
                        I
                        .shadow &&
                        (T = Ge("creative",
                            s
                            )),
                        T) {
                        const
                            z =
                            n
                            .shadowPerProgress ?
                            m *
                            (1 / n
                                .limitProgress
                                ) :
                            m;
                        T.style
                            .opacity =
                            Math
                            .min(
                                Math
                                .max(
                                    Math
                                    .abs(
                                        z
                                        ),
                                    0
                                    ),
                                1
                                )
                    }
                }
                const C =
                    Ze(n,
                    s);
                C.style
                    .transform =
                    _, C
                    .style
                    .opacity =
                    O, I
                    .origin &&
                    (C.style
                        .transformOrigin =
                        I
                        .origin
                        )
            }
        },
        setTransition: w => {
            const p = e
                .slides.map(
                    f => Ne(
                        f));
            p.forEach(f => {
                f.style
                    .transitionDuration =
                    `${w}ms`,
                    f
                    .querySelectorAll(
                        ".swiper-slide-shadow"
                        )
                    .forEach(
                        n => {
                            n.style
                                .transitionDuration =
                                `${w}ms`
                        }
                        )
            }), dt({
                swiper: e,
                duration: w,
                transformElements: p,
                allSlides:
                    !
                    0
            })
        },
        perspective: () => e
            .params
            .creativeEffect
            .perspective,
        overwriteParams: () =>
    ({
            watchSlidesProgress:
                !0,
            virtualTranslate:
                !e
                .params
                .cssMode
        })
    })
}

function Ci(u) {
    let {
        swiper: e,
        extendParams: t,
        on: i
    } = u;
    t({
        cardsEffect: {
            slideShadows: !0,
            rotate: !0,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    }), Ue({
        effect: "cards",
        swiper: e,
        on: i,
        setTranslate: () => {
            const {
                slides: h,
                activeIndex: w,
                rtlTranslate: p
            } = e, f = e
                .params
                .cardsEffect, {
                    startTranslate: n,
                    isTouched: v
                } = e
                .touchEventsData,
                y = p ? -e
                .translate :
                e.translate;
            for (let g =
                0; g < h
                .length; g +=
                1) {
                const r = h[
                        g],
                    s = r
                    .progress,
                    d = Math
                    .min(
                        Math
                        .max(
                            s,
                            -
                            4
                            ),
                        4);
                let m = r
                    .swiperSlideOffset;
                e.params
                    .centeredSlides &&
                    !e
                    .params
                    .cssMode &&
                    (e.wrapperEl
                        .style
                        .transform =
                        `translateX(${e.minTranslate()}px)`
                        ), e
                    .params
                    .centeredSlides &&
                    e.params
                    .cssMode &&
                    (m -= h[
                            0]
                        .swiperSlideOffset
                        );
                let l = e
                    .params
                    .cssMode ?
                    -m - e
                    .translate :
                    -m,
                    c = 0;
                const b = -
                    100 *
                    Math
                    .abs(d);
                let A = 1,
                    $ = -f
                    .perSlideRotate *
                    d,
                    I = f
                    .perSlideOffset -
                    Math
                    .abs(
                    d) *
                    .75;
                const q = e
                    .virtual &&
                    e.params
                    .virtual
                    .enabled ?
                    e
                    .virtual
                    .from +
                    g : g,
                    E = (
                        q ===
                        w ||
                        q ===
                        w -
                        1
                        ) &&
                    d > 0 &&
                    d < 1 &&
                    (v || e
                        .params
                        .cssMode
                        ) &&
                    y < n,
                    D = (
                        q ===
                        w ||
                        q ===
                        w +
                        1
                        ) &&
                    d < 0 &&
                    d > -
                    1 && (
                        v ||
                        e
                        .params
                        .cssMode
                        ) &&
                    y > n;
                if (E ||
                    D) {
                    const
                        T =
                        (1 - Math
                            .abs(
                                (Math
                                    .abs(
                                        d
                                        ) -
                                    .5
                                    ) /
                                .5
                                )
                            ) **
                        .5;
                    $ += -
                        28 *
                        d *
                        T,
                        A +=
                        -
                        .5 *
                        T,
                        I +=
                        96 *
                        T,
                        c =
                        `${-25*T*Math.abs(d)}%`
                }
                if (d < 0 ?
                    l =
                    `calc(${l}px ${p?"-":"+"} (${I*Math.abs(d)}%))` :
                    d > 0 ?
                    l =
                    `calc(${l}px ${p?"-":"+"} (-${I*Math.abs(d)}%))` :
                    l =
                    `${l}px`,
                    !e
                    .isHorizontal()
                    ) {
                    const
                        T =
                        c;
                    c = l,
                        l =
                        T
                }
                const O =
                    d < 0 ?
                    `${1+(1-A)*d}` :
                    `${1-(1-A)*d}`,
                    _ = `
        translate3d(${l}, ${c}, ${b}px)
        rotateZ(${f.rotate?p?-$:$:0}deg)
        scale(${O})
      `;
                if (f
                    .slideShadows
                    ) {
                    let T =
                        r
                        .querySelector(
                            ".swiper-slide-shadow"
                            );
                    T || (T =
                            Ge("cards",
                                r
                                )
                            ),
                        T &&
                        (T.style
                            .opacity =
                            Math
                            .min(
                                Math
                                .max(
                                    (Math
                                        .abs(
                                            d
                                            ) -
                                        .5
                                        ) /
                                    .5,
                                    0
                                    ),
                                1
                                )
                            )
                }
                r.style
                    .zIndex = -
                    Math
                    .abs(
                        Math
                        .round(
                            s
                            )
                        ) +
                    h
                    .length;
                const C =
                    Ze(f,
                    r);
                C.style
                    .transform =
                    _
            }
        },
        setTransition: h => {
            const w = e
                .slides.map(
                    p => Ne(
                        p));
            w.forEach(p => {
                p.style
                    .transitionDuration =
                    `${h}ms`,
                    p
                    .querySelectorAll(
                        ".swiper-slide-shadow"
                        )
                    .forEach(
                        f => {
                            f.style
                                .transitionDuration =
                                `${h}ms`
                        }
                        )
            }), dt({
                swiper: e,
                duration: h,
                transformElements: w
            })
        },
        perspective: () => !0,
        overwriteParams: () =>
    ({
            _loopSwapReset:
                !1,
            watchSlidesProgress:
                !0,
            loopAdditionalSlides: e
                .params
                .cardsEffect
                .rotate ?
                3 : 2,
            centeredSlides:
                !0,
            virtualTranslate:
                !e
                .params
                .cssMode
        })
    })
}
const Ti = [Kt, Jt, Zt, ei, ti, ii, si,
    ri, ai, ni, oi, li, ci, di, pi,
    ui, vi, bi, yi, Ei, Si, xi, Ci
];
It.use(Ti);
const pt = ["eventsPrefix",
    "injectStyles",
    "injectStylesUrls", "modules",
    "init", "_direction",
    "oneWayMovement",
    "swiperElementNodeName",
    "touchEventsTarget",
    "initialSlide", "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver", "nested",
    "focusableElements", "_enabled",
    "_width", "_height",
    "preventInteractionOnTransition",
    "userAgent", "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode", "_autoHeight",
    "setWrapperSize",
    "virtualTranslate", "_effect",
    "breakpoints",
    "breakpointsBase",
    "_spaceBetween",
    "_slidesPerView",
    "maxBackfaceHiddenSlides",
    "_grid", "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_slidesPerGroupAuto",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths", "touchRatio",
    "touchAngle", "simulateTouch",
    "_shortSwipes", "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs", "_followFinger",
    "allowTouchMove", "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_grabCursor", "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide", "_loop",
    "loopAdditionalSlides",
    "loopAddBlankSlides",
    "loopPreventsSliding",
    "_rewind", "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler", "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideActiveClass",
    "slideVisibleClass",
    "slideFullyVisibleClass",
    "slideNextClass",
    "slidePrevClass",
    "slideBlankClass",
    "wrapperClass",
    "lazyPreloaderClass",
    "lazyPreloadPrevNext",
    "runCallbacksOnInit",
    "observer", "observeParents",
    "observeSlideChildren", "a11y",
    "_autoplay", "_controller",
    "coverflowEffect", "cubeEffect",
    "fadeEffect", "flipEffect",
    "creativeEffect", "cardsEffect",
    "hashNavigation", "history",
    "keyboard", "mousewheel",
    "_navigation", "_pagination",
    "parallax", "_scrollbar",
    "_thumbs", "virtual", "zoom",
    "control"
];

function We(u) {
    return typeof u == "object" && u !==
        null && u.constructor && Object
        .prototype.toString.call(u)
        .slice(8, -1) === "Object" && !u
        .__swiper__
}

function vt(u, e) {
    const t = ["__proto__",
        "constructor", "prototype"
    ];
    Object.keys(e).filter(i => t
        .indexOf(i) < 0).forEach(
        i => {
            typeof u[i] > "u" ? u[
                i] = e[i] : We(e[
                i]) && We(u[i]) &&
                Object.keys(e[i])
                .length > 0 ? e[i]
                .__swiper__ ? u[i] =
                e[i] : vt(u[i], e[
                    i]) : u[i] = e[
                    i]
        })
}

function Mi(u) {
    return u === void 0 && (u = {}), u
        .navigation && typeof u
        .navigation.nextEl > "u" &&
        typeof u.navigation.prevEl > "u"
}

function Li(u) {
    return u === void 0 && (u = {}), u
        .pagination && typeof u
        .pagination.el > "u"
}

function Ai(u) {
    return u === void 0 && (u = {}), u
        .scrollbar && typeof u.scrollbar
        .el > "u"
}

function at(u) {
    return u === void 0 && (u = ""), u
        .replace(/-[a-z]/g, e => e
            .toUpperCase().replace("-",
                ""))
}

function Pi(u) {
    let {
        swiper: e,
        slides: t,
        passedParams: i,
        changedParams: a,
        nextEl: o,
        prevEl: h,
        scrollbarEl: w,
        paginationEl: p
    } = u;
    const f = a.filter(E => E !==
            "children" && E !==
            "direction" && E !==
            "wrapperClass"),
        {
            params: n,
            pagination: v,
            navigation: y,
            scrollbar: g,
            virtual: r,
            thumbs: s
        } = e;
    let d, m, l, c, b, A, $, I;
    a.includes("thumbs") && i.thumbs &&
        i.thumbs.swiper && !i.thumbs
        .swiper.destroyed && n.thumbs &&
        (!n.thumbs.swiper || n.thumbs
            .swiper.destroyed) && (d = !
            0), a.includes(
        "controller") && i.controller &&
        i.controller.control && n
        .controller && !n.controller
        .control && (m = !0), a
        .includes("pagination") && i
        .pagination && (i.pagination
            .el || p) && (n
            .pagination || n
            .pagination === !1) && v &&
        !v.el && (l = !0), a.includes(
            "scrollbar") && i
        .scrollbar && (i.scrollbar.el ||
            w) && (n.scrollbar || n
            .scrollbar === !1) && g && !
        g.el && (c = !0), a.includes(
            "navigation") && i
        .navigation && (i.navigation
            .prevEl || h) && (i
            .navigation.nextEl || o) &&
        (n.navigation || n
            .navigation === !1) && y &&
        !y.prevEl && !y.nextEl && (b = !
            0);
    const q = E => {
        e[E] && (e[E].destroy(),
            E === "navigation" ?
            (e.isElement && (e[
                        E]
                    .prevEl
                    .remove(),
                    e[E].nextEl
                    .remove()),
                n[E].prevEl =
                void 0, n[E]
                .nextEl =
                void 0, e[E]
                .prevEl =
                void 0, e[E]
                .nextEl = void 0
                ) : (e
                .isElement && e[
                    E].el
                .remove(), n[E]
                .el = void 0, e[
                    E].el =
                void 0))
    };
    a.includes("loop") && e.isElement &&
        (n.loop && !i.loop ? A = !0 : !n
            .loop && i.loop ? $ = !0 :
            I = !0), f.forEach(E => {
            if (We(n[E]) && We(i[
                E])) Object.assign(
                    n[E], i[E]), (
                    E ===
                    "navigation" ||
                    E ===
                    "pagination" ||
                    E ===
                    "scrollbar") &&
                "enabled" in i[E] &&
                !i[E].enabled && q(
                    E);
            else {
                const D = i[E];
                (D === !0 || D === !
                    1) && (E ===
                    "navigation" ||
                    E ===
                    "pagination" ||
                    E ===
                    "scrollbar") ? D
                    === !1 && q(E):
                    n[E] = i[E]
            }
        }), f.includes("controller") &&
        !m && e.controller && e
        .controller.control && n
        .controller && n.controller
        .control && (e.controller
            .control = n.controller
            .control), a.includes(
            "children") && t && r && n
        .virtual.enabled ? (r.slides =
            t, r.update(!0)) : a
        .includes("virtual") && r && n
        .virtual.enabled && (t && (r
            .slides = t), r.update(!
            0)), a.includes(
        "children") && t && n.loop && (
            I = !0), d && s.init() && s
        .update(!0), m && (e.controller
            .control = n.controller
            .control), l && (e
            .isElement && (!p ||
                typeof p == "string") &&
            (p = document.createElement(
                    "div"), p.classList
                .add(
                    "swiper-pagination"),
                p.part.add(
                "pagination"), e.el
                .appendChild(p)), p && (
                n.pagination.el = p), v
            .init(), v.render(), v
            .update()), c && (e
            .isElement && (!w ||
                typeof w == "string") &&
            (w = document.createElement(
                    "div"), w.classList
                .add(
                "swiper-scrollbar"), w
                .part.add("scrollbar"),
                e.el.appendChild(w)),
            w && (n.scrollbar.el = w), g
            .init(), g.updateSize(), g
            .setTranslate()), b && (e
            .isElement && ((!o ||
                    typeof o == "string"
                    ) && (o = document
                    .createElement(
                        "div"), o
                    .classList.add(
                        "swiper-button-next"
                        ), ce(o, e
                        .hostEl
                        .constructor
                        .nextButtonSvg),
                    o.part.add(
                        "button-next"),
                    e.el.appendChild(o)
                    ), (!h ||
                    typeof h == "string"
                    ) && (h = document
                    .createElement(
                        "div"), h
                    .classList.add(
                        "swiper-button-prev"
                        ), ce(h, e
                        .hostEl
                        .constructor
                        .prevButtonSvg),
                    h.part.add(
                        "button-prev"),
                    e.el.appendChild(h))
                ), o && (n.navigation
                .nextEl = o), h && (n
                .navigation.prevEl = h),
            y.init(), y.update()), a
        .includes("allowSlideNext") && (
            e.allowSlideNext = i
            .allowSlideNext), a
        .includes("allowSlidePrev") && (
            e.allowSlidePrev = i
            .allowSlidePrev), a
        .includes("direction") && e
        .changeDirection(i.direction, !
            1), (A || I) && e
        .loopDestroy(), ($ || I) && e
        .loopCreate(), e.update()
}
const Ct = u => {
        if (parseFloat(u) === Number(u))
            return Number(u);
        if (u === "true" || u === "")
            return !0;
        if (u === "false") return !1;
        if (u === "null") return null;
        if (u !== "undefined") {
            if (typeof u == "string" &&
                u.includes("{") && u
                .includes("}") && u
                .includes('"')) {
                let e;
                try {
                    e = JSON.parse(u)
                } catch {
                    e = u
                }
                return e
            }
            return u
        }
    },
    Tt = ["a11y", "autoplay",
        "controller", "cards-effect",
        "coverflow-effect",
        "creative-effect",
        "cube-effect", "fade-effect",
        "flip-effect", "free-mode",
        "grid", "hash-navigation",
        "history", "keyboard",
        "mousewheel", "navigation",
        "pagination", "parallax",
        "scrollbar", "thumbs",
        "virtual", "zoom"
    ];

function Mt(u, e, t) {
    const i = {},
        a = {};
    vt(i, Qt);
    const o = [...pt, "on"],
        h = o.map(p => p.replace(/_/,
            ""));
    o.forEach(p => {
        p = p.replace("_", ""),
            typeof u[p] < "u" &&
            (a[p] = u[p])
    });
    const w = [...u.attributes];
    return typeof e == "string" &&
        typeof t < "u" && w.push({
            name: e,
            value: We(t) ? {
                ...t
            } : t
        }), w.forEach(p => {
            const f = Tt.find(n => p
                .name
                .startsWith(
                    `${n}-`));
            if (f) {
                const n = at(f),
                    v = at(p.name
                        .split(
                            `${f}-`
                            )[1]);
                typeof a[n] > "u" &&
                    (a[n] = {}), a[
                        n] === !0 &&
                    (a[n] = {
                        enabled:
                            !0
                    }), a[n] === !
                    1 && (a[n] = {
                        enabled:
                            !1
                    }), a[n][v] =
                    Ct(p.value)
            } else {
                const n = at(p
                .name);
                if (!h.includes(n))
                    return;
                const v = Ct(p
                    .value);
                a[n] && Tt.includes(
                        p.name) && !
                    We(v) ? (a[n]
                        .constructor !==
                        Object && (
                            a[
                            n] = {}
                            ), a[n]
                        .enabled = !
                        !v) : a[n] =
                    v
            }
        }), vt(i, a), i.navigation ? i
        .navigation = {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
            ...i.navigation !== !0 ? i
            .navigation : {}
        } : i.navigation === !1 &&
        delete i.navigation, i
        .scrollbar ? i.scrollbar = {
            el: ".swiper-scrollbar",
            ...i.scrollbar !== !0 ? i
            .scrollbar : {}
        } : i.scrollbar === !1 &&
        delete i.scrollbar, i
        .pagination ? i.pagination = {
            el: ".swiper-pagination",
            ...i.pagination !== !0 ? i
            .pagination : {}
        } : i.pagination === !1 &&
        delete i.pagination, {
            params: i,
            passedParams: a
        }
}
const Ii =
    ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}",
    _i =
    "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class ki {}
const _t = typeof window > "u" ||
    typeof HTMLElement > "u" ? ki :
    HTMLElement,
    Lt = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `,
    kt = (u, e) => {
        if (typeof CSSStyleSheet <
            "u" && u.adoptedStyleSheets
            ) {
            const t = new CSSStyleSheet;
            t.replaceSync(e), u
                .adoptedStyleSheets = [
                    t]
        } else {
            const t = document
                .createElement("style");
            t.rel = "stylesheet", t
                .textContent = e, u
                .appendChild(t)
        }
    };
class zt extends _t {
    constructor() {
        super(), this.attachShadow({
            mode: "open"
        })
    }
    static get nextButtonSvg() {
        return Lt
    }
    static get prevButtonSvg() {
        return Lt.replace(
            "/></svg>",
            ' transform-origin="center" transform="rotate(180)"/></svg>'
            )
    }
    cssStyles() {
        return [Ii, ...this
            .injectStyles &&
            Array.isArray(this
                .injectStyles) ?
            this.injectStyles :
            []
        ].join(`
`)
    }
    cssLinks() {
        return this
            .injectStylesUrls || []
    }
    calcSlideSlots() {
        const e = this.slideSlots ||
            0,
            t = [...this
                .querySelectorAll(
                    "[slot^=slide-]"
                    )
            ].map(i => parseInt(i
                .getAttribute(
                    "slot")
                .split(
                "slide-")[1], 10
                ));
        if (this.slideSlots = t
            .length ? Math.max(...
            t) + 1 : 0, !!this
            .rendered) {
            if (this.slideSlots > e)
                for (let i = e; i <
                    this
                    .slideSlots; i +=
                    1) {
                    const a =
                        document
                        .createElement(
                            "swiper-slide"
                            );
                    a.setAttribute(
                        "part",
                        `slide slide-${i+1}`
                        );
                    const o =
                        document
                        .createElement(
                            "slot");
                    o.setAttribute(
                            "name",
                            `slide-${i+1}`
                            ), a
                        .appendChild(
                            o), this
                        .shadowRoot
                        .querySelector(
                            ".swiper-wrapper"
                            )
                        .appendChild(
                            a)
                } else if (this
                    .slideSlots < e
                    ) {
                    const i = this
                        .swiper
                        .slides;
                    for (let a = i
                            .length -
                            1; a >=
                        0; a -= 1)
                        a > this
                        .slideSlots &&
                        i[a]
                        .remove()
                }
        }
    }
    render() {
        if (this.rendered) return;
        this.calcSlideSlots();
        let e = this.cssStyles();
        this.slideSlots > 0 && (e =
                e.replace(
                    /::slotted\(([a-z-0-9.]*)\)/g,
                    "$1")), e
            .length && kt(this
                .shadowRoot, e),
            this.cssLinks().forEach(
                i => {
                    if (this
                        .shadowRoot
                        .querySelector(
                            `link[href="${i}"]`
                            ))
                        return;
                    const o =
                        document
                        .createElement(
                            "link");
                    o.rel =
                        "stylesheet",
                        o.href = i,
                        this
                        .shadowRoot
                        .appendChild(
                            o)
                });
        const t = document
            .createElement("div");
        t.classList.add("swiper"), t
            .part = "container", ce(
                t,
                `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({length:this.slideSlots}).map((i,a)=>` <
                swiper -
                slide part =
                "slide slide-${a}" >
                <
                slot name =
                "slide-${a}" > <
                /slot> <
                /swiper-slide>
                `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${Mi(this.passedParams)?`
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      `:""}
      ${Li(this.passedParams)?`
        <div part="pagination" class="swiper-pagination"></div>
      `:""}
      ${Ai(this.passedParams)?`
        <div part="scrollbar" class="swiper-scrollbar"></div>
      `:""}
    `), this.shadowRoot.appendChild(t),
            this.rendered = !0
    }
    initialize() {
        var e = this;
        if (this.swiper && this
            .swiper.initialized)
            return;
        const {
            params: t,
            passedParams: i
        } = Mt(this);
        this.swiperParams = t, this
            .passedParams = i,
            delete this.swiperParams
            .init, this.render(),
            this.swiper = new It(
                this.shadowRoot
                .querySelector(
                    ".swiper"), {
                    ...t.virtual ?
                    {} : {
                        observer: !0
                    },
                    ...t,
                    touchEventsTarget: "container",
                    onAny: function(
                        a) {
                        a ===
                            "observerUpdate" &&
                            e
                            .calcSlideSlots();
                        const
                            o =
                            t
                            .eventsPrefix ?
                            `${t.eventsPrefix}${a.toLowerCase()}` :
                            a
                            .toLowerCase();
                        for (var h =
                                arguments
                                .length,
                                w =
                                new Array(
                                    h >
                                    1 ?
                                    h -
                                    1 :
                                    0
                                    ),
                                p =
                                1; p <
                            h; p++
                            ) w[p -
                                1
                                ] =
                            arguments[
                                p
                                ];
                        const
                            f =
                            new CustomEvent(
                                o, {
                                    detail: w,
                                    bubbles: a !==
                                        "hashChange",
                                    cancelable:
                                        !
                                        0
                                }
                                );
                        e.dispatchEvent(
                            f
                            )
                    }
                })
    }
    connectedCallback() {
        this.swiper && this.swiper
            .initialized && this
            .nested && this.closest(
                "swiper-slide") &&
            this.closest(
                "swiper-slide")
            .swiperLoopMoveDOM ||
            this.init === !1 || this
            .getAttribute(
            "init") === "false" ||
            this.initialize()
    }
    disconnectedCallback() {
        this.nested && this.closest(
                "swiper-slide") &&
            this.closest(
                "swiper-slide")
            .swiperLoopMoveDOM ||
            this.swiper && this
            .swiper.destroy && this
            .swiper.destroy()
    }
    updateSwiperOnPropChange(e, t) {
        const {
            params: i,
            passedParams: a
        } = Mt(this, e, t);
        this.passedParams = a, this
            .swiperParams = i, !(
                this.swiper && this
                .swiper.params[
                e] === t) && Pi({
                swiper: this
                    .swiper,
                passedParams: this
                    .passedParams,
                changedParams: [
                    at(e)
                ],
                ...e ===
                "navigation" &&
                a[e] ? {
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next"
                } : {},
                ...e ===
                "pagination" &&
                a[e] ? {
                    paginationEl: ".swiper-pagination"
                } : {},
                ...e ===
                "scrollbar" &&
                a[e] ? {
                    scrollbarEl: ".swiper-scrollbar"
                } : {}
            })
    }
    attributeChangedCallback(e, t, i) {
        this.swiper && this.swiper
            .initialized && (t ===
                "true" && i ===
                null && (i = !1),
                this
                .updateSwiperOnPropChange(
                    e, i))
    }
    static get observedAttributes() {
        return pt.filter(t => t
            .includes("_")).map(
            t => t.replace(
                /[A-Z]/g, i =>
                `-${i}`)
            .replace("_", "")
            .toLowerCase())
    }
}
pt.forEach(u => {
    u !== "init" && (u = u
        .replace("_", ""),
        Object
        .defineProperty(zt
            .prototype, u, {
                configurable:
                    !0,
                get() {
                    return (this
                        .passedParams ||
                        {}
                        )[
                        u
                        ]
                },
                set(e) {
                    this.passedParams ||
                        (this
                            .passedParams = {}
                            ),
                        this
                        .passedParams[
                            u
                            ] =
                        e,
                        this
                        .swiper &&
                        this
                        .swiper
                        .initialized &&
                        this
                        .updateSwiperOnPropChange(
                            u,
                            e
                            )
                }
            }))
});
class zi extends _t {
    constructor() {
        super(), this.attachShadow({
            mode: "open"
        })
    }
    render() {
        const e = this.lazy || this
            .getAttribute(
            "lazy") === "" || this
            .getAttribute(
            "lazy") === "true";
        if (kt(this.shadowRoot, _i),
            this.shadowRoot
            .appendChild(document
                .createElement(
                    "slot")), e) {
            const t = document
                .createElement(
                    "div");
            t.classList.add(
                    "swiper-lazy-preloader"
                    ), t.part.add(
                    "preloader"),
                this.shadowRoot
                .appendChild(t)
        }
    }
    initialize() {
        this.render()
    }
    connectedCallback() {
        this.swiperLoopMoveDOM ||
            this.initialize()
    }
}
const Di = () => {
    typeof window > "u" || (window
        .customElements.get(
            "swiper-container"
            ) || window
        .customElements.define(
            "swiper-container",
            zt), window
        .customElements.get(
            "swiper-slide") ||
        window.customElements
        .define("swiper-slide",
            zi))
};
typeof window < "u" && (window
    .SwiperElementRegisterParams =
    u => {
        pt.push(...u)
    });
    
function $i() {
  const stars = document.querySelectorAll(".star");
  if (!stars.length) return;

  const random = (min, max) => min + Math.random() * (max - min);
  const randomOpacity = () => Math.round(Math.random());
  const randomScale = () => random(0.6, 1.1);
  const randomDuration = () => random(0.3, 0.5);
  const randomDelay = () => random(0, 0.2);

  const animateStar = (star, index) => {
    gsap.fromTo(star,
      { opacity: 0, scale: 0 },
      {
        opacity: 1, scale: 1,
        duration: 0.25,
        ease: "back.out(1.7)",
        delay: index * 0.01,
        onComplete: () => {
          const twinkle = () => {
            gsap.to(star, {
              opacity: randomOpacity(),
              scale: randomScale(),
              duration: randomDuration(),
              ease: "power3.inOut",
              yoyo: true,
              repeat: 1,
              delay: randomDelay(),
              onComplete: twinkle
            });
          };
          gsap.delayedCall(index * 0.03, twinkle);
        }
      }
    );
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const star = entry.target;
        const index = Array.from(stars).indexOf(star);
        animateStar(star, index);
        observer.unobserve(star);
      }
    });
  }, { threshold: 0.1, rootMargin: "50px" });

  stars.forEach(star => observer.observe(star));
}
$i();

window.requestIdleCallback || (window
    .requestIdleCallback = function(
        u, e) {
        const t = (e == null ?
                void 0 : e.timeout
                ) || 0,
            i = Date.now();
        return setTimeout(
    function() {
            u({
                didTimeout: t >
                    0 &&
                    Date
                    .now() -
                    i >=
                    t,
                timeRemaining: function() {
                    return Math
                        .max(
                            0,
                            50 -
                            (Date
                                .now() -
                                i
                                )
                            )
                }
            })
        }, 1)
    });
window.cancelIdleCallback || (window
    .cancelIdleCallback = function(
        u) {
        clearTimeout(u)
    });
let gt = document.querySelector(
        ".mobile-menu"),
    Dt = document.querySelector(
        "[data-menu-toggle]"),
    At = document.querySelector(
        ".header-shadow"),
    qi = document.querySelector(
        "#shopify-section-header"),
    Oi = document.querySelector(
        '[id*="announcement-bar"]');
document.querySelector(
    "#locator_modal_window");
const Pt = gsap.timeline({
        paused: !0
    }),
    lt = gsap.timeline({
        paused: !0
    });
lt.to(".header-shadow", {
    opacity: 1,
    duration: .3,
    ease: "power2.out"
});
lt.reverse();

function $t() {
    const u = qi.offsetHeight || 0,
        t = (window.innerHeight || 0) -
        u - Oi.offsetHeight || 0;
    gt.style.top = `${u}px`, gt.style
        .height = `${t}px`, gt.classList
        .toggle("is-open"), Dt.classList
        .toggle("active"), document.body
        .classList.toggle(
            "max-lg:overflow-hidden"),
        Pt.reversed(!Pt.reversed()), lt
        .reversed(!lt.reversed());
    const i = document.querySelector(
            "[data-cart-drawer]"),
        a = document.querySelector(
            "#locator_modal_window");
    a && a.expanded && a.close(), i && i
        .expanded && i.closeCart()
}
Dt.addEventListener("click", $t);
At && At.addEventListener("click", $t);
class Hi extends HTMLElement {
    constructor() {
        super(), this
            .selectedIndex = 0, this
            .carouselSwiperEl = this
            .querySelector(
                ".collection-swiper"
                ), this
            .collectionCarousels =
            this.querySelectorAll(
                ".product-list__carousel"
                ), this
            .collectionButtons =
            this.querySelectorAll(
                ".product-list__collection-button"
                ), this
            .viewAllButtons = this
            .querySelectorAll(
                ".product-list__view-all-button"
                )
    }
    connectedCallback() {
        this.collectionButtons
            .forEach(e => {
                e.addEventListener(
                    "click",
                    t => {
                        this.collectionButtons[
                                this
                                .selectedIndex
                                ]
                            .classList
                            .remove(
                                "selected"
                                ),
                            this
                            .selectedIndex = +
                            e
                            .dataset
                            .collectionIndex,
                            this
                            .collectionButtons[
                                this
                                .selectedIndex
                                ]
                            .classList
                            .add(
                                "selected"
                                ),
                            this
                            .carouselSwiperEl
                            .swiper
                            .slideTo(
                                this
                                .selectedIndex
                                ),
                            this
                            .viewAllButtons
                            .forEach(
                                i => {
                                    i.href =
                                        this
                                        .collectionCarousels[
                                            this
                                            .selectedIndex
                                            ]
                                        .dataset
                                        .collectionUrl
                                }
                                )
                    })
            })
    }
}
customElements.define(
    "jolly-product-list", Hi);
class Bi extends HTMLElement {
    constructor() {
        super(), this.navList = this
            .querySelector(
                "[data-page-nav-list]"
                ), this.template =
            this.querySelector(
                "#page-nav-el-tmp"),
            this.navSections =
            document
            .querySelectorAll(
                "[data-nav-title]"),
            this.topGap = +this
            .getAttribute(
                "data-top-gap") ||
            0, this.activeLink =
            null, this
            .disableLinkScroll = !1
    }
    connectedCallback() {
        this.initNavLinks(), this
            .initObserver()
    }
    initNavLinks() {
        this.navSections.forEach(
                e => {
                    const t = this
                        .template
                        .innerHTML
                        .replace(
                            "{section}",
                            e
                            .dataset
                            .navTitle
                            )
                        .replace(
                            "{title}",
                            e
                            .dataset
                            .navTitle
                            );
                    this.navList
                        .insertAdjacentHTML(
                            "beforeend",
                            t)
                }), this.navLinks =
            this.querySelectorAll(
                "[data-scroll-section]"
                ), this.navLinks
            .forEach(e => {
                e.addEventListener(
                    "click",
                    t => {
                        t
                    .preventDefault();
                        const
                            i =
                            document
                            .querySelector(
                                `[data-nav-title="${e.dataset.scrollSection}"]`
                                )
                            .offsetTop;
                        scrollTo
                            (0, Math
                                .max(
                                    i -
                                    this
                                    .topGap,
                                    0
                                    )
                                ),
                            this
                            .disableLinkScroll = !
                            0,
                            this
                            .navLinks
                            .forEach(
                                a =>
                                a
                                .classList
                                .remove(
                                    "active"
                                    )
                                ),
                            e
                            .classList
                            .add(
                                "active"
                                ),
                            setTimeout(
                                () =>
                                this
                                .disableLinkScroll = !
                                1,
                                500
                                ),
                            this
                            .scrollToLink(
                                e
                                )
                    })
            })
    }
    initObserver() {
        this.observer =
            new IntersectionObserver(
                e => {
                    e.forEach(t => {
                        if (t
                            .isIntersecting &&
                            window
                            .scrollY >=
                            t
                            .intersectionRect
                            .y &&
                            t
                            .intersectionRatio >
                            .7
                            ) {
                            const
                                i =
                                this
                                .querySelector(
                                    `[data-scroll-section="${t.target.getAttribute("data-nav-title")}"]`
                                    );
                            this.disableLinkScroll ||
                                (this
                                    .navLinks
                                    .forEach(
                                        a =>
                                        a
                                        .classList
                                        .remove(
                                            "active"
                                            )
                                        ),
                                    i
                                    .classList
                                    .add(
                                        "active"
                                        ),
                                    i !=
                                    this
                                    .activeLink &&
                                    this
                                    .scrollToLink(
                                        i
                                        ),
                                    this
                                    .activeLink =
                                    i
                                    )
                        }
                    })
                }, {
                    root: null,
                    rootMargin: "0px",
                    threshold: [0,
                        .1, .2,
                        .3, .4,
                        .5, .6,
                        .7, .8,
                        .9, 1
                    ]
                }), this.navSections
            .forEach(e => {
                this.observer
                    .observe(e)
            })
    }
    scrollToLink(e) {
        let t;
        e.getBoundingClientRect()
            .x > this.scrollLeft ?
            t = this.scrollLeft + e
            .getBoundingClientRect()
            .x + 12 : t = this
            .scrollLeft + e
            .getBoundingClientRect()
            .x - 12, document
            .querySelector(
                "page-nav").scroll({
                left: t,
                behavior: "smooth"
            })
    }
}
customElements.define("page-nav", Bi);

function Ri(u, e = 300) {
    let t, i = [];
    return function(...a) {
        return clearTimeout(t),
            new Promise(o => {
                i.push(o), t =
                    setTimeout(
                        async () => {
                            try {
                                const
                                    h =
                                    await u
                                    .apply(
                                        this,
                                        a
                                        );
                                i.forEach(
                                    w =>
                                    w(
                                        h)
                                    )
                            } catch (
                                h
                                ) {
                                i.forEach(
                                    w =>
                                    w(Promise
                                        .reject(
                                            h
                                            )
                                        )
                                    )
                            } finally {
                                i = []
                            }
                        }, e)
            })
    }
}(function() {
    var u = function(M, B) {
        var N = function(j) {
                for (var U = 0,
                        Q = j
                        .length; U <
                    Q; U++) X(j[
                    U])
            },
            X = function(j) {
                var U = j
                    .target,
                    Q = j
                    .attributeName,
                    re = j
                    .oldValue;
                U.attributeChangedCallback(
                    Q, re, U
                    .getAttribute(
                        Q))
            };
        return function(j, U) {
            var Q = j
                .constructor
                .observedAttributes;
            return Q && M(U)
                .then(
                    function() {
                        new B
                            (
                                N)
                            .observe(
                                j, {
                                    attributes:
                                        !
                                        0,
                                    attributeOldValue:
                                        !
                                        0,
                                    attributeFilter: Q
                                }
                                );
                        for (
                            var re =
                                0,
                                V =
                                Q
                                .length; re <
                            V; re++
                            )
                            j
                            .hasAttribute(
                                Q[
                                    re]
                                ) &&
                            X({
                                target: j,
                                attributeName: Q[
                                    re
                                    ],
                                oldValue: null
                            })
                    }), j
        }
    };

    function e(M, B) {
        (B == null || B > M
        .length) && (B = M.length);
        for (var N = 0, X =
                new Array(B); N <
            B; N++) X[N] = M[N];
        return X
    }

    function t(M, B) {
        var N = typeof Symbol <
            "u" && M[Symbol
                .iterator] || M[
                "@@iterator"];
        if (!N) {
            if (Array.isArray(M) ||
                (N = function(V,
                J) {
                    if (V) {
                        if (typeof V ==
                            "string"
                            )
                            return e(
                                V,
                                J
                                );
                        var ee =
                            Object
                            .prototype
                            .toString
                            .call(
                                V
                                )
                            .slice(
                                8,
                                -
                                1
                                );
                        return ee ===
                            "Object" &&
                            V
                            .constructor &&
                            (ee =
                                V
                                .constructor
                                .name
                                ),
                            ee ===
                            "Map" ||
                            ee ===
                            "Set" ?
                            Array
                            .from(
                                V
                                ) :
                            ee ===
                            "Arguments" ||
                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/
                            .test(
                                ee
                                ) ?
                            e(V,
                                J) :
                            void 0
                    }
                }(M)) || B && M &&
                typeof M.length ==
                "number") {
                N && (M = N);
                var X = 0,
                    j =
                function() {};
                return {
                    s: j,
                    n: function() {
                        return X >=
                            M
                            .length ?
                            {
                                done:
                                    !
                                    0
                            } :
                            {
                                done:
                                    !
                                    1,
                                value: M[
                                    X++
                                    ]
                            }
                    },
                    e: function(V) {
                        throw V
                    },
                    f: j
                }
            }
            throw new TypeError(
                `Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`
                )
        }
        var U, Q = !0,
            re = !1;
        return {
            s: function() {
                N = N.call(M)
            },
            n: function() {
                var V = N
            .next();
                return Q = V
                    .done, V
            },
            e: function(V) {
                re = !0, U = V
            },
            f: function() {
                try {
                    Q || N
                        .return ==
                        null ||
                        N
                        .return()
                } finally {
                    if (re)
                        throw U
                }
            }
        }
    } /*! (c) Andrea Giammarchi - ISC */
    var i = !0,
        a = !1,
        o = "querySelectorAll",
        h = "querySelectorAll",
        w = self,
        p = w.document,
        f = w.Element,
        n = w.MutationObserver,
        v = w.Set,
        y = w.WeakMap,
        g = function(M) {
            return h in M
        },
        r = [].filter,
        s = function(M) {
            var B = new y,
                N = function(V, J) {
                    var ee;
                    if (J)
                        for (var be,
                                it =
                                function(
                                    fe
                                    ) {
                                    return fe
                                        .matches ||
                                        fe
                                        .webkitMatchesSelector ||
                                        fe
                                        .msMatchesSelector
                                }(
                                V),
                                Ae =
                                0,
                                ht =
                                j
                                .length; Ae <
                            ht; Ae++
                            ) it
                            .call(V,
                                be =
                                j[
                                    Ae]
                                ) &&
                            (B.has(
                                    V) ||
                                B
                                .set(
                                    V,
                                    new v
                                    ),
                                (ee =
                                    B
                                    .get(
                                        V
                                        )
                                    )
                                .has(
                                    be
                                    ) ||
                                (ee.add(
                                        be),
                                    M
                                    .handle(
                                        V,
                                        J,
                                        be
                                        )
                                    )
                                );
                    else B.has(V) &&
                        (ee = B.get(
                                V),
                            B
                            .delete(
                                V),
                            ee
                            .forEach(
                                function(
                                    fe
                                    ) {
                                    M.handle(
                                        V,
                                        J,
                                        fe
                                        )
                                }))
                },
                X = function(V) {
                    for (var J = !(
                                arguments
                                .length >
                                1 &&
                                arguments[
                                    1
                                    ] !==
                                void 0
                                ) ||
                            arguments[
                                1],
                            ee = 0,
                            be = V
                            .length; ee <
                        be; ee++) N(
                        V[ee], J
                        )
                },
                j = M.query,
                U = M.root || p,
                Q = function(V) {
                    var J =
                        arguments
                        .length >
                        1 &&
                        arguments[
                        1] !==
                        void 0 ?
                        arguments[
                        1] :
                        document,
                        ee =
                        arguments
                        .length >
                        2 &&
                        arguments[
                        2] !==
                        void 0 ?
                        arguments[
                        2] :
                        MutationObserver,
                        be =
                        arguments
                        .length >
                        3 &&
                        arguments[
                        3] !==
                        void 0 ?
                        arguments[
                        3] : ["*"],
                        it =
                        function fe(
                            st, Qe,
                            He, Be,
                            ye, Ke
                            ) {
                            var rt,
                                Ye =
                                t(
                                    st);
                            try {
                                for (
                                    Ye
                                    .s(); !
                                    (rt =
                                        Ye
                                        .n()
                                        )
                                    .done;
                                    ) {
                                    var le =
                                        rt
                                        .value;
                                    (Ke ||
                                        o in
                                        le
                                        ) &&
                                    (ye ?
                                        He
                                        .has(
                                            le
                                            ) ||
                                        (He.add(
                                                le),
                                            Be
                                            .delete(
                                                le
                                                ),
                                            V(le,
                                                ye
                                                )
                                            ) :
                                        Be
                                        .has(
                                            le
                                            ) ||
                                        (Be.add(
                                                le),
                                            He
                                            .delete(
                                                le
                                                ),
                                            V(le,
                                                ye
                                                )
                                            ),
                                        Ke ||
                                        fe(le[
                                                o]
                                            (
                                                Qe),
                                            Qe,
                                            He,
                                            Be,
                                            ye,
                                            i
                                            )
                                        )
                                }
                            } catch (
                                Yt
                                ) {
                                Ye.e(
                                    Yt)
                            } finally {
                                Ye.f()
                            }
                        },
                        Ae = new ee(
                            function(
                                fe
                                ) {
                                if (be
                                    .length
                                    ) {
                                    var st,
                                        Qe =
                                        be
                                        .join(
                                            ","
                                            ),
                                        He =
                                        new Set,
                                        Be =
                                        new Set,
                                        ye =
                                        t(
                                            fe);
                                    try {
                                        for (
                                            ye
                                            .s(); !
                                            (st =
                                                ye
                                                .n()
                                                )
                                            .done;
                                            ) {
                                            var Ke =
                                                st
                                                .value,
                                                rt =
                                                Ke
                                                .addedNodes,
                                                Ye =
                                                Ke
                                                .removedNodes;
                                            it(Ye, Qe,
                                                    He,
                                                    Be,
                                                    a,
                                                    a
                                                    ),
                                                it(rt,
                                                    Qe,
                                                    He,
                                                    Be,
                                                    i,
                                                    a
                                                    )
                                        }
                                    } catch (
                                        le
                                        ) {
                                        ye.e(
                                            le)
                                    } finally {
                                        ye.f()
                                    }
                                }
                            }),
                        ht = Ae
                        .observe;
                    return (Ae
                            .observe =
                            function(
                                fe
                                ) {
                                return ht
                                    .call(
                                        Ae,
                                        fe, {
                                            subtree: i,
                                            childList: i
                                        }
                                        )
                            })(J),
                        Ae
                }(N, U, n, j),
                re = f.prototype
                .attachShadow;
            return re && (f
                    .prototype
                    .attachShadow =
                    function(V) {
                        var J = re
                            .call(
                                this,
                                V);
                        return Q
                            .observe(
                                J),
                            J
                    }), j.length &&
                X(U[h](j)), {
                    drop: function(
                        V) {
                        for (var J =
                                0,
                                ee =
                                V
                                .length; J <
                            ee; J++
                            ) B
                            .delete(
                                V[
                                    J]
                                )
                    },
                    flush: function() {
                        for (var V =
                                Q
                                .takeRecords(),
                                J =
                                0,
                                ee =
                                V
                                .length; J <
                            ee; J++
                            ) X(r
                                .call(
                                    V[
                                        J]
                                    .removedNodes,
                                    g
                                    ),
                                !
                                1
                                ),
                            X(r.call(
                                    V[
                                        J]
                                    .addedNodes,
                                    g
                                    ),
                                !
                                0
                                )
                    },
                    observer: Q,
                    parse: X
                }
        },
        d = self,
        m = d.document,
        l = d.Map,
        c = d.MutationObserver,
        b = d.Object,
        A = d.Set,
        $ = d.WeakMap,
        I = d.Element,
        q = d.HTMLElement,
        E = d.Node,
        D = d.Error,
        O = d.TypeError,
        _ = d.Reflect,
        C = b.defineProperty,
        T = b.keys,
        z = b.getOwnPropertyNames,
        R = b.setPrototypeOf,
        S = !self.customElements,
        x = function(M) {
            for (var B = T(M),
                    N = [], X =
                    new A, j = B
                    .length, U =
                    0; U < j; U++) {
                N[U] = M[B[U]];
                try {
                    delete M[B[U]]
                } catch {
                    X.add(U)
                }
            }
            return function() {
                for (var Q =
                    0; Q <
                    j; Q++) X
                    .has(Q) || (
                        M[B[
                        Q]] = N[
                            Q])
            }
        };
    if (S) {
        var H = function() {
                var M = this
                    .constructor;
                if (!K.has(M))
                throw new O(
                        "Illegal constructor"
                        );
                var B = K.get(M);
                if (k) return te(k,
                    B);
                var N = Y.call(m,
                B);
                return te(R(N, M
                    .prototype
                    ), B)
            },
            Y = m.createElement,
            K = new l,
            Z = new l,
            ne = new l,
            de = new l,
            P = [],
            L = s({
                query: P,
                handle: function(
                    M, B, N
                    ) {
                    var X =
                        ne
                        .get(
                            N
                            );
                    if (B &&
                        !X
                        .isPrototypeOf(
                            M
                            )
                        ) {
                        var j =
                            x(
                                M);
                        k = R(M,
                            X);
                        try {
                            new X
                                .constructor
                        } finally {
                            k = null,
                                j()
                        }
                    }
                    var U =
                        ""
                        .concat(
                            B ?
                            "" :
                            "dis",
                            "connectedCallback"
                            );
                    U in X &&
                        M[U]
                        ()
                }
            }).parse,
            k = null,
            G = function(M) {
                if (!Z.has(M)) {
                    var B, N =
                        new Promise(
                            function(
                                X) {
                                B = X
                            });
                    Z.set(M, {
                        $: N,
                        _: B
                    })
                }
                return Z.get(M).$
            },
            te = u(G, c);
        self.customElements = {
                define: function(M,
                    B) {
                    if (de.has(
                            M))
                        throw new D(
                            'the name "'
                            .concat(
                                M,
                                '" has already been used with this registry'
                                )
                            );
                    K.set(B, M),
                        ne.set(
                            M, B
                            .prototype
                            ),
                        de.set(
                            M, B
                            ), P
                        .push(
                        M), G(M)
                        .then(
                            function() {
                                L(m.querySelectorAll(
                                    M
                                    ))
                            }),
                        Z.get(M)
                        ._(B)
                },
                get: function(M) {
                    return de
                        .get(M)
                },
                whenDefined: G
            }, C(H.prototype = q
                .prototype,
                "constructor", {
                    value: H
                }), self
            .HTMLElement = H, m
            .createElement =
            function(M, B) {
                var N = B && B.is,
                    X = N ? de.get(
                        N) : de.get(
                        M);
                return X ? new X : Y
                    .call(m, M)
            }, "isConnected" in E
            .prototype || C(E
                .prototype,
                "isConnected", {
                    configurable: !
                        0,
                    get: function() {
                        return !
                            (this
                                .ownerDocument
                                .compareDocumentPosition(
                                    this
                                    ) &
                                this
                                .DOCUMENT_POSITION_DISCONNECTED
                                )
                    }
                })
    } else if (S = !self
        .customElements.get(
            "extends-br")) try {
        var pe = function M() {
            return self
                .Reflect
                .construct(
                    HTMLBRElement,
                    [], M)
        };
        pe.prototype =
            HTMLLIElement
            .prototype;
        var ue = "extends-br";
        self.customElements
            .define(
                "extends-br",
                pe, {
                    extends: "br"
                }), S = m
            .createElement(
            "br", {
                is: ue
            }).outerHTML
            .indexOf(ue) < 0;
        var oe = self
            .customElements,
            he = oe.get,
            ie = oe.whenDefined;
        self.customElements
            .whenDefined =
            function(M) {
                var B = this;
                return ie.call(
                        this, M)
                    .then(
                        function(
                            N) {
                            return N ||
                                he
                                .call(
                                    B,
                                    M
                                    )
                        })
            }
    } catch {}
    if (S) {
        var ae = function(M) {
                var B = $e.get(M);
                Et(B.querySelectorAll(
                        this), M
                    .isConnected
                    )
            },
            se = self
            .customElements,
            De = m.createElement,
            xe = se.define,
            Ce = se.get,
            Xe = se.upgrade,
            Ve = _ || {
                construct: function(
                    M) {
                    return M
                        .call(
                            this
                            )
                }
            },
            Fe = Ve.construct,
            $e = new $,
            qe = new A,
            Te = new l,
            Me = new l,
            ve = new l,
            Oe = new l,
            Le = [],
            et = [],
            yt = function(M) {
                return Oe.get(M) ||
                    Ce.call(se, M)
            },
            Et = s({
                query: et,
                handle: function(
                    M, B, N
                    ) {
                    var X =
                        ve
                        .get(
                            N
                            );
                    if (B &&
                        !X
                        .isPrototypeOf(
                            M
                            )
                        ) {
                        var j =
                            x(
                                M);
                        tt = R(M,
                            X
                            );
                        try {
                            new X
                                .constructor
                        } finally {
                            tt = null,
                                j()
                        }
                    }
                    var U =
                        ""
                        .concat(
                            B ?
                            "" :
                            "dis",
                            "connectedCallback"
                            );
                    U in X &&
                        M[U]
                        ()
                }
            }).parse,
            Vt = s({
                query: Le,
                handle: function(
                    M, B) {
                    $e.has(
                            M) &&
                        (B ? qe
                            .add(
                                M
                                ) :
                            qe
                            .delete(
                                M
                                ),
                            et
                            .length &&
                            ae
                            .call(
                                et,
                                M
                                )
                            )
                }
            }).parse,
            St = I.prototype
            .attachShadow;
        St && (I.prototype
            .attachShadow =
            function(M) {
                var B = St.call(
                    this, M);
                return $e.set(
                        this, B
                        ), B
            });
        var ut = function(M) {
                if (!Me.has(M)) {
                    var B, N =
                        new Promise(
                            function(
                                X) {
                                B = X
                            });
                    Me.set(M, {
                        $: N,
                        _: B
                    })
                }
                return Me.get(M).$
            },
            ft = u(ut, c),
            tt = null;
        z(self).filter(function(M) {
                return /^HTML.*Element$/
                    .test(M)
            }).forEach(function(M) {
                var B = self[M];

                function N() {
                    var X = this
                        .constructor;
                    if (!Te.has(
                            X))
                        throw new O(
                            "Illegal constructor"
                            );
                    var j = Te
                        .get(X),
                        U = j
                        .is,
                        Q = j
                        .tag;
                    if (U) {
                        if (tt)
                            return ft(
                                tt,
                                U
                                );
                        var re =
                            De
                            .call(
                                m,
                                Q
                                );
                        return re
                            .setAttribute(
                                "is",
                                U
                                ),
                            ft(R(re, X
                                    .prototype
                                    ),
                                U
                                )
                    }
                    return Fe
                        .call(
                            this,
                            B,
                            [],
                            X)
                }
                C(N.prototype =
                    B
                    .prototype,
                    "constructor", {
                        value: N
                    }), C(
                    self,
                    M, {
                        value: N
                    })
            }), m.createElement =
            function(M, B) {
                var N = B && B.is;
                if (N) {
                    var X = Oe.get(
                        N);
                    if (X && Te.get(
                            X)
                        .tag === M)
                        return new X
                }
                var j = De.call(m,
                    M);
                return N && j
                    .setAttribute(
                        "is", N), j
            }, se.get = yt, se
            .whenDefined = ut, se
            .upgrade = function(M) {
                var B = M
                    .getAttribute(
                        "is");
                if (B) {
                    var N = Oe.get(
                        B);
                    if (N) return void ft(
                        R(M, N
                            .prototype
                            ),
                        B)
                }
                Xe.call(se, M)
            }, se.define = function(
                M, B, N) {
                if (yt(M))
                throw new D("'"
                        .concat(
                            M,
                            "' has already been defined as a custom element"
                            ));
                var X, j = N && N
                    .extends;
                Te.set(B, j ? {
                        is: M,
                        tag: j
                    } : {
                        is: "",
                        tag: M
                    }), j ? (X = ""
                        .concat(j,
                            '[is="')
                        .concat(M,
                            '"]'),
                        ve.set(X, B
                            .prototype
                            ), Oe
                        .set(M, B),
                        et.push(X)
                        ) : (xe
                        .apply(se,
                            arguments
                            ), Le
                        .push(X = M)
                        ), ut(M)
                    .then(
                function() {
                        j ? (Et(m.querySelectorAll(
                                    X
                                    )),
                                qe
                                .forEach(
                                    ae,
                                    [
                                        X]
                                    )
                                ) :
                            Vt(m.querySelectorAll(
                                X
                                ))
                    }), Me.get(M)._(
                        B)
            }
    }
})();
class qt extends HTMLElement {
    constructor() {
        super(), this.steps = this
            .querySelectorAll(
                "[data-step]"), this
            .previousStepStates =
            new Map, this
            .giftInformation = this
            ._createStepMap()
    }
    add(e) {
        this._updateValue(this
            .value + e)
    }
    subtract(e) {
        this._updateValue(this
            .value - e)
    }
    get giftInfo() {
        return this.giftInformation
    }
    get value() {
        return parseInt(this.dataset
            .value)
    }
    set value(e) {
        this._updateValue(e)
    }
    get minValue() {
        return parseInt(this.dataset
            .min)
    }
    get maxValue() {
        return parseInt(this.dataset
            .max)
    }
    _updateValue(e) {
        typeof e == "number" ? (this
                .dataset.value = e,
                this._updateSteps()
                ) : console.error(
                `Value ${e} is not a number`
                )
    }
    _createStepMap() {
        const e = {};
        return this.steps.forEach(
            t => {
                const i = t
                    .getAttribute(
                        "data-value"
                        ),
                    a = t
                    .getAttribute(
                        "data-gift-info"
                        );
                i && a && (e[
                    i] = a)
            }), e
    }
    _updateSteps() {
        this.steps.forEach((e,
        t) => {
            const i =
                parseInt(e
                    .dataset
                    .value),
                a = this
                .value >= i,
                o = this
                .previousStepStates
                .get(i) || !
                1;
            e.setAttribute(
                    "aria-checked",
                    a), a &&
                !o ? this
                ._handleStepAchievement(
                    t, i) :
                !a && o &&
                this
                ._handleStepUnachievement(
                    t, i),
                this
                .previousStepStates
                .set(i, a)
        })
    }
    _handleStepAchievement(e, t) {}
    _handleStepUnachievement(e, t) {}
    _handleMinValueAchievement() {}
    _handleMaxValueAchievement() {}
    attributeChangedCallback(e, t, i) {
        if (e === "data-value") {
            t = parseInt(t), i =
                parseInt(i), t <
                this.maxValue &&
                i >= this
                .maxValue && this
                ._handleMaxValueAchievement(),
                t > this.minValue &&
                i <= this
                .minValue && this
                ._handleMaxValueAchievement();
            const a = Math.round((
                        this.value -
                        this
                        .minValue) /
                    this.maxValue *
                    100),
                o = a >= 0 ? Math
                .min(a, 100) : Math
                .max(a, 0);
            this.style.setProperty(
                    "--position", o
                    ), this
                ._updateSteps()
        }
    }
}
mt(qt, "observedAttributes", [
    "data-value"
]);
window.customElements.define(
    "progress-bar", qt);
class Ot extends HTMLElement {
    constructor() {
        super(), this._content =
            null
    }
    connectedCallback() {
        const e = this
            .querySelector(
                ".js-backdrop");
        e && e.addEventListener(
            "click", this.close
            .bind(this))
    }
    open() {
        document.documentElement
            .style.overflow =
            "hidden", this
            .expanded = !0
    }
    close() {
        document.documentElement
            .style.overflow = "",
            this.expanded = !1
    }
    toggle() {
        this.expanded ? this
        .close() : this.open()
    }
    onTrigger(e, t, i = "open") {
        var a;
        if (!t) {
            console.error(
                "Trigger element isn't specified"
                );
            return
        }
        t.addEventListener(e, (a =
                this[i]) ==
            null ? void 0 : a
            .bind(this))
    }
    get expanded() {
        return this.getAttribute(
                "aria-expanded") ===
            "true"
    }
    set expanded(e) {
        this.setAttribute(
            "aria-expanded", !!e
            )
    }
    get content() {
        return this._content || (
                this._content = this
                .querySelector(
                    ".js-content")),
            this._content
    }
}
class Ht extends Ot {
    constructor() {
        super(), this
            .currentContentKey =
            null
    }
    onTrigger(e, t, i = "open", a) {
        if (!t) {
            console.error(
                "Trigger element isn't specified"
                );
            return
        }
        if (["open", "toggle"]
            .includes(i) && !a) {
            console.error(
                "Content key is required for action: ",
                i);
            return
        }
        t.addEventListener(e,
    () => {
            var o;
            (o = this[i]) ==
            null || o.call(
                this, a)
        })
    }
    open(e) {
        if (this.dataset
            .checkContent ===
            "true" && this
            .currentContentKey !== e
            ) {
            const t = document
                .querySelector(
                    `[data-modal-content="${e}"]`
                    );
            if (!t) {
                console.error(
                    "Content wasn't found"
                    );
                return
            }
            this.currentContentKey =
                e, this.content
                .innerHTML = t
                .innerHTML
        }
        super.open()
    }
    toggle(e) {
        this.expanded ? this
        .close() : this.open(e)
    }
}
class Ni extends Ht {
    async open(e) {
        if (this
            .currentContentKey !== e
            ) try {
            const t =
                await fetch(
                    `?section_id=${e}`
                    );
            if (!t.ok) {
                console.error(
                    "Failed to fetch content"
                    );
                return
            }
            const i = await t
                .text(),
                a = document
                .createElement(
                    "div");
            a.innerHTML = i;
            const o = a
                .querySelector(
                    "#fetch-content"
                    );
            if (!o) {
                console.error(
                    "Content wasn't found"
                    );
                return
            }
            this.currentContentKey =
                e, this.content
                .innerHTML = o
                .innerHTML
        } catch (t) {
            console.error(
                "Error fetching content:",
                t);
            return
        }
        document.documentElement
            .style.overflow =
            "hidden", this
            .expanded = !0
    }
}
class Xi extends HTMLElement {
    connectedCallback() {
        const e = this.dataset
            .modalSelector ||
            "g-modal",
            t = this.dataset
            .event || "click",
            i = this.dataset
            .action || "open",
            a = this.dataset
            .contentKey,
            o = document
            .querySelector(e);
        o ? o.onTrigger(t, this, i,
            a) : console.error(
            "Modal wasn't found"
            )
    }
}
customElements.define("g-modal", Ot);
customElements.define("dynamic-modal",
    Ht);
customElements.define("fetch-modal",
Ni);
customElements.define("modal-trigger",
    Xi);
const Vi = 300,
    Yi = 999,
    ke = {
        ADD_ITEM: "Error adding item to cart:",
        UPDATE_ITEM: "Error updating cart item:",
        FETCH_SECTION: "Error fetching cart section:",
        APPLY_PROMOCODE: "Error applying promocode:",
        UPDATE_CART: "Error updating cart:",
        INVALID_PROMOCODE: "Invalid promocode.",
        APPLY_PROMOCODE_ERROR: "Error applying promocode."
    },
    Se = {
        DRAWER: "[data-cart-drawer]",
        PAGE: "[data-cart-page]",
        OPEN_CART: "[data-open-cart]",
        CLOSE_BUTTON: "[data-close-button]",
        OVERLAY: "[data-cart-overlay]",
        MAIN_CONTENT: "[data-cart-main-content]"
    };
let me = null;
document.addEventListener(
    "DOMContentLoaded", () => {
        me = document.querySelector(
                Se.DRAWER), document
            .querySelectorAll(Se
                .OPEN_CART).forEach(
                u => u
                .addEventListener(
                    "click", e => {
                        e
                    .stopPropagation();
                        const t =
                            document
                            .querySelector(
                                ".mobile-menu"
                                ),
                            i =
                            document
                            .querySelector(
                                "[data-menu-toggle]"
                                ),
                            a =
                            document
                            .querySelector(
                                "#locator_modal_window"
                                );
                        a && a
                            .expanded &&
                            a
                            .close(),
                            t && t
                            .classList
                            .contains(
                                "is-open"
                                ) &&
                            (i ==
                                null ||
                                i
                                .click()
                                ),
                            me !=
                            null &&
                            me
                            .expanded ?
                            me
                            .closeCart() :
                            me ==
                            null ||
                            me
                            .openCart()
                    }))
    });
class Bt extends HTMLElement {
    constructor() {
        super(), this.progressBar =
            this.querySelector(
                "progress-bar"),
            this._giftInfoArr = null
    }
    async addCartItem(e, t, i = {}) {
        try {
            const a = await _e.cart
                .addItem(e, t, [this
                    .dataset
                    .sectionId
                ], null, i);
            a && await this.update(
                a)
        } catch (a) {
            throw console.error(ke
                .ADD_ITEM, a), a
        }
    }
    async updateCartItem(e, t) {
        try {
            const i = await _e.cart
                .updateItem(e, t, [
                    this.dataset
                    .sectionId
                ]);
            i && await this.update(
                i)
        } catch (i) {
            throw console.error(ke
                    .UPDATE_ITEM, i
                    ), i
        }
    }
    async update(e) {
        const t = await this
            ._normalizeCartData(e);
        await this
            ._updateGiftsInCart(
            t) || this
            ._updateCartDisplay(t),
            this
            ._updateCartEmptyAttribute(
                t)
    }
    async _normalizeCartData(e) {
        if (e.total_price) return e;
        const t = await _e.cart
            .getAll();
        return t.sections = e
            .sections, t
    }
    async _updateGiftsInCart(e) {
        if (this.giftInfoArr
            .length === 0) return !
        1;
        const t = this
            ._calculateTotalWithoutGifts(
                e);
        let i = !1;
        for (const a of this
                .giftInfoArr) {
            const o = this
                ._findGiftInCart(e,
                    a.variantId);
            this._shouldAddGift(o, a
                    .amount, t) ? (
                    await this
                    .addCartItem(a
                        .variantId,
                        1, {
                            __isGift:
                                !0
                        }), i = !0
                    ) : this
                ._shouldRemoveGift(
                    o, a.amount, t
                    ) && (await this
                    .updateCartItem(
                        o, 0), i = !
                    0)
        }
        return i
    }
    _calculateTotalWithoutGifts(e) {
        var t;
        return ((t = e.items) ==
            null ? void 0 : t
            .reduce((i, a) => {
                var o;
                return ((o = a
                            .properties
                            ) ==
                        null ?
                        void 0 :
                        o
                        .__isGift
                        ) ===
                    !0 ? i :
                    i + (a
                        .line_price ||
                        0)
            }, 0)) || 0
    }
    _findGiftInCart(e, t) {
        var i, a;
        return ((a = (i = e
                    .items) ==
                    null ? void 0 :
                    i.find(o => {
                        var h;
                        return o
                            .variant_id ===
                            t &&
                            ((h = o
                                    .properties) ==
                                null ?
                                void 0 :
                                h
                                .__isGift
                                ) ===
                            !0
                    })) == null ?
                void 0 : a.key) ||
            null
    }
    _shouldAddGift(e, t, i) {
        return !e && t <= i
    }
    _shouldRemoveGift(e, t, i) {
        return e && t > i
    }
    _updateCartDisplay(e) {
        if (!(e != null && e
                .sections)) {
            console.warn(
                "No data or sections received"
                );
            return
        }
        const t = this
            ._createTempElement(e
                .sections[this
                    .dataset
                    .sectionId]);
        if (!e.items || e.items
            .length === 0) {
            const a = this
                .querySelector(
                    "[data-cart-container]"
                    ),
                o = t.querySelector(
                    "[data-cart-container]"
                    );
            if (a && o) {
                a.innerHTML = o
                    .innerHTML;
                return
            }
        }
        this._updateBlocks(t), this
            ._updateProgressBar(e
                .total_price)
    }
    _createTempElement(e) {
        const t = document
            .createElement("div");
        return t.innerHTML = e, t
    }
    _updateBlocks(e) {
        this.blockSelectors.forEach(
            t => {
                const i = this
                    .querySelector(
                        t),
                    a = e
                    .querySelector(
                        t);
                i && a && (i
                    .innerHTML =
                    a
                    .innerHTML
                    )
            })
    }
    _updateProgressBar(e) {
        this.progressBar && (this
            .progressBar.value =
            e)
    }
    _updateCartEmptyAttribute(e) {
        const t = !e.items || e
            .items.length === 0;
        this.setAttribute(
            "data-cart-empty",
            t ? "true" : "false"
            );
        const i = document
            .querySelector(
                "[data-open-cart]");
        if (i) {
            const a = e.items ? e
                .items.reduce((o,
                    h) => o + h
                    .quantity, 0) :
                0;
            i.setAttribute(
                "data-qnt", a)
        }
    }
    async getSectionsJson() {
        try {
            const e = await fetch(
                `/?sections=${this.dataset.sectionId}`
                );
            if (!e.ok)
            throw new Error(
                    `Failed to fetch section: ${e.statusText}`
                    );
            return await e.json()
        } catch (e) {
            throw console.error(ke
                .FETCH_SECTION,
                e), e
        }
    }
    get giftInfoArr() {
        if (!this._giftInfoArr) {
            const e = this
                .querySelector(
                    "[data-gift-info-arr]"
                    );
            this._giftInfoArr = e ?
                JSON.parse(e
                    .innerHTML) : []
        }
        return this._giftInfoArr
    }
    get blockSelectors() {
        return ["[data-cart-products]",
            "[data-cart-upsells]",
            "[data-cart-header-count]",
            "[data-cart-summary]",
            "[data-cart-button-container]",
            "[data-progress-bar-message]"
        ]
    }
}
class ji extends Bt {
    constructor() {
        super(), this.closeButton =
            this.querySelector(Se
                .CLOSE_BUTTON), this
            .overlay = this
            .querySelector(Se
                .OVERLAY)
    }
    connectedCallback() {
        this._setupEventListeners(),
            this
            ._setupResizeListener()
    }
    _setupEventListeners() {
        var e, t;
        window.addEventListener(
                "cart:open", () => {
                    this.expanded = !
                        0, this
                        ._setupResizeListener()
                }), window
            .addEventListener(
                "cart:rerender",
                async i => {
                    await this
                        ._handleCartRerender(
                            i)
                }), (e = this
                .overlay) == null ||
            e.addEventListener(
                "click", this
                .closeCart.bind(
                    this)), (t =
                this.closeButton) ==
            null || t
            .addEventListener(
                "click", this
                .closeCart.bind(
                    this))
    }
    async _handleCartRerender(e) {
        if (this.expanded) return;
        const {
            cart: t,
            open: i
        } = e.detail, a = await this
            .getSectionsJson();
        await this.update({
            ...t,
            sections: a
        }), i && (this
            .expanded = !0)
    }
    set expanded(e) {
        this.ariaExpanded = e, this
            .ariaHidden = !e,
            document.documentElement
            .style.overflow = e ?
            "hidden" : "visible";
        const t = document
            .querySelector(
                "[data-open-cart]");
        t && t.classList.toggle(
                "is-open", e), e &&
            window.innerWidth <
            1024 && this
            ._positionCartDrawerBelowHeader()
    }
    _positionCartDrawerBelowHeader() {
        const e = document
            .querySelector(
            "header");
        if (e) {
            const i = e
                .getBoundingClientRect()
                .bottom;
            this.style.top = i +
                "px", this.style
                .height =
                `calc(100vh - ${i}px)`
        }
    }
    _setupResizeListener() {
        window.innerWidth < 1024 ?
            this
            ._positionCartDrawerBelowHeader() :
            (this.style.top = "0",
                this.style.height =
                "100%")
    }
    get expanded() {
        return this.ariaExpanded ===
            "true"
    }
    openCart() {
        this.expanded = !0, this
            ._setupResizeListener()
    }
    closeCart() {
        this.expanded = !1
    }
}
customElements.define("cart-drawer",
ji);
class Gi extends Bt {
    constructor() {
        super()
    }
    connectedCallback() {
        window.addEventListener(
            "cart:rerender",
            async e => {
                const {
                    cart: t
                } = e
                    .detail,
                    i =
                    await this
                    .getSectionsJson();
                await this
                    .update({
                        ...
                        t,
                        sections: i
                    })
            })
    }
}
customElements.define("cart-page", Gi);
class Rt extends HTMLElement {
    constructor() {
        super(), this
            ._initializeElements(),
            this
            ._debounceCartUpdateItem =
            Ri(_e.cart.updateItem,
                Vi)
    }
    _initializeElements() {
        this.increaseButton = this
            .querySelector(
                "[data-quantity-increase]"
                ), this
            .decreaseButton = this
            .querySelector(
                "[data-quantity-decrease]"
                ), this
            .removeButton = this
            .querySelector(
                "[data-remove-item-button]"
                ), this
            .inputQuantity = this
            .querySelector(
                "[data-quantity-input]"
                ), this
            ._inputItemKey = this
            .querySelector(
                'input[name="item-key"]'
                ), this
            ._quantityInput = this
            .querySelector(
                "[data-quantity-input]"
                )
    }
    get itemKey() {
        var e;
        return ((e = this
                    ._inputItemKey
                    ) == null ?
                void 0 : e.value) ||
            ""
    }
    get maxQuantity() {
        var e;
        return parseInt((e = this
                ._quantityInput
                ) == null ?
            void 0 : e
            .getAttribute("max")
            ) || Yi
    }
    get currentQuantity() {
        var e;
        return ((e = this
                ._quantityInput
                ) == null ?
            void 0 : e
            .valueAsNumber) || 0
    }
    connectedCallback() {
        this._setupEventListeners()
    }
    _setupEventListeners() {
        this._hasRequiredElements() &&
            (this.removeButton
                .addEventListener(
                    "click", this
                    ._handleRemoveItem
                    .bind(this)),
                this.increaseButton
                .addEventListener(
                    "click", this
                    ._handleIncreaseQuantity
                    .bind(this)),
                this.decreaseButton
                .addEventListener(
                    "click", this
                    ._handleDecreaseQuantity
                    .bind(this)),
                this.inputQuantity
                .addEventListener(
                    "blur", this
                    ._handleQuantityInput
                    .bind(this)),
                this.inputQuantity
                .addEventListener(
                    "keydown", this
                    ._handleKeydown
                    .bind(this)))
    }
    _hasRequiredElements() {
        return this.removeButton &&
            this.increaseButton &&
            this.decreaseButton &&
            this.inputQuantity
    }
    _handleKeydown(e) {
        e.key === "Enter" && this
            ._handleQuantityInput(e)
    }
    _handleRemoveItem(e) {
        e.preventDefault(), this
            .updateCartItem(this
                .itemKey, 0)
    }
    _handleIncreaseQuantity(e) {
        e.preventDefault();
        const t = this
            .currentQuantity;
        if (t < this.maxQuantity) {
            const i = t + 1;
            this._quantityInput
                .value = i, this
                .updateCartItem(this
                    .itemKey, i),
                this
                ._updateQuantityButtonsState()
        }
    }
    _handleDecreaseQuantity(e) {
        e.preventDefault();
        const t = this
            .currentQuantity;
        if (t > 0) {
            const i = t - 1;
            this._quantityInput
                .value = i, this
                .updateCartItem(this
                    .itemKey, i),
                this
                ._updateQuantityButtonsState()
        }
    }
    _handleQuantityInput(e) {
        e.preventDefault();
        const t = parseInt(e.target
            .getAttribute(
                "data-prev-value"
                )) || 0;
        let i = this
        .currentQuantity;
        i === t || i < 0 || (i >
            this.maxQuantity &&
            (i = this
                .maxQuantity,
                this
                ._quantityInput
                .value = this
                .maxQuantity),
            this.updateCartItem(
                this.itemKey, i
                ), this
            ._updateQuantityButtonsState()
            )
    }
    _updateQuantityButtonsState() {
        const e = this
            .currentQuantity;
        this.increaseButton
            .disabled = e >= this
            .maxQuantity, this
            .decreaseButton
            .disabled = e <= 0
    }
    async updateCartItem(e, t) {
        var i;
        t === 0 && (this.ariaBusy =
            "true");
        try {
            (i = this
                .abortController) ==
            null || i.abort(), this
                .abortController =
                new AbortController;
            const a = await _e.cart
                .updateItem(e, t, [
                        this
                        .parentSectionId
                    ], this
                    .abortController
                    .signal);
            await this.cartEl
                .update(a)
        } catch (a) {
            if (a.name ===
                "AbortError")
        return;
            throw a
        }
    }
}
class Wi extends Rt {
    constructor() {
        var e;
        super(), this.cartEl = this
            .closest(Se.PAGE), this
            .parentSectionId = (e =
                this.cartEl) ==
            null ? void 0 : e
            .dataset.sectionId
    }
}
customElements.define("cart-page-item",
    Wi);
class Ui extends Rt {
    constructor() {
        var e;
        super(), this.cartEl = this
            .closest(Se.DRAWER),
            this.parentSectionId = (
                e = this.cartEl) ==
            null ? void 0 : e
            .dataset.sectionId
    }
}
customElements.define(
    "cart-drawer-item", Ui);
class Fi extends HTMLElement {
    constructor() {
        super(), this
            ._initializeElements()
    }
    _initializeElements() {
        var e;
        this.addButton = this
            .querySelector(
                "[data-add-to-cart-button]"
                ), this
            .parentSectionId = (e =
                this.closest(Se
                    .DRAWER)) ==
            null ? void 0 : e
            .dataset.sectionId, this
            ._inputVariantId = this
            .querySelector(
                'input[name="variant-id"]'
                ), this
            ._inputPrice = this
            .querySelector(
                "input[data-price]")
    }
    get variantId() {
        var e;
        return ((e = this
                    ._inputVariantId
                    ) == null ?
                void 0 : e.value) ||
            ""
    }
    get price() {
        var e;
        return parseFloat((e = this
                ._inputPrice) ==
            null ? void 0 : e
            .dataset.price) || 0
    }
    connectedCallback() {
        var e;
        (e = this.addButton) == null
            || e.addEventListener(
                "click", this
                ._handleAddToCart
                .bind(this))
    }
    _handleAddToCart(e) {
        e.preventDefault(), this
            .addButton && this
            .addButton.setAttribute(
                "aria-busy", "true"
                ), this.addCartItem(
                this.variantId, 1)
    }
    async addCartItem(e, t, i = {}) {
        try {
            const a = await _e.cart
                .addItem(e, t, [this
                    .parentSectionId
                ], null, i);
            await me.update(a)
        } catch (a) {
            throw console.error(ke
                .ADD_ITEM, a), a
        }
    }
}
customElements.define(
    "cart-drawer-upsell", Fi);
class Qi extends HTMLElement {
    constructor() {
        super(), this
            ._initializeElements()
    }
    _initializeElements() {
        var e;
        this.parentSectionId = (e =
                this.closest(Se
                    .DRAWER)) ==
            null ? void 0 : e
            .dataset.sectionId, this
            .promocodeInput = this
            .querySelector(
                "[data-promocode-input]"
                ), this
            .promocodeButton = this
            .querySelector(
                "[data-promocode-button]"
                ), this
            .promocodeError = this
            .querySelector(
                "[data-promocode-error]"
                )
    }
    connectedCallback() {
        this._setupEventListeners()
    }
    _setupEventListeners() {
        if (!this.promocodeButton ||
            !this.promocodeInput) {
            console.warn(
                "Promocode button or input not found"
                );
            return
        }
        this.promocodeButton
            .addEventListener(
                "click", this
                ._handlePromoActivator
                .bind(this)), this
            .promocodeInput
            .addEventListener(
                "focus", this
                ._handleInputFocus
                .bind(this))
    }
    _handlePromoActivator(e) {
        e.preventDefault();
        const t = this
            .promocodeInput.value
            .toUpperCase().trim();
        t && this.addPromo(t)
    }
    _handleInputFocus() {
        this._hideError()
    }
    async addPromo(e) {
        var t;
        try {
            this.promocodeInput
                .value = "";
            const i = await _e.cart
                .applyDiscount(e,
                    this
                    .parentSectionId
                    ),
                a = (t = i
                    .discount_codes
                    ) == null ?
                void 0 : t.find(o =>
                    o.code === e);
            a != null && a
                .applicable ? (
                    await me.update(
                        i), this
                    ._hideError()) :
                this._showError(ke
                    .INVALID_PROMOCODE
                    )
        } catch (i) {
            console.error(ke
                    .APPLY_PROMOCODE,
                    i), this
                ._showError(ke
                    .APPLY_PROMOCODE_ERROR
                    )
        }
    }
    _showError(e) {
        this.promocodeError && (this
            .promocodeError
            .textContent = e,
            this.promocodeError
            .ariaHidden = !1)
    }
    _hideError() {
        this.promocodeError && (this
            .promocodeError
            .ariaHidden = !0)
    }
}
customElements.define("cart-promocode",
    Qi);
class Ki extends HTMLElement {
    constructor() {
        super(), this
            ._initializeElements()
    }
    _initializeElements() {
        this._buttonToAddNote = this
            .querySelector(
                "#order-note-toggle"
                ), this
            .mainContainer = this
            .closest(Se
                .MAIN_CONTENT), this
            ._inputGiftWrapping =
            this.querySelector(
                "[data-gift-wrapping-input]"
                ), this
            ._textAreaNote = this
            .querySelector(
                "[data-note-input]")
    }
    connectedCallback() {
        this._setupEventListeners()
    }
    _setupEventListeners() {
        var e, t, i;
        (e = this
        ._buttonToAddNote) == null
            || e.addEventListener(
                "click", this
                ._handleToggleNote
                .bind(this)), (t =
                this._textAreaNote
                ) == null || t
            .addEventListener(
                "blur", this
                ._handleNoteBlur
                .bind(this)), (i =
                this
                ._inputGiftWrapping
                ) == null || i
            .addEventListener(
                "change", this
                ._handleGiftWrappingChange
                .bind(this))
    }
    _handleToggleNote() {
        if (!this.mainContainer)
            return;
        const e = this.mainContainer
            .dataset.noteToggle ===
            "true";
        this.mainContainer.dataset
            .noteToggle = e ?
            "false" : "true"
    }
    _handleNoteBlur() {
        var t;
        const e = ((t = this
                ._textAreaNote
                ) == null ?
            void 0 : t.value
            .trim()) || "";
        this.applyNote({
            note_message: e !==
                ""
        }, e)
    }
    _handleGiftWrappingChange() {
        var i, a;
        const e = ((i = this
                    ._textAreaNote
                    ) == null ?
                void 0 : i.value
                .trim()) || "",
            t = ((a = this
                    ._inputGiftWrapping
                    ) == null ?
                void 0 : a.checked
                ) || !1;
        this.applyNote({
                gift_wrapping: t
            }, t ? e ||
            "Gift wrapping" : e)
    }
    async applyNote(e, t) {
        try {
            await _e.cart
                .updateAttributes(e,
                    t)
        } catch (i) {
            throw console.error(ke
                    .UPDATE_CART, i
                    ), i
        }
    }
}
customElements.define("order-note", Ki);
class Ji {
    async init() {
        const e = await this
            .fetchCart();
        this.storeCart(e), this
            .observeCartChanges()
    }
    async fetchCart() {
        return (await fetch(
            "/cart.js")).json()
    }
    storeCart(e) {
        localStorage.setItem("cart",
            JSON.stringify(e))
    }
    storedCart() {
        return JSON.parse(
            localStorage
            .getItem("cart")) ||
        {
            items: []
        }
    }
    findCartChanges(e, t) {
        const i = (o, h) => o
            .filter(w => !h.some(
                p => w.key == p
                .key));
        let a = {
            added: i(t.items, e
                .items),
            removed: i(e.items,
                t.items)
        };
        return e.items.forEach(
        o => {
            const h = t
                .items.find(
                    f => f
                    .key ==
                    o.key &&
                    f
                    .quantity !=
                    o
                    .quantity
                    );
            if (!h) return;
            let w = h
                .quantity -
                o.quantity,
                p = {
                    ...h,
                    quantity: Math
                        .abs(
                            w
                            )
                };
            w > 0 ? a.added
                .push(p) : a
                .removed
                .push(p)
        }), a
    }
    async emitCartChanges() {
        const e = await this
            .fetchCart(),
            t = this.storedCart(),
            i = this
            .findCartChanges(t, e);
        if (i.added.length > 0 || i
            .removed.length > 0) {
            const a =
                new CustomEvent(
                    "cart:rerender", {
                        detail: {
                            cart: e,
                            open: !0
                        }
                    });
            window.dispatchEvent(a)
        }
    }
    observeCartChanges() {
        new PerformanceObserver(
        t => {
            t.getEntries()
                .forEach(
                    i => {
                        const
                            a = [
                                "xmlhttprequest",
                                "fetch"
                            ]
                            .includes(
                                i
                                .initiatorType
                                ),
                            o =
                            /\/cart\//
                            .test(
                                i
                                .name
                                );
                        a && o &&
                            this
                            .emitCartChanges()
                    })
        }).observe({
            entryTypes: [
                "resource"
            ]
        })
    }
}
const Zi = new Ji;
Zi.init();
class es extends HTMLElement {
    constructor() {
        super(), this.videoSwipers =
            this.querySelectorAll(
                ".js-video-popup"),
            this.videosOpen = this
            .querySelectorAll(
                ".video-toggle"),
            this.videoModals = this
            .querySelectorAll(
                ".js-video-review-modal"
                ), this
            .videoButtons = this
            .querySelectorAll(
                ".js-video-player-button"
                ), this.overlay =
            this.querySelectorAll(
                ".js-video-block-overlay"
                ), this
            .playButtons = this
            .querySelectorAll(
                ".js-play-pause"),
            this.muteButtons = this
            .querySelectorAll(
                ".js-mute"), this
            .videoArray = this
            .querySelectorAll(
                "[id^='main_video_popup_']"
                ), this.openPopup =
            this.openPopup.bind(
                this), this
            .closePopup = this
            .closePopup.bind(this),
            this.handleVideoToggle =
            this.handleVideoToggle
            .bind(this), this
            .resetAndPauseVideo =
            this.resetAndPauseVideo
            .bind(this), this
            .handleMuteToggle = this
            .handleMuteToggle.bind(
                this), this
            .videoReviewCarouselListener =
            this
            .videoReviewCarouselListener
            .bind(this), this
            .shouldAutoplay = this
            .getAttribute(
                "data-autoplay-video"
                ) === "true"
    }
    connectedCallback() {
        this.initListeners(), this
            .shouldAutoplay && this
            .setupVideoEndListeners()
    }
    initListeners() {
        this.overlay.length > 0 &&
            this.overlay.forEach(
                e => {
                    e.addEventListener(
                        "click",
                        () => {
                            const
                                t =
                                Array
                                .from(
                                    this
                                    .videoModals
                                    )
                                .find(
                                    i =>
                                    i
                                    .classList
                                    .contains(
                                        "active"
                                        )
                                    );
                            t && this
                                .closePopup(
                                    t
                                    )
                        })
                }), this.videosOpen
            .length > 0 && this
            .videosOpen.forEach(
            e => {
                e.addEventListener(
                    "click",
                    this
                    .handleVideoToggle
                    )
            }), this.muteButtons
            .length > 0 && this
            .muteButtons.forEach(
                e => {
                    e.addEventListener(
                        "click",
                        this
                        .handleMuteToggle
                        )
                }), this.playButtons
            .length > 0 && this
            .playButtons.forEach(
                e => {
                    e.addEventListener(
                        "click",
                        t => {
                            this.handlePlayPauseToggle(
                                t
                                .currentTarget
                                )
                        })
                }), this
            .videoReviewCarouselListener()
    }
    openPopup(e) {
        e.classList.add("active"),
            document.documentElement
            .style.overflow =
            "hidden", this
            .videoSwipers.length >
            0 && this.videoSwipers
            .forEach((t, i) => {
                if (!t.swiper) {
                    console
                        .warn(
                            `Swiper not initialized for popup ${i}`
                            );
                    return
                }
                t.swiper.on(
                    "slideChange",
                    () => {
                        this.resetAndPauseVideo(),
                            this
                            .shouldAutoplay &&
                            setTimeout(
                                () => {
                                    this.playActiveSlideVideo()
                                },
                                0
                                )
                    })
            }), this
            .shouldAutoplay && this
            .playActiveSlideVideo()
    }
    closePopup(e) {
        this.resetAndPauseVideo(), e
            .classList.remove(
                "active"), document
            .documentElement.style
            .overflow = "visible",
            this.videoButtons
            .forEach(t => {
                t.setAttribute(
                    "data-state",
                    "inactive"
                    )
            })
    }
    handlePlayPauseToggle(e) {
        if (e.getAttribute(
                "data-state") ===
            "pause") {
            e.setAttribute(
                "data-state",
                "play");
            let i = !1;
            this.videoArray.forEach(
                a => {
                    const o = a
                        .closest(
                            ".swiper-slide-active"
                            );
                    if (o && !
                        i) {
                        const
                            h =
                            o
                            .querySelector(
                                ".js-play"
                                );
                        i = !0,
                            a
                            .play(),
                            h &&
                            (h.style
                                .opacity =
                                "0"
                                )
                    }
                })
        } else e.setAttribute(
                "data-state",
                "pause"), this
            .videoArray.forEach(
            i => {
                if (!i.paused) {
                    i.pause();
                    const a = i
                        .closest(
                            "[data-video-block]"
                            );
                    if (a) {
                        const
                            o =
                            a
                            .querySelector(
                                ".js-play"
                                );
                        o && (o.style
                            .opacity =
                            "1"
                            )
                    }
                }
            })
    }
    handleVideoToggle(e) {
        const t = e.currentTarget,
            i = parseInt(t.dataset
                .activeSlide, 10);
        Array.from(this.videoModals)
            .find(o => o.classList
                .contains("active")
                ) ? this.videoModals
            .forEach(o => {
                o.classList
                    .contains(
                        "active"
                        ) &&
                    this
                    .closePopup(
                        o)
            }) : this.videoModals
            .forEach(o => {
                this.openPopup(
                    o)
            }), this.videoSwipers
            .forEach(o => {
                o.swiper
                    .slideTo(i)
            })
    }
    resetAndPauseVideo() {
        this.videoArray.length !==
            0 && (this
                .shouldAutoplay ||
                this.playButtons
                .forEach(e => {
                    e.setAttribute(
                        "data-state",
                        "pause"
                        )
                }), this.videoArray
                .forEach(e => {
                    const t = e
                        .closest(
                            "[data-video-block]"
                            );
                    e.pause(), e
                        .load(),
                        e
                        .currentTime =
                        0, t &&
                        (t.querySelector(
                                ".js-inner-timeline"
                                )
                            .style
                            .width =
                            "0",
                            t
                            .querySelector(
                                ".js-play"
                                )
                            .style
                            .opacity =
                            "1")
                }))
    }
    handleMuteToggle(e) {
        const i = e.currentTarget
            .getAttribute(
                "data-state") ===
            "mute";
        this.videoArray.forEach(
            a => {
                a.muted = i
            }), this.muteButtons
            .forEach(a => {
                a.setAttribute(
                    "data-state",
                    i ?
                    "unmute" :
                    "mute")
            })
    }
    videoReviewCarouselListener() {
        this.videoArray.length !==
            0 && this.videoArray
            .forEach(e => {
                const t = e
                    .closest(
                        "[data-video-block]"
                        );
                t && (this
                    .handleTimeUpdate(
                        e, t
                        ),
                    this
                    .handlePlayButtonClick(
                        e, t
                        ),
                    this
                    .handleTimelineClick(
                        e, t
                        ))
            })
    }
    handleTimeUpdate(e, t) {
        e.addEventListener(
            "timeupdate",
        () => {
                let i = e
                    .currentTime /
                    e.duration *
                    100;
                e.ended && !this
                    .shouldAutoplay &&
                    (this
                        .playButtons
                        .forEach(
                            a => {
                                a.setAttribute(
                                    "data-state",
                                    "pause"
                                    )
                            }),
                        t
                        .querySelector(
                            ".js-play"
                            )
                        .style
                        .opacity =
                        "1"),
                    i = i >=
                    99 ?
                    "100%" :
                    `${i}%`, t
                    .querySelector(
                        ".js-inner-timeline"
                        ).style
                    .width = i
            })
    }
    handlePlayButtonClick(e, t) {
        t.querySelector(".js-play")
            .addEventListener(
                "click", () => {
                    e.paused ? (this
                            .playButtons
                            .forEach(
                                i => {
                                    i.setAttribute(
                                        "data-state",
                                        "play"
                                        )
                                }),
                            t
                            .querySelector(
                                ".js-play"
                                )
                            .style
                            .opacity =
                            "0", e
                            .play()
                            ) : (
                            this
                            .playButtons
                            .forEach(
                                i => {
                                    i.setAttribute(
                                        "data-state",
                                        "pause"
                                        )
                                }),
                            t
                            .querySelector(
                                ".js-play"
                                )
                            .style
                            .opacity =
                            "1", e
                            .pause()
                            )
                })
    }
    handleTimelineClick(e, t) {
        t.querySelector(
                ".js-timeline")
            .addEventListener(
                "click", i => {
                    const a = i
                        .target
                        .closest(
                            ".js-timeline"
                            );
                    if (a) {
                        const o = a
                            .getBoundingClientRect(),
                            w = (i
                                .clientX -
                                o
                                .left
                                ) /
                            o.width;
                        e.currentTime =
                            w * e
                            .duration
                    }
                })
    }
    playActiveSlideVideo() {
        this.shouldAutoplay && this
            .videoArray.forEach(
            e => {
                const t = e
                    .closest(
                        "[data-video-block]"
                        );
                if (t && t
                    .classList
                    .contains(
                        "swiper-slide-active"
                        ) && t
                    ) {
                    const a = t
                        .querySelector(
                            ".js-play"
                            );
                    a && (a.style
                            .opacity =
                            "0"
                            ), e
                        .play()
                        .catch(
                            o => {
                                console
                                    .error(
                                        "Error playing video:",
                                        o
                                        )
                            }),
                        this
                        .playButtons
                        .forEach(
                            o => {
                                o.setAttribute(
                                    "data-state",
                                    "play"
                                    )
                            })
                }
            })
    }
    setupVideoEndListeners() {
        this.shouldAutoplay && this
            .videoArray.forEach(
            e => {
                e.addEventListener(
                    "ended",
                    () => {
                        const
                            t =
                            e
                            .closest(
                                ".js-video-popup"
                                );
                        t && t
                            .swiper &&
                            (t.swiper
                                .isEnd ?
                                this
                                .videoModals
                                .forEach(
                                    a => {
                                        a.classList
                                            .contains(
                                                "active"
                                                ) &&
                                            this
                                            .closePopup(
                                                a
                                                )
                                    }
                                    ) :
                                t
                                .swiper
                                .slideNext()
                                ),
                            this
                            .videoNoSwiper &&
                            this
                            .videoModals
                            .forEach(
                                i => {
                                    i.classList
                                        .contains(
                                            "active"
                                            ) &&
                                        this
                                        .closePopup(
                                            i
                                            )
                                }
                                )
                    })
            })
    }
}
customElements.define("video-carousel",
    es);
class ts extends HTMLElement {
    constructor() {
        super(), this.topGap = 0,
            this.bottomGap = 0, this
            .currPos = window
            .scrollY, this
            .screenHeight = window
            .innerHeight, this
            .stickyElementHeight =
            0, this.endScroll = 0,
            this
            ._boundUpdateSticky =
            this.throttle(this
                .updateSticky.bind(
                    this), 200),
            this
            ._boundHandleResize =
            this.handleResize.bind(
                this)
    }
    connectedCallback() {
        this.initSidebar(), window
            .addEventListener(
                "scroll", this
                ._boundUpdateSticky, {
                    passive: !0
                }), window
            .addEventListener(
                "resize", this
                ._boundHandleResize
                ), this
            .updateSticky()
    }
    disconnectedCallback() {
        window.removeEventListener(
                "scroll", this
                ._boundUpdateSticky
                ), window
            .removeEventListener(
                "resize", this
                ._boundHandleResize)
    }
    initSidebar() {
        if (this.hasAttribute(
                "data-top-gap")) {
            const e = this
                .getAttribute(
                    "data-top-gap");
            this.topGap = parseInt(
                e, 10)
        } else this.topGap = 0;
        this.hasAttribute(
                "data-bottom-gap") ?
            this.bottomGap =
            parseInt(this
                .getAttribute(
                    "data-bottom-gap"
                    ), 10) : this
            .bottomGap = 0, this
            .style.top = this
            .topGap + "px", this
            .stickyElementHeight =
            this.offsetHeight
    }
    handleResize() {
        this.screenHeight = window
            .innerHeight, this
            .stickyElementHeight =
            this.offsetHeight, this
            .currPos = window
            .scrollY, this
            .updateSticky()
    }
    updateSticky() {
        this.screenHeight = window
            .innerHeight, this
            .stickyElementHeight =
            this.offsetHeight, this
            .positionStickySidebar()
    }
    positionStickySidebar() {
        this.endScroll = window
            .innerHeight - this
            .stickyElementHeight -
            this.bottomGap;
        let e = parseInt(this.style
                .top.replace("px",
                    ""), 10),
            t = this.currPos -
            window.scrollY,
            i;
        this.stickyElementHeight +
            this.topGap + this
            .bottomGap > this
            .screenHeight ? t > 0 ?
            i = Math.min(e + t, this
                .topGap) : i = Math
            .max(e + t, this
                .endScroll) : i =
            this.topGap, this.style
            .top = i + "px", this
            .currPos = window
            .scrollY
    }
    throttle(e, t) {
        let i = 0;
        return function(...a) {
            const o = Date
        .now();
            o - i >= t && (i =
                o, e.apply(
                    this, a)
                )
        }
    }
}
customElements.define("sticky-sidebar",
    ts);
class is extends HTMLElement {
    constructor() {
        super(), this
            .parentSection = this
            .closest(
                ".shopify-section"),
            this.tabClickedHandler =
            this.handleTabClicked
            .bind(this)
    }
    connectedCallback() {
        this.tabs = Array.from(this
                .querySelectorAll(
                    "[data-tab]")),
            this.contentEntries =
            Array.from(this
                .querySelectorAll(
                    "[data-content-entry]"
                    )), this.tabs
            .forEach(e => e
                .addEventListener(
                    "click", this
                    .tabClickedHandler
                    ))
    }
    handleTabClicked(e) {
        const t = e.currentTarget,
            i = t.dataset.bgColor,
            a = this.contentEntries
            .find(o => o.dataset
                .id === t.dataset.id
                );
        this.tabs.forEach(o => o
                .removeAttribute(
                    "data-active")),
            t.setAttribute(
                "data-active", ""),
            this.contentEntries
            .forEach(o => o
                .removeAttribute(
                    "data-active")),
            a.setAttribute(
                "data-active", ""),
            this.parentSection.style
            .setProperty(
                "--background", i)
    }
    disconnectedCallback() {
        this.tabs.forEach(e => e
            .removeEventListener(
                "click", this
                .tabClickedHandler
                ))
    }
}
customElements.define(
    "features-highlights", is);
class ss extends HTMLElement {
    constructor() {
        super(), this._input = this
            .querySelector("input")
    }
    connectedCallback() {
        this._updateMaskWidth(this
                ._input.value), this
            ._input
            .addEventListener(
                "input", this
                ._handleInput.bind(
                    this))
    }
    _handleInput() {
        this._updateMaskWidth(this
            ._input.value)
    }
    _updateMaskWidth(e) {
        this.style.setProperty(
            "--mask-width",
            `${e}%`)
    }
}
customElements.define("compare-images",
    ss);
class F extends HTMLElement {
    constructor() {
        super(), this
            .onActiveFilterClick =
            this.onActiveFilterClick
            .bind(this), this
            .onSubmitHandler = this
            .onSubmitHandler.bind(
                this);
        const e = this
            .querySelector("form");
        e == null || e
            .addEventListener(
                "change", t => {
                    t.preventDefault(),
                        this
                        .onSubmitHandler(
                            t)
                }), e == null || e
            .addEventListener(
                "submit", t => {
                    t.preventDefault(),
                        this
                        .onSubmitHandler(
                            t)
                })
    }
    static setListeners() {
        const e = t => {
            const i = t.state ?
                t.state
                .searchParams :
                F
                .searchParamsInitial;
            i !== F
                .searchParamsPrev &&
                F.renderPage(i,
                    null, !1)
        };
        window.addEventListener(
            "popstate", e)
    }
    static closeCurrentPopup() {
        const e = document
            .querySelector(
                "g-modal[aria-expanded='true']"
                );
        e && e.close()
    }
    static renderPage(e, t, i = !0) {
        F.searchParamsPrev = e, F
            .getSections().forEach(
                o => {
                    const h =
                        `${window.location.pathname}?section_id=${o.section}&${e}`,
                        w = p => p
                        .url === h;
                    F.filterData
                        .some(w) ? F
                        .renderSectionFromCache(
                            w, t) :
                        F
                        .renderSectionFromFetch(
                            h, t)
                }), i && F
            .updateURLHash(e)
    }
    static getSections() {
        return [{
            section: document
                .getElementById(
                    "ProductGridContainer"
                    )
                .dataset.id
        }]
    }
    static toggleLoading(e = !1) {
        const t = document
            .getElementById(
                "loadContainer"),
            i = document
            .querySelectorAll(
                "[data-facets-submit]"
                );
        t.setAttribute("aria-busy",
                e.toString()), i
            .forEach(o => {
                o.setAttribute(
                    "aria-busy",
                    e
                    .toString()
                    )
            });
        const a = new CustomEvent(
            "facet_updated");
        document.dispatchEvent(a)
    }
    static renderSectionFromFetch(e) {
        F.toggleLoading(!0), fetch(
            e).then(t => t
        .text()).then(t => {
            const i = t;
            F.filterData = [
                    ...F
                    .filterData,
                    {
                        html: i,
                        url: e
                    }
                ], F
                .updateFiltersHTML(
                    i), F
                .renderProductGridContainer(
                    i), F
                .renderProductCount(
                    i), F
                .toggleLoading(
                    !1), F
                .closeCurrentPopup()
        })
    }
    static renderSectionFromCache(e) {
        F.toggleLoading(!0);
        const t = F.filterData.find(
            e).html;
        F.updateFiltersHTML(t), F
            .renderProductGridContainer(
                t), F
            .renderProductCount(t),
            F.toggleLoading(!1), F
            .closeCurrentPopup()
    }
    static renderProductGridContainer(
    e) {
        document.getElementById(
                "ProductGridContainer"
                ).outerHTML =
            new DOMParser()
            .parseFromString(e,
                "text/html")
            .getElementById(
                "ProductGridContainer"
                ).outerHTML
    }
    static renderProductCount(e) {
        const t = new DOMParser()
            .parseFromString(e,
                "text/html")
            .getElementById(
                "ProductCount")
            .innerHTML,
            i = document
            .getElementById(
                "ProductCount");
        i.innerHTML = t
    }
    static updateFiltersHTML(e) {
        const t = new DOMParser()
            .parseFromString(e,
                "text/html");
        ["[data-filters-modal]",
            "[data-filters-aside]",
            "[data-filters-sort]",
            "[data-facets-remove]",
            "[data-filter-trigger]",
            "[data-filters-inline]"
        ].forEach(a => {
            const o = t
                .querySelectorAll(
                    a),
                h = document
                .querySelectorAll(
                    a);
            o.length !==
                0 && h
                .forEach((w,
                        p
                        ) => {
                        const
                            f =
                            o[
                                p];
                        if (
                            f) {
                            for (; w
                                .firstChild;
                                )
                                w
                                .removeChild(
                                    w
                                    .firstChild
                                    );
                            f.childNodes
                                .forEach(
                                    n => {
                                        w.appendChild(
                                            n
                                            .cloneNode(
                                                !
                                                0
                                                )
                                            )
                                    }
                                    )
                        }
                    })
        })
    }
    static updateFiltersHTML(e) {
        const t = new DOMParser()
            .parseFromString(e,
                "text/html");
        ["[data-filters-modal]",
            "[data-filters-aside]",
            "[data-filters-sort]",
            "[data-facets-remove]",
            "[data-filter-trigger]",
            "[data-filters-inline]"
        ].forEach(a => {
            const o = t
                .querySelectorAll(
                    a),
                h = document
                .querySelectorAll(
                    a);
            o.length ===
                0 || h
                .length ===
                0 || h
                .forEach(
                    w => {
                        o.forEach(
                            p => {
                                w.innerHTML =
                                    p
                                    .innerHTML
                            }
                            )
                    })
        })
    }
    static updateURLHash(e) {
        history.pushState({
                searchParams: e
            }, "",
            `${window.location.pathname}${e&&"?".concat(e)}`
            )
    }
    createSearchParams(e) {
        const t = new FormData(e),
            i = new FormData;
        for (const [a, o] of t
            .entries()) {
            const h = e
                .querySelector(
                    `[name="${a}"]`
                    );
            h && !h.classList
                .contains(
                    "js-accordion-input"
                    ) && i.append(a,
                    o)
        }
        return new URLSearchParams(
            i).toString()
    }
    onSubmitHandler(e) {
        if (e.preventDefault(), e
            .target.classList
            .contains(
                "js-accordion-input"
                )) return;
        const t = [],
            i = e.target.closest(
                "form");
        if (i && [
                "FacetFiltersFormModal"
            ].includes(i.id) && e
            .type === "change")
            return;
        document.querySelectorAll(
            "facet-filters-form form"
            ).forEach(o => {
            const h = (i ==
                    null ?
                    void 0 :
                    i.id
                    ) ===
                "FacetSortForm" ||
                (o == null ?
                    void 0 :
                    o.id
                    ) ===
                "FacetSortForm";
            ["FacetFiltersForm",
                "FacetSortForm",
                "FacetFiltersFormModal"
            ].includes(o
                .id) && (
                    o ===
                    i || h
                    ) && (t
                    .includes(
                        this
                        .createSearchParams(
                            o
                            )
                        ) ||
                    t.push(
                        this
                        .createSearchParams(
                            o
                            )
                        ))
        }), F.renderPage(t.join(
            "&"), e)
    }
    onActiveFilterClick(e) {
        e.preventDefault();
        const t = e.currentTarget
            .href.indexOf("?") == -
            1 ? "" : e.currentTarget
            .href.slice(e
                .currentTarget.href
                .indexOf("?") + 1);
        F.renderPage(t)
    }
}
F.filterData = [];
F.searchParamsInitial = window.location
    .search.slice(1);
F.searchParamsPrev = window.location
    .search.slice(1);
customElements.define(
    "facet-filters-form", F);
F.setListeners();
class rs extends HTMLElement {
    constructor() {
        super();
        const e = this
            .querySelector("a");
        e.setAttribute("role",
                "button"), e
            .addEventListener(
                "click", this
                .closeFilter.bind(
                    this)), e
            .addEventListener(
                "keyup", t => {
                    t.preventDefault(),
                        t.code
                        .toUpperCase() ===
                        "SPACE" &&
                        this
                        .closeFilter(
                            t)
                })
    }
    closeFilter(e) {
        e.preventDefault();
        const t = this.closest(
                "facet-filters-form"
                ) || document
            .querySelector(
                "facet-filters-form"
                );
        if (!t) {
            console.error(
                "Facet filter form not found!"
                );
            return
        }
        t.onActiveFilterClick(e)
    }
}
customElements.define(
    "facet-filters-remove", rs);
class as extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.min = Number(this
                .getAttribute("min")
                ) || 0, this.max =
            Number(this
                .getAttribute("max")
                ) || 100, this
            .from = Number(this
                .getAttribute(
                    "from")) || this
            .min, this.to = Number(
                this.getAttribute(
                    "to")) || this
            .max, this.gap = Number(
                this.getAttribute(
                    "gap")) || 5,
            this.fromSlider = this
            .querySelector(
                "#fromSlider"), this
            .toSlider = this
            .querySelector(
                "#toSlider"), this
            .fromInput = this
            .querySelector(
                "#fromInput"), this
            .toInput = this
            .querySelector(
                "#toInput"), this
            .outerFirstStartColor =
            "#ffffff", this
            .outerFirstEndColor =
            "#000000", this
            .innerFirstColor =
            "#000000", this
            .innerSecondColor =
            "#000000", this
            .outerSecondStartColor =
            "#000000", this
            .outerSecondEndColor =
            "#ffffff", this
            .fromSlider.min = this
            .min, this.fromSlider
            .max = this.max, this
            .fromSlider.value = this
            .from, this.toSlider
            .min = this.min, this
            .toSlider.max = this
            .max, this.toSlider
            .value = this.to, this
            .fromInput.min = this
            .min, this.fromInput
            .max = this.max, this
            .fromInput.value = this
            .from, this.toInput
            .min = this.min, this
            .toInput.max = this.max,
            this.toInput.value =
            this.to, this
            .fillSlider(), this
            .setToggleAccessible(),
            this.fromSlider
            .addEventListener(
                "input", () => this
                .controlFromSlider()
                ), this.toSlider
            .addEventListener(
                "input", () => this
                .controlToSlider()),
            this.fromInput
            .addEventListener(
                "input", () => {
                    this.controlFromInput(),
                        this
                        .dispatchNativeChange(
                            this
                            .fromInput
                            )
                }), this.toInput
            .addEventListener(
                "input", () => {
                    this.controlToInput(),
                        this
                        .dispatchNativeChange(
                            this
                            .toInput
                            )
                }), this.fromSlider
            .addEventListener(
                "change", () => {
                    this.controlFromSlider(),
                        this
                        .dispatchNativeChange(
                            this
                            .fromInput
                            )
                }), this.toSlider
            .addEventListener(
                "change", () => {
                    this.controlToSlider(),
                        this
                        .dispatchNativeChange(
                            this
                            .toInput
                            )
                })
    }
    controlFromSlider() {
        let e = parseInt(this
                .fromSlider.value,
                10),
            t = parseInt(this
                .toSlider.value, 10
                );
        e + this.gap > t && (e = t -
                this.gap, this
                .fromSlider.value =
                e), this.fromInput
            .value = e, this
            .fillSlider()
    }
    controlToSlider() {
        let e = parseInt(this
                .fromSlider.value,
                10),
            t = parseInt(this
                .toSlider.value, 10
                );
        e + this.gap > t && (t = e +
                this.gap, this
                .toSlider.value = t
                ), this.toInput
            .value = t, this
            .fillSlider(), this
            .setToggleAccessible()
    }
    controlFromInput() {
        let e = parseInt(this
                .fromInput.value, 10
                ),
            t = parseInt(this
                .toInput.value, 10);
        e < this.min && (e = this
                .min), e + this
            .gap > t && (e = t -
                this.gap), this
            .fromInput.value = e,
            this.fromSlider.value =
            e, this.fillSlider()
    }
    controlToInput() {
        let e = parseInt(this
                .fromInput.value, 10
                ),
            t = parseInt(this
                .toInput.value, 10);
        t > this.max && (t = this
                .max), t < e + this
            .gap && (t = e + this
                .gap), this.toInput
            .value = t, this
            .toSlider.value = t,
            this.fillSlider(), this
            .setToggleAccessible()
    }
    fillSlider() {
        const e = this.max - this
            .min,
            t = (this.fromSlider
                .value - this.min) /
            e * 100,
            i = (this.toSlider
                .value - this.min) /
            e * 100;
        this.toSlider.style
            .background = `linear-gradient(
      to right,
      ${this.outerFirstStartColor} 0%,
      ${this.outerFirstEndColor} ${t}%,
      ${this.innerFirstColor} ${t}%,
      ${this.innerSecondColor} ${i}%,
      ${this.outerSecondStartColor} ${i}%,
      ${this.outerSecondEndColor} 100%
    )`
    }
    setToggleAccessible() {
        Number(this.toInput
            .value) <= 0 ? this
            .toSlider.style.zIndex =
            2 : this.toSlider.style
            .zIndex = 0
    }
    dispatchNativeChange(e) {
        e.dispatchEvent(new Event(
            "change", {
                bubbles: !0
            }))
    }
}
customElements.define("range-slider",
    as);
const ns = "300px",
    os = 3;
class Nt extends HTMLElement {
    constructor() {
        var e;
        super(), this.nextPageUrl =
            (e = this.querySelector(
                "#load-more-link"
                )) == null ?
            void 0 : e.href, this
            .cachedPages = [], this
            .loadMoreBtn = this
            .querySelector(
                ".js-load-more-btn"
                ), this.loader =
            this.querySelector(
                ".js-toggle-load"),
            this.productList = this
            .querySelector(
                ".js-product-list"),
            this.fetching = !1, this
            .isCaching = !1, this
            .itemCountEl = document
            .querySelector(
                "#ProductCount .js-items-per-page"
                ), this
            ._createSentinel()
    }
    _createSentinel() {
        this._sentinel = document
            .createElement("div"),
            this._sentinel.style
            .position = "absolute",
            this._sentinel.style
            .bottom = "0", this
            ._sentinel.style.left =
            "0", this._sentinel
            .style.width = "100%",
            this._sentinel.style
            .height = "1px", this
            .productList.style
            .position = "relative",
            this.productList
            .appendChild(this
                ._sentinel)
    }
    connectedCallback() {
        this._connect()
    }
    _connect() {
        this.loadMoreBtn || this
            ._setupObserver(), this
            ._attachEventListeners(),
            this
            ._startBackgroundCaching()
    }
    _attachEventListeners() {
        this.loadMoreBtn && this
            .loadMoreBtn
            .addEventListener(
                "click",
        async () => {
                    await this
                        ._insertNextPage(),
                        this
                        .loadMoreBtn
                        .setAttribute(
                            "aria-busy",
                            "false"
                            )
                }), document
            .addEventListener(
                "facet_updated",
            () => {
                    var e;
                    this.cachedPages = [],
                        this
                        .nextPageUrl =
                        (e = this
                            .querySelector(
                                "#load-more-link"
                                )
                            ) ==
                        null ?
                        void 0 : e
                        .href, this
                        ._startBackgroundCaching()
                })
    }
    disconnectedCallback() {
        this._disconnect()
    }
    _disconnect() {
        this.observer && (this
                .observer
                .disconnect(), this
                .observer = null),
            this.loadMoreBtn && (
                this.loadMoreBtn
                .style.display =
                "none"), this
            ._sentinel && this
            ._sentinel.parentNode &&
            this._sentinel
            .parentNode.removeChild(
                this._sentinel)
    }
    _setupObserver() {
        this.observer =
            new IntersectionObserver(
                (e, t) => {
                    e.forEach(i => {
                        i.isIntersecting &&
                            this
                            ._insertNextPage()
                    })
                }, {
                    root: null,
                    rootMargin: `0px 0px ${ns} 0px`,
                    threshold: 0
                }), this.observer
            .observe(this._sentinel)
    }
    async _startBackgroundCaching() {
        if (this.caching || !this
            .nextPageUrl) return;
        this.caching = !0;
        const e = async () => {
            const t =
                await this
                ._fetchNextPage();
            if (t && this
                .cachedPages
                .push(t),
                this
                .cachedPages
                .length >=
                os || !this
                .nextPageUrl
                ) {
                this.caching = !
                    1;
                return
            }
            requestIdleCallback
                (e, {
                    timeout: 2e3
                })
        };
        requestIdleCallback(e, {
            timeout: 2e3
        })
    }
    async _fetchNextPage() {
        this.fetching = !0;
        try {
            const e = await fetch(
                this.nextPageUrl
                );
            if (!e.ok)
            throw new Error(
                    `HTTP error! status: ${e.status}`
                    );
            const t = await e
            .text(),
                a = new DOMParser()
                .parseFromString(t,
                    "text/html"),
                o = a.querySelector(
                    "#load-more-link"
                    );
            return this
                .nextPageUrl = o ? o
                .href : null, a
        } catch (e) {
            return console.error(
                "Error fetching next page:",
                e), null
        } finally {
            this.fetching = !1
        }
    }
    async _insertNextPage() {
        var i;
        for (this._setLoadingState(!
                0); this.fetching;)
            await new Promise(a =>
                setTimeout(a, 50));
        if (this.cachedPages
            .length === 0) {
            if (!this.nextPageUrl) {
                this._setLoadingState(
                    !1);
                return
            }
            const a = await this
                ._fetchNextPage();
            if (!a) {
                this._setLoadingState(
                    !1);
                return
            }
            this.cachedPages.push(a)
        }
        const e = this.cachedPages
            .shift();
        if (!e) {
            this._setLoadingState(!
                1);
            return
        }
        this.caching || this
            ._startBackgroundCaching();
        const t = (i = e
                .querySelector(
                    ".js-product-list"
                    )) == null ?
            void 0 : i.innerHTML;
        if (t && (this._sentinel
                .insertAdjacentHTML(
                    "beforebegin", t
                    ), this
                .itemCountEl)) {
            const a = parseInt(this
                    .itemCountEl
                    .textContent, 10
                    ) || 0,
                o = e
                .querySelectorAll(
                    ".js-product-list > *"
                    ).length;
            this.itemCountEl
                .textContent = a + o
        }!this.nextPageUrl && this
            .cachedPages.length ===
            0 && this._disconnect(),
            this._setLoadingState(!
                1)
    }
    _setLoadingState(e = !0) {
        this.loader.setAttribute(
            "aria-busy", e)
    }
}
mt(Nt, "fetchQueue", new Map);
customElements.define(
    "g-infinite-scroll", Nt);
class ls extends HTMLElement {
    constructor() {
        super(), this.optionInputs =
            this.querySelectorAll(
                ".js-options input"
                ), this.input = this
            .querySelector(
                'input[name="id"]'),
            this.atcBtn = this
            .querySelector(
                ".js-atc")
    }
    connectedCallback() {
        this.optionInputs.forEach(
            e => e
            .addEventListener(
                "change", () =>
                this
                .getSelectedVariant()
                ))
    }
    get variantsJson() {
        const e = this
            .querySelector(
                ".js-variants");
        return !this
            ._variantsJson && e && (
                this._variantsJson =
                JSON.parse(e
                    .innerHTML)),
            this._variantsJson
    }
    getSelectedVariant() {
        var i;
        const e = Array.from(this
                .optionInputs)
            .filter(a => a.checked)
            .map(a => a.value);
        let t = (i = Object.entries(
                    this
                    .variantsJson)
                .find(([a, o]) =>
                    JSON.stringify(o
                        .optionValues
                        ) === JSON
                    .stringify(e) &&
                    o.available)) ==
            null ? void 0 : i[0];
        t ? (this.input.value = t,
                this.atcBtn
                .disabled = !1) :
            this.atcBtn.disabled = !
            0
    }
}
customElements.define("product-card-v3",
    ls);
class cs extends HTMLElement {
    constructor() {
        super(), this.mobileVideo =
            this.querySelector(
                "#video-mobile-" +
                this._getSectionId()
                ), this
            .desktopVideo = this
            .querySelector(
                "#video-desktop-" +
                this._getSectionId()
                ), this.video = this
            ._getCurrentVideo(),
            this.togglePlayBtn =
            this.querySelector(
                ".js-toggle-play"),
            this.toggleSoundBtn =
            this.querySelector(
                ".js-toggle-sound"),
            this.videoLoaded = !1,
            this.currentBreakpoint =
            this._getBreakpoint(),
            this.isResizing = !1
    }
    connectedCallback() {
        this.mobileVideo && this
            .desktopVideo && this
            ._initializeVideos(),
            this.togglePlayBtn
            .addEventListener(
                "click", this
                .togglePlay.bind(
                    this)), this
            .toggleSoundBtn
            .addEventListener(
                "click", this
                .toggleSound.bind(
                    this)), this
            ._addVideoEventListeners(
                this.mobileVideo),
            this
            ._addVideoEventListeners(
                this.desktopVideo),
            window.addEventListener(
                "resize", this
                ._handleResize.bind(
                    this)), this
            ._setupIntersectionObserver()
    }
    disconnectedCallback() {
        this.observer && this
            .observer.disconnect(),
            window
            .removeEventListener(
                "resize", this
                ._handleResize.bind(
                    this))
    }
    _initializeVideos() {
        this.desktopVideo.muted = !
            0, this.desktopVideo
            .playsInline = !0, this
            .mobileVideo.muted = !0,
            this.mobileVideo
            .playsInline = !0, this
            .video = this
            ._getCurrentVideo(),
            this.videoLoaded = this
            .video.readyState >= 2
    }
    _addVideoEventListeners(e) {
        e && (e.addEventListener(
                "play", this
                ._updateToggleButton
                .bind(this)), e
            .addEventListener(
                "pause", this
                ._updateToggleButton
                .bind(this)), e
            .addEventListener(
                "loadeddata",
            () => {
                    e === this
                        .video &&
                        (this
                            .videoLoaded = !
                            0,
                            this
                            ._isInViewport() &&
                            this
                            .classList
                            .contains(
                                "autoplay"
                                ) &&
                            this
                            .video
                            .play()
                            )
                }))
    }
    _handleResize() {
        this.isResizing = !0, this
            .mobileVideo && !this
            .mobileVideo.paused &&
            this.mobileVideo
        .pause(), this
            .desktopVideo && !this
            .desktopVideo.paused &&
            this.desktopVideo
            .pause(), this
            ._updateToggleButton(),
            clearTimeout(this
                .resizeTimeout),
            this.resizeTimeout =
            setTimeout(() => {
                this._switchVideo(),
                    this
                    .isResizing = !
                    1
            }, 100)
    }
    togglePlay() {
        this.video = this
            ._getCurrentVideo(),
            this.video.paused ||
            this.video.ended ? (this
                ._ensureVideoLoaded(),
                this.video.play()) :
            this.video.pause()
    }
    toggleSound() {
        this.video = this
            ._getCurrentVideo(),
            this.video.muted = !this
            .video.muted, this
            ._updateSoundButton()
    }
    _updateToggleButton() {
        this.togglePlayBtn
            .setAttribute(
                "aria-checked", !
                this.video.paused)
    }
    _updateSoundButton() {
        this.toggleSoundBtn
            .setAttribute(
                "aria-checked", this
                .video.muted)
    }
    _isInViewport() {
        if (!this.video) return !1;
        const e = this.video
            .getBoundingClientRect();
        return e.top <= (window
                .innerHeight ||
                document
                .documentElement
                .clientHeight) && e
            .bottom >= 0
    }
    _getSectionId() {
        const e = this.closest(
            '[id^="shopify-section-"]'
            );
        return e ? e.id.replace(
            "shopify-section-",
            "") : ""
    }
    _getBreakpoint() {
        return window.innerWidth >=
            1024 ? "desktop" :
            "mobile"
    }
    _getCurrentVideo() {
        return this
        ._getBreakpoint() ===
            "desktop" ? this
            .desktopVideo : this
            .mobileVideo
    }
    _switchVideo() {
        const e = this
            ._getBreakpoint();
        if (e !== this
            .currentBreakpoint) {
            this.currentBreakpoint =
                e;
            const t = this.video;
            this.video = this
                ._getCurrentVideo(),
                t && this.video && (
                    this.video
                    .currentTime = t
                    .currentTime,
                    this.video
                    .muted = t
                    .muted, this
                    .video.pause()),
                this.videoLoaded =
                this.video
                .readyState >= 2,
                this
                ._updateToggleButton()
        }
    }
    _ensureVideoLoaded() {
        if (!this.videoLoaded) {
            const e = this.video
                .querySelectorAll(
                    "source[data-src]"
                    );
            e.length > 0 && (e
                .forEach(t => {
                    const
                        i =
                        t
                        .getAttribute(
                            "data-src"
                            );
                    i && !t
                        .hasAttribute(
                            "src"
                            ) &&
                        t
                        .setAttribute(
                            "src",
                            i
                            )
                }), this.video
                .load())
        }
    }
    _setupIntersectionObserver() {
        this.observer =
            new IntersectionObserver(
                e => {
                    e.forEach(t => {
                        (window
                            .innerWidth >
                            992 ||
                            this
                            .classList
                            .contains(
                                "autoplay-always"
                                )
                            ) &&
                        (t.isIntersecting ?
                            (this
                                .video =
                                this
                                ._getCurrentVideo(),
                                this
                                ._ensureVideoLoaded(),
                                this
                                .classList
                                .contains(
                                    "autoplay"
                                    ) &&
                                !
                                this
                                .isResizing &&
                                (this
                                    .videoLoaded ||
                                    this
                                    .video
                                    .readyState >=
                                    2
                                    ) &&
                                this
                                .video
                                .play()
                                ) :
                            this
                            .classList
                            .contains(
                                "autoplay"
                                ) &&
                            (this
                                .video =
                                this
                                ._getCurrentVideo(),
                                this
                                .video
                                .pause()
                                )
                            )
                    })
                }), this.observer
            .observe(this)
    }
}
customElements.define("video-player",
    cs);
ds();

function ds() {
    const u = document.querySelector(
        ".three-cards-main-block");
    if (!u) return;
    const e = u.querySelectorAll(
            ".card-item"),
        t = u.querySelector(
            "#how-to-title");
    gsap.to(t, {
        scale: 1,
        ease: "power2.out",
        scrollTrigger: {
            trigger: u,
            start: "top bottom",
            end: "bottom top",
            scrub: !0
        }
    }), ScrollTrigger.matchMedia({
        "(max-width: 767px)": function() {
            var h;
            const i = (h =
                    e[0]) ==
                null ?
                void 0 : h
                .offsetHeight,
                a = i /
                window
                .innerHeight,
                o = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: u,
                        start: "top top+=64",
                        end: "+=" +
                            e
                            .length *
                            i *
                            1.5,
                        scrub:
                            !
                            0,
                        pin: !
                            0
                    }
                });
            e.forEach((w,
                p) => {
                    p > 0 &&
                        w
                        .setAttribute(
                            "aria-hidden",
                            "true"
                            ),
                        o
                        .fromTo(
                            w, {
                                y: 1200,
                                scale: .8
                            }, {
                                y: 0,
                                opacity: 1,
                                scale: 1,
                                ease: "power3.out",
                                duration: a,
                                onStart: () => {
                                    p > 0 &&
                                        w
                                        .removeAttribute(
                                            "aria-hidden"
                                            )
                                }
                            },
                            p *
                            a
                            )
                })
        },
        "(min-width: 768px) and (max-width: 1023px)": function() {
            const i = e[0]
                .offsetHeight,
                a = i /
                window
                .innerHeight,
                o = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: u,
                        start: "top top+=104",
                        end: "+=" +
                            e
                            .length *
                            i *
                            1.5,
                        scrub:
                            !
                            0,
                        pin: !
                            0
                    }
                });
            e.forEach((h,
                w) => {
                    w > 0 &&
                        h
                        .setAttribute(
                            "aria-hidden",
                            "true"
                            ),
                        o
                        .fromTo(
                            h, {
                                y: 1200,
                                scale: .8
                            }, {
                                y: 0,
                                opacity: 1,
                                scale: 1,
                                ease: "power3.out",
                                duration: a,
                                onStart: () => {
                                    w > 0 &&
                                        h
                                        .removeAttribute(
                                            "aria-hidden"
                                            )
                                }
                            },
                            w *
                            a
                            )
                })
        },
        "(min-width: 1024px)": function() {
            const i = e[0]
                .offsetHeight,
                a = i /
                window
                .innerHeight,
                o = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: u,
                        start: "top top",
                        end: "+=" +
                            e
                            .length *
                            i *
                            1.5,
                        scrub:
                            !
                            0,
                        pin: !
                            0
                    }
                });
            e.forEach((h,
                w) => {
                    w > 0 &&
                        h
                        .setAttribute(
                            "aria-hidden",
                            "true"
                            ),
                        o
                        .fromTo(
                            h, {
                                y: 800,
                                scale: .8
                            }, {
                                y: 0,
                                opacity: 1,
                                scale: 1,
                                ease: "power3.out",
                                duration: a,
                                onStart: () => {
                                    w > 0 &&
                                        h
                                        .removeAttribute(
                                            "aria-hidden"
                                            )
                                }
                            },
                            w *
                            a
                            )
                })
        }
    })
}
Di();
class ps {
    constructor() {
        this.animatedElements =
            new Set, this.observer =
            null, this.init()
    }
    init() {
        this.observer =
            new IntersectionObserver(
                e => this
                .handleIntersection(
                    e), {
                    root: null,
                    rootMargin: "50px 0px -50px 0px",
                    threshold: .1
                }), this
            .observeElements()
    }
    observeElements() {
        document.querySelectorAll(
                ".gsap-bounce-down")
            .forEach(e => {
                this.observer
                    .observe(e)
            }), document
            .querySelectorAll(
                ".gsap-slide-down")
            .forEach(e => {
                this.observer
                    .observe(e)
            }), document
            .querySelectorAll(
                ".gsap-zoom-in")
            .forEach(e => {
                this.observer
                    .observe(e)
            }), document
            .querySelectorAll(
                ".gsap-rotate-right"
                ).forEach(e => {
                this.observer
                    .observe(e)
            }), document
            .querySelectorAll(
                ".faq-swiper .swiper-slide"
                ).forEach(e => {
                this.observer
                    .observe(e)
            }), document
            .querySelectorAll(
                ".stores-swiper .swiper-slide"
                ).forEach(e => {
                this.observer
                    .observe(e)
            })
    }
    handleIntersection(e) {
        e.forEach(t => {
            t.isIntersecting &&
                !this
                .animatedElements
                .has(t
                    .target
                    ) && (
                    this
                    .animateElement(
                        t
                        .target
                        ),
                    this
                    .animatedElements
                    .add(t
                        .target
                        ),
                    this
                    .observer
                    .unobserve(
                        t
                        .target
                        ))
        })
    }
    animateElement(e) {
        const t = e.closest(
            "section");
        if (e.classList.contains(
                "gsap-bounce-down"))
            gsap.from(e, {
                scrollTrigger: {
                    trigger: t,
                    start: "top center",
                    toggleActions: "play none none none"
                },
                y: -50,
                opacity: 0,
                duration: 1.2,
                ease: "bounce.out"
            });
        else if (e.classList
            .contains(
                "gsap-slide-down"))
            gsap.from(e, {
                scrollTrigger: {
                    trigger: t,
                    start: "top center",
                    toggleActions: "play none none none"
                },
                y: -50,
                opacity: 0,
                duration: 1.2,
                ease: "power2.In"
            });
        else if (e.classList
            .contains(
                "gsap-zoom-in"))
            gsap.fromTo(e, {
                opacity: 0,
                scale: .5
            }, {
                scrollTrigger: {
                    trigger: t,
                    start: "top center",
                    toggleActions: "play none none none"
                },
                scale: 1,
                opacity: 1,
                duration: 1.2,
                ease: "zoomIn"
            });
        else if (e.classList
            .contains(
                "gsap-rotate-right")
            ) gsap.from(e, {
            scrollTrigger: {
                trigger: t,
                start: "top center",
                toggleActions: "play none none none"
            },
            rotate: -20,
            duration: 1.2,
            ease: "rotate"
        });
        else if (e.closest(
                ".faq-swiper")) {
            const i = e.closest(
                    ".faq-swiper"),
                o = Array.from(i
                    .querySelectorAll(
                        ".swiper-slide"
                        )).indexOf(
                    e);
            if (this
                .animateDesktopOnly()
                ) {
                gsap.from(e, {
                    scrollTrigger: {
                        trigger: t,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    },
                    y: 60,
                    opacity: 0,
                    scale: .9,
                    duration: .8,
                    delay: o *
                        .15,
                    ease: "power2.out"
                });
                const h = e
                    .querySelector(
                        ".flip-card-inner"
                        );
                h && gsap.set(h, {
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden"
                })
            }
        } else if (e.closest(
                ".stores-swiper")) {
            const i = e.closest(
                    ".stores-swiper"
                    ),
                o = Array.from(i
                    .querySelectorAll(
                        ".swiper-slide"
                        )).indexOf(
                    e);
            if (this
                .animateDesktopOnly()
                ) {
                gsap.from(e, {
                    scrollTrigger: {
                        trigger: t,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    },
                    y: 60,
                    opacity: 0,
                    scale: .9,
                    duration: .8,
                    delay: o *
                        .15,
                    ease: "power2.out"
                });
                const h = e
                    .querySelector(
                        ".stores-swiper-item"
                        );
                h && gsap.set(h, {
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden"
                })
            }
        }
    }
    refresh() {
        this.observeElements()
    }
    animateDesktopOnly() {
        return window.innerWidth >=
            1024
    }
    destroy() {
        this.observer && this
            .observer.disconnect()
    }
}
const Xt = new ps;
document.addEventListener(
    "DOMContentLoaded", () => {
        Xt.refresh()
    });
window.addEventListener("resize",
() => {
    Xt.refresh()
});